
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5apVM", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $; });
$parcel$export(module.exports, "addClass", function () { return addClass; });
$parcel$export(module.exports, "removeClass", function () { return removeClass; });
$parcel$export(module.exports, "toggleClass", function () { return toggleClass; });
$parcel$export(module.exports, "hasClass", function () { return hasClass; });
$parcel$export(module.exports, "attr", function () { return attr; });
$parcel$export(module.exports, "removeAttr", function () { return removeAttr; });
$parcel$export(module.exports, "transform", function () { return transform; });
$parcel$export(module.exports, "transition", function () { return transition; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "off", function () { return off; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "transitionEnd", function () { return transitionEnd; });
$parcel$export(module.exports, "outerWidth", function () { return outerWidth; });
$parcel$export(module.exports, "outerHeight", function () { return outerHeight; });
$parcel$export(module.exports, "offset", function () { return offset; });
$parcel$export(module.exports, "styles", function () { return styles; });
$parcel$export(module.exports, "css", function () { return css; });
$parcel$export(module.exports, "each", function () { return each; });
$parcel$export(module.exports, "filter", function () { return filter; });
$parcel$export(module.exports, "html", function () { return html; });
$parcel$export(module.exports, "text", function () { return text; });
$parcel$export(module.exports, "is", function () { return is; });
$parcel$export(module.exports, "index", function () { return index; });
$parcel$export(module.exports, "eq", function () { return eq; });
$parcel$export(module.exports, "append", function () { return append; });
$parcel$export(module.exports, "prepend", function () { return prepend; });
$parcel$export(module.exports, "next", function () { return next; });
$parcel$export(module.exports, "nextAll", function () { return nextAll; });
$parcel$export(module.exports, "prev", function () { return prev; });
$parcel$export(module.exports, "prevAll", function () { return prevAll; });
$parcel$export(module.exports, "parent", function () { return parent; });
$parcel$export(module.exports, "parents", function () { return parents; });
$parcel$export(module.exports, "closest", function () { return closest; });
$parcel$export(module.exports, "find", function () { return find; });
$parcel$export(module.exports, "children", function () { return children; });
$parcel$export(module.exports, "remove", function () { return remove; });
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $4acFp = parcelRequire("4acFp");
/* eslint-disable no-proto */ function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class Dom7 extends Array {
    constructor(items){
        if (typeof items === 'number') super(items);
        else {
            super(...items || []);
            makeReactive(this);
        }
    }
}
function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== 'string') return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    const window = (0, $4acFp.getWindow)();
    const document = (0, $4acFp.getDocument)();
    let arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === 'string') {
        const html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            let toCreate = 'div';
            if (html.indexOf('<li') === 0) toCreate = 'ul';
            if (html.indexOf('<tr') === 0) toCreate = 'tbody';
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
            if (html.indexOf('<tbody') === 0) toCreate = 'table';
            if (html.indexOf('<option') === 0) toCreate = 'select';
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    return arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === 'string') {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    let el;
    if (typeof value === 'undefined') {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf('data-') >= 0) dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === 'false') dataset[key] = false;
        else if (dataset[key] === 'true') dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === 'undefined') {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === 'select') {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
    return this;
}
function on(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(' ');
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(' ');
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
    const window = (0, $4acFp.getWindow)();
    const events = args[0].split(' ');
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionstart', fireCallBack);
    }
    if (callback) dom.on('transitionstart', fireCallBack);
    return this;
}
function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
    }
    if (callback) dom.on('transitionend', fireCallBack);
    return this;
}
function animationEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('animationend', fireCallBack);
    }
    if (callback) dom.on('animationend', fireCallBack);
    return this;
}
function width() {
    const window = (0, $4acFp.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css('width'));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    const window = (0, $4acFp.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css('height'));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        const window = (0, $4acFp.getWindow)();
        const document = (0, $4acFp.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = 'none';
    return this;
}
function show() {
    const window = (0, $4acFp.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === 'none') el.style.display = '';
        if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') // Still not visible
        el.style.display = 'block';
    }
    return this;
}
function styles() {
    const window = (0, $4acFp.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    const window = (0, $4acFp.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === 'string') {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    const result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === 'undefined') return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === 'undefined') return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    const window = (0, $4acFp.getWindow)();
    const document = (0, $4acFp.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === 'undefined') return this;
    const length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append(...els) {
    let newChild;
    const document = (0, $4acFp.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === 'string') {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    const document = (0, $4acFp.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === 'string') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    const before = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    const after = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = '';
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo(...args) {
    const window = (0, $4acFp.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === 'function') {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === 'undefined') easing = 'swing';
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === 'undefined') easing = 'swing';
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === 'undefined') {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === 'undefined') {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    const window = (0, $4acFp.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: 'swing' // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === 'swing') return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === 'function') return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, '');
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue, finalValue, unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === 'stop') animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const noTrigger = 'resize scroll'.split(' ');
function shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === 'undefined') {
            for(let i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const click = shortcut('click');
const blur = shortcut('blur');
const focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const scroll = shortcut('scroll');
var $3c320048fa76b910$export$2e2bcd8739ae039 = $;

});
parcelRegister("4acFp", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $3081ebf44248f949$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getWindow", function () { return $3081ebf44248f949$export$38b2d434cce3ea22; });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $3081ebf44248f949$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $3081ebf44248f949$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($3081ebf44248f949$var$isObject(src[key]) && $3081ebf44248f949$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $3081ebf44248f949$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $3081ebf44248f949$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $3081ebf44248f949$export$f65ca476c09acec0() {
    const doc = typeof document !== 'undefined' ? document : {};
    $3081ebf44248f949$export$8b58be045bf06082(doc, $3081ebf44248f949$export$3fdcb9b4d81368d8);
    return doc;
}
const $3081ebf44248f949$export$8582633f185c62bb = {
    document: $3081ebf44248f949$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $3081ebf44248f949$export$38b2d434cce3ea22() {
    const win = typeof window !== 'undefined' ? window : {};
    $3081ebf44248f949$export$8b58be045bf06082(win, $3081ebf44248f949$export$8582633f185c62bb);
    return win;
}

});


var $2b1a091b652cef0d$exports = {};
!function(e, t) {
    $2b1a091b652cef0d$exports = t();
}($2b1a091b652cef0d$exports, function() {
    "use strict";
    var e = "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {}, t = "Expected a function", n = NaN, o = "[object Symbol]", i = /^\s+|\s+$/g, a = /^[-+]0x[0-9a-f]+$/i, r = /^0b[01]+$/i, c = /^0o[0-7]+$/i, s = parseInt, u = "object" == typeof e && e && e.Object === Object && e, d = "object" == typeof self && self && self.Object === Object && self, l = u || d || Function("return this")(), f = Object.prototype.toString, m = Math.max, p = Math.min, b = function() {
        return l.Date.now();
    };
    function v(e, n, o) {
        var i, a, r, c, s, u, d = 0, l = !1, f = !1, v = !0;
        if ("function" != typeof e) throw new TypeError(t);
        function y(t) {
            var n = i, o = a;
            return i = a = void 0, d = t, c = e.apply(o, n);
        }
        function h(e) {
            var t = e - u;
            return void 0 === u || t >= n || t < 0 || f && e - d >= r;
        }
        function k() {
            var e = b();
            if (h(e)) return x(e);
            s = setTimeout(k, function(e) {
                var t = n - (e - u);
                return f ? p(t, r - (e - d)) : t;
            }(e));
        }
        function x(e) {
            return s = void 0, v && i ? y(e) : (i = a = void 0, c);
        }
        function O() {
            var e = b(), t = h(e);
            if (i = arguments, a = this, u = e, t) {
                if (void 0 === s) return function(e) {
                    return d = e, s = setTimeout(k, n), l ? y(e) : c;
                }(u);
                if (f) return s = setTimeout(k, n), y(u);
            }
            return void 0 === s && (s = setTimeout(k, n)), c;
        }
        return n = w(n) || 0, g(o) && (l = !!o.leading, r = (f = "maxWait" in o) ? m(w(o.maxWait) || 0, n) : r, v = "trailing" in o ? !!o.trailing : v), O.cancel = function() {
            void 0 !== s && clearTimeout(s), d = 0, i = u = a = s = void 0;
        }, O.flush = function() {
            return void 0 === s ? c : x(b());
        }, O;
    }
    function g(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
    }
    function w(e) {
        if ("number" == typeof e) return e;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                return !!e && "object" == typeof e;
            }(e) && f.call(e) == o;
        }(e)) return n;
        if (g(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = g(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(i, "");
        var u = r.test(e);
        return u || c.test(e) ? s(e.slice(2), u ? 2 : 8) : a.test(e) ? n : +e;
    }
    var y = function(e, n, o) {
        var i = !0, a = !0;
        if ("function" != typeof e) throw new TypeError(t);
        return g(o) && (i = "leading" in o ? !!o.leading : i, a = "trailing" in o ? !!o.trailing : a), v(e, n, {
            leading: i,
            maxWait: n,
            trailing: a
        });
    }, h = "Expected a function", k = NaN, x = "[object Symbol]", O = /^\s+|\s+$/g, j = /^[-+]0x[0-9a-f]+$/i, E = /^0b[01]+$/i, N = /^0o[0-7]+$/i, z = parseInt, C = "object" == typeof e && e && e.Object === Object && e, A = "object" == typeof self && self && self.Object === Object && self, q = C || A || Function("return this")(), L = Object.prototype.toString, T = Math.max, M = Math.min, S = function() {
        return q.Date.now();
    };
    function D(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
    }
    function H(e) {
        if ("number" == typeof e) return e;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                return !!e && "object" == typeof e;
            }(e) && L.call(e) == x;
        }(e)) return k;
        if (D(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = D(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(O, "");
        var n = E.test(e);
        return n || N.test(e) ? z(e.slice(2), n ? 2 : 8) : j.test(e) ? k : +e;
    }
    var $ = function(e, t, n) {
        var o, i, a, r, c, s, u = 0, d = !1, l = !1, f = !0;
        if ("function" != typeof e) throw new TypeError(h);
        function m(t) {
            var n = o, a = i;
            return o = i = void 0, u = t, r = e.apply(a, n);
        }
        function p(e) {
            var n = e - s;
            return void 0 === s || n >= t || n < 0 || l && e - u >= a;
        }
        function b() {
            var e = S();
            if (p(e)) return v(e);
            c = setTimeout(b, function(e) {
                var n = t - (e - s);
                return l ? M(n, a - (e - u)) : n;
            }(e));
        }
        function v(e) {
            return c = void 0, f && o ? m(e) : (o = i = void 0, r);
        }
        function g() {
            var e = S(), n = p(e);
            if (o = arguments, i = this, s = e, n) {
                if (void 0 === c) return function(e) {
                    return u = e, c = setTimeout(b, t), d ? m(e) : r;
                }(s);
                if (l) return c = setTimeout(b, t), m(s);
            }
            return void 0 === c && (c = setTimeout(b, t)), r;
        }
        return t = H(t) || 0, D(n) && (d = !!n.leading, a = (l = "maxWait" in n) ? T(H(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f), g.cancel = function() {
            void 0 !== c && clearTimeout(c), u = 0, o = s = i = c = void 0;
        }, g.flush = function() {
            return void 0 === c ? r : v(S());
        }, g;
    }, W = function() {};
    function P(e) {
        e && e.forEach(function(e) {
            var t = Array.prototype.slice.call(e.addedNodes), n = Array.prototype.slice.call(e.removedNodes);
            if (function e(t) {
                var n = void 0, o = void 0;
                for(n = 0; n < t.length; n += 1){
                    if ((o = t[n]).dataset && o.dataset.aos) return !0;
                    if (o.children && e(o.children)) return !0;
                }
                return !1;
            }(t.concat(n))) return W();
        });
    }
    function Y() {
        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    var _ = {
        isSupported: function() {
            return !!Y();
        },
        ready: function(e, t) {
            var n = window.document, o = new (Y())(P);
            W = t, o.observe(n.documentElement, {
                childList: !0,
                subtree: !0,
                removedNodes: !0
            });
        }
    }, B = function(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }, F = function() {
        function e(e, t) {
            for(var n = 0; n < t.length; n++){
                var o = t[n];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
            }
        }
        return function(t, n, o) {
            return n && e(t.prototype, n), o && e(t, o), t;
        };
    }(), I = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
        return e;
    }, K = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i, G = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, J = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i, Q = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
    function R() {
        return navigator.userAgent || navigator.vendor || window.opera || "";
    }
    var U = new (function() {
        function e() {
            B(this, e);
        }
        return F(e, [
            {
                key: "phone",
                value: function() {
                    var e = R();
                    return !(!K.test(e) && !G.test(e.substr(0, 4)));
                }
            },
            {
                key: "mobile",
                value: function() {
                    var e = R();
                    return !(!J.test(e) && !Q.test(e.substr(0, 4)));
                }
            },
            {
                key: "tablet",
                value: function() {
                    return this.mobile() && !this.phone();
                }
            },
            {
                key: "ie11",
                value: function() {
                    return "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style;
                }
            }
        ]), e;
    }()), V = function(e, t) {
        var n = void 0;
        return U.ie11() ? (n = document.createEvent("CustomEvent")).initCustomEvent(e, !0, !0, {
            detail: t
        }) : n = new CustomEvent(e, {
            detail: t
        }), document.dispatchEvent(n);
    }, X = function(e) {
        return e.forEach(function(e, t) {
            return function(e, t) {
                var n = e.options, o = e.position, i = e.node, a = (e.data, function() {
                    e.animated && (function(e, t) {
                        t && t.forEach(function(t) {
                            return e.classList.remove(t);
                        });
                    }(i, n.animatedClassNames), V("aos:out", i), e.options.id && V("aos:in:" + e.options.id, i), e.animated = !1);
                });
                n.mirror && t >= o.out && !n.once ? a() : t >= o.in ? e.animated || (function(e, t) {
                    t && t.forEach(function(t) {
                        return e.classList.add(t);
                    });
                }(i, n.animatedClassNames), V("aos:in", i), e.options.id && V("aos:in:" + e.options.id, i), e.animated = !0) : e.animated && !n.once && a();
            }(e, window.pageYOffset);
        });
    }, Z = function(e) {
        for(var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);)t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
        return {
            top: n,
            left: t
        };
    }, ee = function(e, t, n) {
        var o = e.getAttribute("data-aos-" + t);
        if (void 0 !== o) {
            if ("true" === o) return !0;
            if ("false" === o) return !1;
        }
        return o || n;
    }, te = function(e, t) {
        return e.forEach(function(e, n) {
            var o = ee(e.node, "mirror", t.mirror), i = ee(e.node, "once", t.once), a = ee(e.node, "id"), r = t.useClassNames && e.node.getAttribute("data-aos"), c = [
                t.animatedClassName
            ].concat(r ? r.split(" ") : []).filter(function(e) {
                return "string" == typeof e;
            });
            t.initClassName && e.node.classList.add(t.initClassName), e.position = {
                in: function(e, t, n) {
                    var o = window.innerHeight, i = ee(e, "anchor"), a = ee(e, "anchor-placement"), r = Number(ee(e, "offset", a ? 0 : t)), c = a || n, s = e;
                    i && document.querySelectorAll(i) && (s = document.querySelectorAll(i)[0]);
                    var u = Z(s).top - o;
                    switch(c){
                        case "top-bottom":
                            break;
                        case "center-bottom":
                            u += s.offsetHeight / 2;
                            break;
                        case "bottom-bottom":
                            u += s.offsetHeight;
                            break;
                        case "top-center":
                            u += o / 2;
                            break;
                        case "center-center":
                            u += o / 2 + s.offsetHeight / 2;
                            break;
                        case "bottom-center":
                            u += o / 2 + s.offsetHeight;
                            break;
                        case "top-top":
                            u += o;
                            break;
                        case "bottom-top":
                            u += o + s.offsetHeight;
                            break;
                        case "center-top":
                            u += o + s.offsetHeight / 2;
                    }
                    return u + r;
                }(e.node, t.offset, t.anchorPlacement),
                out: o && function(e, t) {
                    window.innerHeight;
                    var n = ee(e, "anchor"), o = ee(e, "offset", t), i = e;
                    return n && document.querySelectorAll(n) && (i = document.querySelectorAll(n)[0]), Z(i).top + i.offsetHeight - o;
                }(e.node, t.offset)
            }, e.options = {
                once: i,
                mirror: o,
                animatedClassNames: c,
                id: a
            };
        }), e;
    }, ne = function() {
        var e = document.querySelectorAll("[data-aos]");
        return Array.prototype.map.call(e, function(e) {
            return {
                node: e
            };
        });
    }, oe = [], ie = !1, ae = {
        offset: 120,
        delay: 0,
        easing: "ease",
        duration: 400,
        disable: !1,
        once: !1,
        mirror: !1,
        anchorPlacement: "top-bottom",
        startEvent: "DOMContentLoaded",
        animatedClassName: "aos-animate",
        initClassName: "aos-init",
        useClassNames: !1,
        disableMutationObserver: !1,
        throttleDelay: 99,
        debounceDelay: 50
    }, re = function() {
        return document.all && !window.atob;
    }, ce = function() {
        arguments.length > 0 && void 0 !== arguments[0] && arguments[0] && (ie = !0), ie && (oe = te(oe, ae), X(oe), window.addEventListener("scroll", y(function() {
            X(oe, ae.once);
        }, ae.throttleDelay)));
    }, se = function() {
        if (oe = ne(), de(ae.disable) || re()) return ue();
        ce();
    }, ue = function() {
        oe.forEach(function(e, t) {
            e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay"), ae.initClassName && e.node.classList.remove(ae.initClassName), ae.animatedClassName && e.node.classList.remove(ae.animatedClassName);
        });
    }, de = function(e) {
        return !0 === e || "mobile" === e && U.mobile() || "phone" === e && U.phone() || "tablet" === e && U.tablet() || "function" == typeof e && !0 === e();
    };
    return {
        init: function(e) {
            return ae = I(ae, e), oe = ne(), ae.disableMutationObserver || _.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), ae.disableMutationObserver = !0), ae.disableMutationObserver || _.ready("[data-aos]", se), de(ae.disable) || re() ? ue() : (document.querySelector("body").setAttribute("data-aos-easing", ae.easing), document.querySelector("body").setAttribute("data-aos-duration", ae.duration), document.querySelector("body").setAttribute("data-aos-delay", ae.delay), -1 === [
                "DOMContentLoaded",
                "load"
            ].indexOf(ae.startEvent) ? document.addEventListener(ae.startEvent, function() {
                ce(!0);
            }) : window.addEventListener("load", function() {
                ce(!0);
            }), "DOMContentLoaded" === ae.startEvent && [
                "complete",
                "interactive"
            ].indexOf(document.readyState) > -1 && ce(!0), window.addEventListener("resize", $(ce, ae.debounceDelay, !0)), window.addEventListener("orientationchange", $(ce, ae.debounceDelay, !0)), oe);
        },
        refresh: ce,
        refreshHard: se
    };
});


// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const $28c15c8b5c5906e8$var$vhUtils = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${$28c15c8b5c5906e8$var$vhUtils}px`);
// We listen to the resize event
window.addEventListener('resize', ()=>{
    // We execute the same script as before
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});


var $d0178846fa869d5e$exports = {};
/** @type {import('tailwindcss').Config} */ $d0178846fa869d5e$exports = {
    important: true,
    content: [
        './app/modules/**/*.php',
        '!./app/modules/**/system/**',
        './app/layout/**/*.php',
        './app/layout/**/**/*.php',
        './app/public/js/*.js',
        './src/js/**/*.js',
        './src/js/*.js',
        './src-panel/js/**/*.js',
        './src-panel/js/*.js',
        './src-shop/js/**/*.js',
        './src-shop/js/*.js'
    ],
    theme: {
        screens: {
            xs: '360px',
            // => @media (min-width: 360px) { ... }
            sm: '640px',
            // => @media (min-width: 640px) { ... }
            md: '768px',
            // => @media (min-width: 768px) { ... }
            lg: '1024px',
            // => @media (min-width: 1024px) { ... }
            xl: '1280px',
            // => @media (min-width: 1280px) { ... }
            '2xl': '1536px',
            // => @media (min-width: 1536px) { ... }
            '3xl': '1800px'
        },
        extend: {
            colors: {
                transparent: 'transparent',
                current: 'currentColor'
            }
        }
    },
    plugins: [],
    safelist: [
        'w-full',
        'hidden',
        'sr-only',
        {
            pattern: /^grid-cols-/
        },
        {
            pattern: /^col-span-/
        },
        {
            pattern: /^flex-/
        },
        {
            pattern: /^grid-/
        },
        {
            pattern: /^justify-/
        },
        {
            pattern: /^items-/
        },
        {
            pattern: /^ml-/
        },
        {
            pattern: /^mr-/
        },
        {
            pattern: /^mb-/
        }
    ]
}; /*Classes:
w-full - width: 100%;
hidden - display: none;
sr-only - hides visually, screen reader accessible;

flex - display: flex;
flex-wrap - flex-wrap: wrap;
justify-start - justify-content: flex-start;
justify-center - justify-content: center;
justify-end - justify-content: flex-end;
justify-between - justify-content: flex-between;
items-start - alight-items: flex-start;
items-center - alight-items: center;
items-end - alight-items: flex-end;
items-between - alight-items: flex-between;

grid - display: grid;
grid-cols-8 (1–8) – sets the parent to 8 grid columns.
col-span-8 (1–8) – makes the child span 8 columns.
col-span-full - makes the child span all columns.
* */ 


function $5c2065aa5c493538$export$74b8f1741b4483c3(options = {}) {
    const defaultOptions = {
        animateOnce: true,
        speed: 500,
        threshold: 0.35,
        delay: 0,
        easing: 'ease',
        disableMutationObserver: false,
        breakpoints: {}
    };
    // Export breakpoints from tailwind
    if (Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($d0178846fa869d5e$exports))).theme.screens).length) defaultOptions.breakpoints = (0, (/*@__PURE__*/$parcel$interopDefault($d0178846fa869d5e$exports))).theme.screens;
    const { breakpoints: breakpoints } = defaultOptions;
    const mergedBreakpoints = Object.assign(breakpoints, options.breakpoints);
    const mainOptions = Object.assign(defaultOptions, options);
    mainOptions.breakpoints = mergedBreakpoints;
    /* --- Set global properties --- */ function setGlobalProperty(name, value, isTimeUnit) {
        if (isTimeUnit) value += 'ms';
        document.documentElement.style.setProperty(`--view-${name}`, `${value}`);
    }
    const { speed: speed, easing: easing } = mainOptions;
    setGlobalProperty('speed', speed, true);
    setGlobalProperty('easing', easing);
    // Function to get the appropriate threshold based on screen size
    function getThreshold(element) {
        const dataset = element.dataset;
        // Check for mobile threshold and desktop threshold
        const desktopThreshold = dataset.viewThreshold ? parseFloat(dataset.viewThreshold) : mainOptions.threshold;
        const mobileThreshold = dataset.viewThresholdMobile ? parseFloat(dataset.viewThresholdMobile) : desktopThreshold;
        // If screen width is less than 768px, return mobile threshold, else desktop threshold
        return window.innerWidth < 768 ? mobileThreshold : desktopThreshold;
    }
    // Function to observe element with individual threshold
    // Function to observe element with individual threshold
    function observeElement(element) {
        const threshold = getThreshold(element);
        // Create a new IntersectionObserver with the calculated threshold
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                // Show element when it meets the threshold
                if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
                    const delay = entry.target.dataset.viewDelay ? parseInt(entry.target.dataset.viewDelay, 10) : 0;
                    if (delay > 0) setTimeout(()=>{
                        entry.target.classList.add('animated');
                    }, delay);
                    else entry.target.classList.add('animated');
                } else if (!entry.isIntersecting && !mainOptions.animateOnce) entry.target.classList.remove('animated');
            });
        }, {
            threshold: threshold
        });
        // Start observing the element
        observer.observe(element);
    }
    // Function to handle elements with disable-on-mobile option
    function intersectElement(element, isMutation = false) {
        element.classList.add('in-view');
        const dataset = element.dataset;
        // Check for mobile disable and handle it
        if (dataset.viewDisableMobile === "true" && window.innerWidth < 768) {
            element.classList.add('animated'); // Activate immediately on mobile
            return; // Stop further processing for this element
        }
        // Set speed and easing to current element
        if (dataset.viewSpeed) element.style.transitionDuration = `${dataset.viewSpeed}ms`;
        if (dataset.viewEasing) element.style.transitionTimingFunction = dataset.viewEasing;
        // Delay observer if viewDelay is specified
        if (dataset.viewDelay) setTimeout(()=>observeElement(element), dataset.viewDelay);
        else observeElement(element);
    }
    // Find all elements with data-view attribute and observe them
    const targetElements = document.querySelectorAll('[data-view]');
    if (targetElements.length) targetElements.forEach((target)=>intersectElement(target));
    /* --- Intersect dynamically added elements in DOM --- */ if (!mainOptions.disableMutationObserver) {
        // Callback function to handle the mutations
        const handleMutations = function(mutationsList) {
            for (const mutation of mutationsList)if (mutation.addedNodes.length) {
                // Check if any added node has the desired dataset
                const addedNodes = mutation.addedNodes;
                addedNodes.forEach((target)=>{
                    if (target.dataset && 'view' in target.dataset) intersectElement(target, true);
                });
            }
        };
        // Create a MutationObserver instance
        const mutationObserver = new MutationObserver(handleMutations);
        const mutationObserverOptions = {
            childList: true,
            subtree: true,
            characterData: false
        };
        mutationObserver.observe(document.body, mutationObserverOptions);
    }
}
// Test call
$5c2065aa5c493538$export$74b8f1741b4483c3();
function $5c2065aa5c493538$var$handleInstantElements() {
    document.querySelectorAll('[data-view-instant="true"]').forEach((element)=>{
        element.classList.add('animated');
    });
}
$5c2065aa5c493538$var$handleInstantElements(); // data-view-threshold="0.9"
 // data-view-threshold-mobile="0.1" 
 // data-view-disable-mobile="true" 
 // data-view-instant="true"


/**
 * Updates the SimpleBar instance for a given list element.
 *
 * @param {HTMLElement} list - The list element to update.
 */ function $0cfd9c1d06f2717d$var$updateSimpleBar(list) {
    if (list.SimpleBar) list.SimpleBar.unMount();
    list.SimpleBar = new SimpleBar(list);
    const simplebarYInstancesArr = list.querySelectorAll('.simplebar-track.simplebar-vertical');
    const simplebarXInstancesArr = list.querySelectorAll('.simplebar-track.simplebar-horizontal');
    if (simplebarYInstancesArr.length) simplebarYInstancesArr.forEach((element, idx)=>{
        if (idx > 0) element.remove();
    });
    if (simplebarXInstancesArr.length) simplebarXInstancesArr.forEach((element, idx)=>{
        if (idx > 0) element.remove();
    });
}
/**
 * Resets the focus state for all list items inside the wrapper element.
 *
 * @param {HTMLElement} wrapperElement - The wrapper element containing the select list.
 */ window.resetMetaSelectFocus = function resetMetaSelectFocus1(wrapperElement) {
    const listContent = wrapperElement.querySelector('.meta-select-list-content');
    if (listContent) listContent.querySelectorAll('.meta-select-list__item').forEach((el)=>el.classList.remove('is-focused'));
    else document.querySelectorAll('.meta-select-list__item').forEach((el)=>el.classList.remove('is-focused'));
};
/**
 * Initializes  meta select elements and sets up the list dropdown functionality.
 *
 * @param {string} elementsArr - The CSS selector to find the select elements.
 */ window.initMetaSelect = function initMetaSelect1(elementsArr) {
    const metaSelectArr = document.querySelectorAll(elementsArr);
    metaSelectArr.forEach((selectElement, idx)=>{
        const parentContainer = selectElement.closest('.meta-select');
        parentContainer.style.zIndex = metaSelectArr.length - idx + 5;
        if (!parentContainer) return;
        if (!selectElement.classList.contains('is-init')) {
            selectElement.classList.add('is-init');
            const optionsLength = selectElement.querySelectorAll('option').length;
            if (optionsLength === 0) {
                const newOption = document.createElement('option');
                newOption.innerHTML = 'Selected...';
                newOption.value = '';
                selectElement.appendChild(newOption);
            }
            const disabled = selectElement.hasAttribute('disabled');
            const label = parentContainer.querySelector('label');
            const wrapper = document.createElement('div');
            wrapper.className = 'meta-select-inner';
            const placeholder = document.createElement('div');
            placeholder.className = 'meta-select-placeholder';
            const list = document.createElement('div');
            list.className = 'meta-select-list';
            const additionalListClasses = selectElement.getAttribute('data-meta-select-list-class');
            if (additionalListClasses) additionalListClasses.split(' ').forEach((cls)=>{
                if (cls.trim()) list.classList.add(cls.trim());
            });
            const listContent = document.createElement('div');
            listContent.className = 'meta-select-list-content';
            const isSearch = selectElement.hasAttribute('data-meta-select-search');
            let listInput = null;
            if (isSearch) {
                listInput = document.createElement('input');
                listInput.className = 'meta-select-search';
                listInput.type = 'text';
                list.appendChild(listInput);
                list.classList.add('is-search-input');
            }
            list.appendChild(listContent);
            const notInlinePosition = selectElement.hasAttribute('data-meta-select-not-inline');
            if (disabled) parentContainer.classList.add('is-disabled-select');
            /**
       * Positions the dropdown list relative to the select element.
       */ function positionList() {
                if (!notInlinePosition) return;
                requestAnimationFrame(()=>{
                    if (list.parentElement !== document.body) document.body.appendChild(list);
                    if (selectElement.closest('#popup')) list.style.position = 'fixed';
                    else list.style.position = 'absolute';
                    list.style.position = 'fixed';
                    list.style.minWidth = `${wrapper.clientWidth}px`;
                    list.style.maxWidth = `${wrapper.clientWidth}px`;
                    list.style.visibility = 'hidden';
                    list.style.display = 'block';
                    list.style.top = '0';
                    list.style.left = '0';
                    const listHeight = list.offsetHeight;
                    const selectRect = wrapper.getBoundingClientRect();
                    const bottomSpace = window.innerHeight - selectRect.bottom;
                    const topSpace = selectRect.top;
                    let top;
                    if (bottomSpace >= listHeight + 3) top = selectRect.bottom + 3;
                    else if (topSpace >= listHeight + 3) top = selectRect.top - listHeight - 3;
                    else {
                        top = selectRect.bottom + 3;
                        list.style.maxHeight = `${bottomSpace - 10}px`;
                        list.style.overflowY = 'auto';
                    }
                    const left = selectRect.left;
                    list.style.top = `${top}px`;
                    list.style.left = `${left}px`;
                    list.style.visibility = 'visible';
                });
            }
            /**
       * Creates a list item element for a given option element.
       *
       * @param {HTMLOptionElement} option - The option element to create an item for.
       * @returns {HTMLElement} The created list item element.
       */ function createOptionItem(option) {
                const item = document.createElement('div');
                item.className = 'meta-select-list__item';
                item.textContent = option.text;
                item.dataset.value = option.value;
                if (option.selected) item.classList.add('is-selected');
                if (option.disabled) item.classList.add('is-disabled');
                if (option.classList.contains('is-placeholder')) item.classList.add('is-placeholder');
                item.addEventListener('click', ()=>{
                    if (!item.classList.contains('is-disabled')) {
                        setMetaSelectValue(selectElement.id, option.value);
                        closeList();
                    }
                });
                item.addEventListener('mouseenter', ()=>{
                    resetFocus();
                });
                return item;
            }
            /**
       * Updates the dropdown list with the current options from the select element.
       * Supports optgroup elements with labels.
       */ function updateList() {
                listContent.innerHTML = '';
                placeholder.textContent = selectElement.options[selectElement.selectedIndex]?.text || 'Selected...';
                Array.from(selectElement.children).forEach((child)=>{
                    if (child.tagName === 'OPTGROUP') {
                        // Create optgroup container
                        const groupContainer = document.createElement('div');
                        groupContainer.className = 'meta-select-list__group';
                        // Create optgroup label
                        const groupLabel = document.createElement('div');
                        groupLabel.className = 'meta-select-list__group-label';
                        groupLabel.textContent = child.label;
                        groupContainer.appendChild(groupLabel);
                        // Add options within this optgroup
                        Array.from(child.children).forEach((option)=>{
                            if (option.tagName === 'OPTION') {
                                const item = createOptionItem(option);
                                groupContainer.appendChild(item);
                            }
                        });
                        listContent.appendChild(groupContainer);
                    } else if (child.tagName === 'OPTION') {
                        // Handle standalone options (not in optgroup)
                        const item = createOptionItem(child);
                        listContent.appendChild(item);
                    }
                });
                $0cfd9c1d06f2717d$var$updateSimpleBar(list);
            }
            let currentFocusIndex = -1;
            /**
       * Updates the visual focus state of list items based on the current focus index.
       *
       * @param {HTMLElement[]} visibleItems - Array of visible and focusable list items.
       */ function updateFocusItem(visibleItems) {
                visibleItems.forEach((item, i)=>{
                    if (i === currentFocusIndex) item.classList.add('is-focused');
                    else item.classList.remove('is-focused');
                });
            }
            /**
       * Resets the current focus index and removes focus classes from all list items.
       */ function resetFocus() {
                currentFocusIndex = -1;
                listContent.querySelectorAll('.meta-select-list__item').forEach((el)=>el.classList.remove('is-focused'));
            }
            /**
       * Handles keyboard navigation for the dropdown list.
       * Supports ArrowUp, ArrowDown, and Enter keys to navigate and select options.
       *
       * @param {KeyboardEvent} e - The keyboard event object.
       */ function handleKeydown(e) {
                const visibleItems = Array.from(listContent.querySelectorAll('.meta-select-list__item')).filter((item)=>{
                    return item.style.display !== 'none' && !item.classList.contains('is-disabled');
                });
                if (!visibleItems.length) return;
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    currentFocusIndex = (currentFocusIndex + 1) % visibleItems.length;
                    updateFocusItem(visibleItems);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    currentFocusIndex = (currentFocusIndex - 1 + visibleItems.length) % visibleItems.length;
                    updateFocusItem(visibleItems);
                } else if (e.key === 'Enter' && currentFocusIndex >= 0) {
                    e.preventDefault();
                    visibleItems[currentFocusIndex].click();
                }
                const scrollEl = listContent.closest('.simplebar-content-wrapper');
                const focusedEl = visibleItems[currentFocusIndex];
                if (scrollEl && focusedEl) {
                    const scrollTop = scrollEl.scrollTop;
                    const scrollHeight = scrollEl.clientHeight;
                    const elTop = focusedEl.offsetTop;
                    const elBottom = elTop + focusedEl.offsetHeight;
                    if (currentFocusIndex === 0) scrollEl.scrollTop = 0;
                    else if (elBottom > scrollTop + scrollHeight) scrollEl.scrollTop = elBottom - scrollHeight + 8;
                    else if (elTop < scrollTop) scrollEl.scrollTop = elTop - 8;
                }
            }
            /**
       * Opens the dropdown list and positions it correctly.
       */ function openList() {
                const innersGlobalArr = document.querySelectorAll('.meta-select-inner');
                const listsGlobalArr = document.querySelectorAll('.meta-select-list');
                for(let i = 0; i < innersGlobalArr.length; i++){
                    innersGlobalArr[i].classList.remove('is-open');
                    if (listsGlobalArr[i]) listsGlobalArr[i]?.classList.remove('is-open');
                    resetMetaSelectFocus(innersGlobalArr[i]);
                }
                list.classList.add('is-open');
                wrapper.classList.add('is-open');
                positionList();
                window.addEventListener('resize', positionList);
                $0cfd9c1d06f2717d$var$updateSimpleBar(list);
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        positionList();
                    });
                });
                if (isSearch) listInput.focus();
                if (notInlinePosition) bindGlobalScrollClose();
                document.addEventListener('keydown', handleKeydown);
            }
            /**
       * Closes the dropdown list and removes event listeners.
       */ function closeList() {
                list.classList.remove('is-open');
                wrapper.classList.remove('is-open');
                window.removeEventListener('resize', positionList);
                if (notInlinePosition) wrapper.appendChild(list);
                if (notInlinePosition) unbindGlobalScrollClose();
                resetFocus();
                document.removeEventListener('keydown', handleKeydown);
            }
            function handleGlobalTouchMoveClose(event) {
                const touchTarget = event.target;
                if (touchTarget && (list.contains(touchTarget) || wrapper.contains(touchTarget) || label?.contains(touchTarget))) return;
                closeList();
            }
            /**
       * Binds scroll and touchmove events on the window to close the dropdown list.
       */ function bindGlobalScrollClose() {
                window.addEventListener('scroll', closeList);
                window.addEventListener('touchmove', handleGlobalTouchMoveClose, {
                    passive: true
                });
            }
            /**
       * Unbinds scroll and touchmove events from the window that close the dropdown list.
       */ function unbindGlobalScrollClose() {
                window.removeEventListener('scroll', closeList);
                window.removeEventListener('touchmove', handleGlobalTouchMoveClose);
            }
            /**
       * Toggles the visibility of the dropdown list.
       */ const toggleList = ()=>{
                if (list.classList.contains('is-open')) closeList();
                else openList();
            };
            if (!disabled) {
                wrapper.addEventListener('click', (ev)=>{
                    if (ev.target !== list && ev.target !== label && ev.target !== listInput) toggleList();
                });
                label?.addEventListener('click', (ev)=>{
                    ev.preventDefault();
                    ev.stopPropagation();
                    toggleList();
                });
            }
            document.addEventListener('click', (e)=>{
                if (!wrapper.contains(e.target) && !list.contains(e.target) && (!label || !label.contains(e.target))) closeList();
            });
            /**
       * Shows or hides related input fields based on the selected option's data attributes.
       */ const updateVisibility = ()=>{
                const inputIds = new Set();
                Array.from(selectElement.options).forEach((option)=>{
                    const ids = option.dataset.msShowFields?.split(',') || [];
                    ids.forEach((id)=>inputIds.add(id.trim()));
                });
                const inputs = Array.from(inputIds).map((id)=>document.getElementById(id)).filter(Boolean);
                const selectedOption = selectElement.options[selectElement.selectedIndex];
                const toShow = selectedOption.dataset.msShowFields?.split(',').map((id)=>id.trim()) || [];
                inputs.forEach((input)=>{
                    const parentMetaInput = input.closest('.meta-input');
                    const parentMetaSelect = input.closest('.meta-select');
                    const parentMetaTimePicker = input.closest('.meta-time-picker');
                    const parentMetaCheckbox = input.closest('.meta-checkbox');
                    const parentMetaSwitch = input.closest('.meta-switch');
                    if (toShow.includes(input.id)) {
                        parentMetaInput?.classList.remove('hidden');
                        parentMetaSelect?.classList.remove('hidden');
                        parentMetaTimePicker?.classList.remove('hidden');
                        parentMetaCheckbox?.classList.remove('hidden');
                        parentMetaSwitch?.classList.remove('hidden');
                    } else {
                        parentMetaInput?.classList.add('hidden');
                        parentMetaSelect?.classList.add('hidden');
                        parentMetaTimePicker?.classList.add('hidden');
                        parentMetaCheckbox?.classList.add('hidden');
                        parentMetaSwitch?.classList.add('hidden');
                    }
                });
            };
            selectElement.addEventListener('change', function() {
                updateList();
                updateVisibility();
            });
            wrapper.appendChild(placeholder);
            wrapper.appendChild(list);
            parentContainer.appendChild(wrapper);
            selectElement.style.display = 'none';
            updateList();
            updateVisibility();
            /**
       * Calculates the Levenshtein distance between two strings.
       *
       * @param {string} a - First string.
       * @param {string} b - Second string.
       * @returns {number} The Levenshtein distance between the two strings.
       */ function getLevenshteinDistance(a, b) {
                const matrix = [];
                const lenA = a.length;
                const lenB = b.length;
                for(let i = 0; i <= lenB; i++)matrix[i] = [
                    i
                ];
                for(let j = 0; j <= lenA; j++)matrix[0][j] = j;
                for(let i = 1; i <= lenB; i++){
                    for(let j = 1; j <= lenA; j++)if (b.charAt(i - 1) === a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
                    else matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j] + 1);
                }
                return matrix[lenB][lenA];
            }
            if (isSearch) {
                listInput.addEventListener('input', ()=>{
                    const searchTerm = listInput.value.toLowerCase();
                    const items = listContent.querySelectorAll('.meta-select-list__item');
                    const groups = listContent.querySelectorAll('.meta-select-list__group');
                    let visibleCount = 0;
                    items.forEach((item)=>{
                        const text = item.textContent.toLowerCase();
                        const distance = getLevenshteinDistance(text, searchTerm);
                        if (searchTerm === '' || text.includes(searchTerm) || distance <= 1) {
                            item.style.display = '';
                            visibleCount++;
                        } else item.style.display = 'none';
                    });
                    // Hide/show group labels based on whether they have visible items
                    groups.forEach((group)=>{
                        const visibleItemsInGroup = Array.from(group.querySelectorAll('.meta-select-list__item')).filter((item)=>item.style.display !== 'none');
                        const groupLabel = group.querySelector('.meta-select-list__group-label');
                        if (groupLabel) groupLabel.style.display = visibleItemsInGroup.length > 0 ? '' : 'none';
                    });
                    let noResultsSpan = listContent.querySelector('.meta-select-list__item-no-results');
                    if (visibleCount === 0) {
                        if (!noResultsSpan) {
                            noResultsSpan = document.createElement('span');
                            noResultsSpan.className = 'meta-select-list__item-no-results';
                            noResultsSpan.textContent = 'No results';
                            listContent.appendChild(noResultsSpan);
                        }
                    } else if (noResultsSpan) noResultsSpan.remove();
                    resetFocus();
                });
                const isNova = selectElement.hasAttribute('data-meta-select-nova');
                if (isNova) {
                    let typingTimer;
                    const doneTypingInterval = 500;
                    let prevValue = '';
                    /**
           * Handles the logic after the user has stopped typing in the search input.
           * Used for Nova search integration.
           */ function doneTyping() {
                        const novaSelectSearchValue = listInput.value;
                        if (prevValue !== novaSelectSearchValue) {
                            prevValue = novaSelectSearchValue;
                            startLoaderSelect();
                        /*load(
                'page/loadWarehousesKeywords',
                'city_id#nova_city',
                `keywords=${novaSelectSearchValue}`
              );*/ }
                    }
                    listInput.addEventListener('input', function(event) {
                        clearTimeout(typingTimer);
                        typingTimer = setTimeout(doneTyping, doneTypingInterval);
                    });
                }
            }
        }
    });
};
/**
 * Sets the value of a select element and triggers a change event.
 *
 * @param {string} selectId - The ID of the select element.
 * @param {string} value - The value to set for the select element.
 */ window.setMetaSelectValue = function setMetaSelectValue1(selectId, value) {
    const selectElement = document.getElementById(selectId);
    if (!selectElement) return;
    const optionExists = Array.from(selectElement.options).some((option)=>option.value === value);
    if (!optionExists) return;
    selectElement.value = value;
    selectElement.dispatchEvent(new Event('change', {
        bubbles: true
    }));
};
/**
 * Updates the dropdown list of a specific select element.
 *
 * @param {string} selectId - The ID of the select element to update.
 */ window.updateMetaSelect = function updateMetaSelect(selectId) {
    const selectElement = document.getElementById(selectId);
    if (!selectElement) return;
    const parentContainer = selectElement.closest('.meta-select');
    if (!parentContainer) return;
    const wrapper = parentContainer.querySelector('.meta-select-inner');
    const placeholder = wrapper.querySelector('.meta-select-placeholder');
    const list = wrapper.querySelector('.meta-select-list');
    const listContent = wrapper.querySelector('.meta-select-list-content');
    const disabled = selectElement.hasAttribute('disabled');
    if (disabled) parentContainer.classList.add('is-disabled-select');
    if (!list) return;
    listContent.innerHTML = '';
    /**
   * Creates a list item element for a given option element.
   */ function createOptionItem(option) {
        const item = document.createElement('div');
        item.className = 'meta-select-list__item';
        item.textContent = option.text;
        item.dataset.value = option.value;
        if (option.selected) item.classList.add('is-selected');
        if (option.disabled) item.classList.add('is-disabled');
        if (option.classList.contains('is-placeholder')) item.classList.add('is-placeholder');
        item.addEventListener('click', ()=>{
            if (!item.classList.contains('is-disabled')) {
                setMetaSelectValue(selectId, option.value);
                list.classList.remove('is-open');
                wrapper.classList.remove('is-open');
            }
        });
        item.addEventListener('mouseenter', ()=>{
            resetMetaSelectFocus(wrapper);
        });
        return item;
    }
    Array.from(selectElement.children).forEach((child)=>{
        if (child.tagName === 'OPTGROUP') {
            // Create optgroup container
            const groupContainer = document.createElement('div');
            groupContainer.className = 'meta-select-list__group';
            // Create optgroup label
            const groupLabel = document.createElement('div');
            groupLabel.className = 'meta-select-list__group-label';
            groupLabel.textContent = child.label;
            groupContainer.appendChild(groupLabel);
            // Add options within this optgroup
            Array.from(child.children).forEach((option)=>{
                if (option.tagName === 'OPTION') {
                    const item = createOptionItem(option);
                    groupContainer.appendChild(item);
                }
            });
            listContent.appendChild(groupContainer);
        } else if (child.tagName === 'OPTION') {
            // Handle standalone options (not in optgroup)
            const item = createOptionItem(child);
            listContent.appendChild(item);
        }
    });
    placeholder.textContent = selectElement.options[selectElement.selectedIndex]?.text || 'Selected...';
    $0cfd9c1d06f2717d$var$updateSimpleBar(list);
    resetMetaSelectFocus(wrapper);
};
/**
 * Updates the dropdown list of all select elements on the page.
 */ window.updateAllMetaSelects = function updateAllMetaSelects() {
    document.querySelectorAll('[data-meta-select]').forEach((selectElement)=>{
        const parentContainer = selectElement.closest('.meta-select');
        if (!parentContainer) return;
        const wrapper = parentContainer.querySelector('.meta-select-inner');
        const placeholder = wrapper.querySelector('.meta-select-placeholder');
        const list = wrapper.querySelector('.meta-select-list');
        const listContent = wrapper.querySelector('.meta-select-list-content');
        const disabled = selectElement.hasAttribute('disabled');
        if (disabled) parentContainer.classList.add('is-disabled-select');
        if (!list) return;
        listContent.innerHTML = '';
        /**
     * Creates a list item element for a given option element.
     */ function createOptionItem(option) {
            const item = document.createElement('div');
            item.className = 'meta-select-list__item';
            item.textContent = option.text;
            item.dataset.value = option.value;
            if (option.selected) item.classList.add('is-selected');
            if (option.disabled) item.classList.add('is-disabled');
            if (option.classList.contains('is-placeholder')) item.classList.add('is-placeholder');
            item.addEventListener('click', ()=>{
                setMetaSelectValue(selectElement.id, option.value);
                list.classList.remove('is-open');
                wrapper.classList.remove('is-open');
            });
            item.addEventListener('mouseenter', ()=>{
                resetMetaSelectFocus(wrapper);
            });
            return item;
        }
        Array.from(selectElement.children).forEach((child)=>{
            if (child.tagName === 'OPTGROUP') {
                // Create optgroup container
                const groupContainer = document.createElement('div');
                groupContainer.className = 'meta-select-list__group';
                // Create optgroup label
                const groupLabel = document.createElement('div');
                groupLabel.className = 'meta-select-list__group-label';
                groupLabel.textContent = child.label;
                groupContainer.appendChild(groupLabel);
                // Add options within this optgroup
                Array.from(child.children).forEach((option)=>{
                    if (option.tagName === 'OPTION') {
                        const item = createOptionItem(option);
                        groupContainer.appendChild(item);
                    }
                });
                listContent.appendChild(groupContainer);
            } else if (child.tagName === 'OPTION') {
                // Handle standalone options (not in optgroup)
                const item = createOptionItem(child);
                listContent.appendChild(item);
            }
        });
        placeholder.textContent = selectElement.options[selectElement.selectedIndex]?.text || 'Selected...';
        $0cfd9c1d06f2717d$var$updateSimpleBar(list);
        resetMetaSelectFocus(wrapper);
    });
};
/**
 * A utility to handle global "wheel" event listeners that trigger a callback
 * when the user scrolls the mouse wheel **outside** a given element.
 */ const $0cfd9c1d06f2717d$var$OutsideWheelListener = (()=>{
    // Stores references to each list and its associated event handler
    const listeners = new WeakMap();
    return {
        /**
     * Adds a global "wheel" event listener that triggers the callback
     * if the wheel scroll happens outside the given element.
     *
     * @param {Element} list - The DOM element to monitor for outside scroll.
     * @param {Function} callback - The function to call when the scroll happens outside the element.
     */ add (list, callback) {
            if (!list || typeof callback !== 'function') return;
            const handler = (event)=>{
                const hovered = document.elementFromPoint(event.clientX, event.clientY);
                if (!list.contains(hovered)) callback();
            };
            document.addEventListener('wheel', handler, {
                passive: true
            });
            listeners.set(list, handler);
        },
        /**
     * Removes the previously added "wheel" listener for the given element.
     *
     * @param {Element} list - The DOM element associated with the listener to remove.
     */ remove (list) {
            const handler = listeners.get(list);
            if (handler) {
                document.removeEventListener('wheel', handler);
                listeners.delete(list);
            }
        }
    };
})();
initMetaSelect('[data-meta-select]');


function $cd603d79ca5ddbcd$var$t(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var i = 0, n = Array(e); i < e; i++)n[i] = t[i];
    return n;
}
function $cd603d79ca5ddbcd$var$e() {
    return $cd603d79ca5ddbcd$var$e = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)({}).hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, $cd603d79ca5ddbcd$var$e.apply(null, arguments);
}
window.__allCometMarqueeInstances || (window.__allCometMarqueeInstances = []);
var $cd603d79ca5ddbcd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function t(t, e) {
        if (void 0 === e && (e = {}), "string" == typeof t) this.containers = Array.from(document.querySelectorAll(t));
        else if (t instanceof HTMLElement) this.containers = [
            t
        ];
        else {
            if (!(t instanceof NodeList || Array.isArray(t))) throw new Error("CometMarquee: invalid selector");
            this.containers = Array.from(t);
        }
        this.instances = this.containers.map(function(t, i) {
            return new $cd603d79ca5ddbcd$var$n(t, e, i);
        });
    }
    var e = t.prototype;
    return e.start = function() {
        this.instances.forEach(function(t) {
            return t.startAnimation();
        });
    }, e.stop = function() {
        this.instances.forEach(function(t) {
            return t.stop();
        });
    }, e.pause = function() {
        this.instances.forEach(function(t) {
            return t.pause();
        });
    }, e.resume = function() {
        this.instances.forEach(function(t) {
            return t.resume();
        });
    }, e.refresh = function() {
        this.instances.forEach(function(t) {
            return t.refresh();
        });
    }, e.addItem = function(t) {
        this.instances.forEach(function(e) {
            return e.addItem(t);
        });
    }, e.removeItem = function() {
        this.instances.forEach(function(t) {
            return t.removeItem();
        });
    }, e.destroy = function() {
        this.instances.forEach(function(t) {
            return t.destroy();
        });
    }, t;
}(), $cd603d79ca5ddbcd$var$n = /*#__PURE__*/ function() {
    function i(t, e, i) {
        var n, s, o, a, r, h, c, l = this;
        if (void 0 === e && (e = {}), void 0 === i && (i = 0), this.animate = function(t) {
            if (l.isAnimating) {
                t || (t = performance.now());
                var e = (t - l.lastTime) / 1e3;
                if (l.lastTime = t, !l.isPaused) {
                    var i = l.loopWidth || l.contentWidth + l.options.gap;
                    l.options.reverse ? (l.currentTranslate += l.options.speed * e, l.currentTranslate >= -(l.prependWidth || 0) && (l.currentTranslate -= i, l.dispatchEvent("animation-cycle", {
                        direction: "reverse"
                    }))) : (l.currentTranslate -= l.options.speed * e, l.currentTranslate <= -i && (l.currentTranslate += i, l.dispatchEvent("animation-cycle", {
                        direction: "forward"
                    }))), l.content.style.transform = l.isVertical ? "translate3d(0," + l.currentTranslate + "px,0)" : "translate3d(" + l.currentTranslate + "px,0,0)";
                }
                l.animationId = requestAnimationFrame(l.animate);
            }
        }, this.container = t, this.content = t.querySelector(".comet-marquee-content"), this.items = Array.from(this.content.children).filter(function(t) {
            return !t.classList.contains("comet-marquee-clone");
        }), this.container.classList.contains("is-init-comet-marquee")) e.develop && console.warn("[CometMarquee #" + i + "] Already initialized. Skipping.");
        else {
            var d = getComputedStyle(this.content), u = parseFloat(d.gap || d.columnGap || "0");
            this.options = {
                speed: null != (n = e.speed) ? n : 50,
                gap: null != (s = e.gap) ? s : Number.isFinite(u) ? u : 0,
                pauseOnHover: !!e.pauseOnHover,
                pauseOnClick: !!e.pauseOnClick,
                adaptivePause: !!e.adaptivePause,
                reverse: !!e.reverse,
                initialShift: null != (o = e.initialShift) && o,
                pauseOnInvisible: !!e.pauseOnInvisible,
                syncPause: !!e.syncPause,
                repeatCount: null != (a = e.repeatCount) ? a : 3,
                develop: !!e.develop,
                forceAnimation: !!e.forceAnimation,
                forceAnimationWidth: null != (r = e.forceAnimationWidth) ? r : 2,
                fadeEdges: null != (h = e.fadeEdges) && h,
                fullWidth: !!e.fullWidth,
                vertical: !!e.vertical,
                height: null != (c = e.height) ? c : null
            }, this.isVertical = this.options.vertical, this.axis = this.isVertical ? "y" : "x", this.sizeProperty = this.isVertical ? "height" : "width", window.__allCometMarqueeInstances.push(this), this.isAnimating = !1, this.isPaused = !1, this.animationId = null, this.currentTranslate = 0, this.contentWidth = 0, this.containerWidth = 0, this.lastTime = 0, this.idx = i, this.io = null, this.ro = null, this._hoverPause = null, this._hoverResume = null, this._clickToggle = null, this._documentClick = null, this._resizeHandler = null, this._fadeEdgesResizeHandler = null, this._visibilityHandler = null, this._motionChangeHandler = null, this.forceAnimationEnabled = !1, this.lastContainerRectWidth = 0, this.lastWindowWidth = window.innerWidth, this.refreshTimeout = null, this.isRefreshing = !1, this.isInitializing = !1, this.resizeObserverCallCount = 0, this.lastResizeTimestamp = 0, this.contentSetup = !1, this._fullWidthResizeHandler = null, this._fullWidthDebounceTimeout = null, this._originalContainerStyles = null, this.init(), this.bindEvents();
        }
    }
    var n = i.prototype;
    return n.dispatchEvent = function(t, i) {
        void 0 === i && (i = {});
        var n = new CustomEvent("comet-marquee:" + t, {
            detail: $cd603d79ca5ddbcd$var$e({
                instance: this,
                container: this.container
            }, i),
            bubbles: !0,
            cancelable: !0
        });
        this.container.dispatchEvent(n), this.options.develop && console.log("[CometMarquee #" + this.idx + "] " + t, i);
    }, n.getTotalSize = function() {
        var t = this, e = this.items.map(function(e) {
            var i = e.getBoundingClientRect();
            return t.isVertical ? i.height : i.width;
        });
        return e.length ? e.reduce(function(t, e) {
            return t + e;
        }, 0) + this.options.gap * (this.items.length - 1) : 0;
    }, n.calculateDimensions = function() {
        var t = this.container.getBoundingClientRect();
        this.containerWidth = t.width, this.containerHeight = t.height, this.containerSize = this.isVertical ? t.height : t.width, this.contentWidth = this.getTotalSize(), this.contentSize = this.contentWidth, this.contentSize <= 0 ? (this.shouldAnimate = !1, this.options.develop && console.warn("[CometMarquee #" + this.idx + "] Content " + (this.isVertical ? "height" : "width") + " is 0. Animation disabled.")) : this.shouldAnimate = this.contentSize > this.containerSize + 1, this.options.forceAnimation && !this.shouldAnimate && this.contentSize > 0 ? (this.shouldAnimate = !0, this.forceAnimationEnabled = !0, this.dispatchEvent("force-animation-enabled", {
            originalContentSize: this.contentSize,
            containerSize: this.containerSize
        })) : this.forceAnimationEnabled = !1, this.dispatchEvent("dimensions-calculated", {
            containerWidth: this.containerWidth,
            containerHeight: this.containerHeight,
            containerSize: this.containerSize,
            contentSize: this.contentSize,
            shouldAnimate: this.shouldAnimate,
            forceAnimationEnabled: this.forceAnimationEnabled,
            isVertical: this.isVertical
        });
    }, n.calculateForceAnimationClones = function() {
        if (!this.forceAnimationEnabled || !this.items.length) return 0;
        var t = (this.isVertical ? window.innerHeight : window.innerWidth) * this.options.forceAnimationWidth, e = this.contentWidth, i = Math.min(Math.ceil(t / e), 20), n = Math.max(0, (i - 1) * this.items.length), s = Math.min(n, 100);
        return s < n && this.options.develop && console.warn("[CometMarquee #" + this.idx + "] Clone count capped at 100 (would be " + n + ")"), this.dispatchEvent("force-animation-calculated", {
            targetSize: t,
            singleSetSize: e,
            setsNeeded: i,
            clonesNeeded: s,
            cappedFromOriginal: n
        }), s;
    }, n.applyFadeEdges = function() {
        var t = this.options.fadeEdges;
        if (!1 === t) return this.container.classList.remove("is-fade-edges"), void this.dispatchEvent("fade-edges-removed");
        if (!0 === t) return this.container.classList.add("is-fade-edges"), void this.dispatchEvent("fade-edges-applied", {
            condition: "always"
        });
        if ("number" == typeof t) {
            var e = window.innerWidth;
            e >= t ? (this.container.classList.add("is-fade-edges"), this.dispatchEvent("fade-edges-applied", {
                condition: "breakpoint",
                breakpoint: t,
                currentWidth: e
            })) : (this.container.classList.remove("is-fade-edges"), this.dispatchEvent("fade-edges-removed", {
                condition: "breakpoint",
                breakpoint: t,
                currentWidth: e
            }));
        }
    }, n.setupContent = function() {
        var t, e = this;
        if (this.content.style.willChange = "transform", this.content.querySelectorAll(".comet-marquee-clone").forEach(function(t) {
            return t.remove();
        }), !this.shouldAnimate) return this.content.style.transform = "translate3d(0,0,0)", this.isVertical ? this.content.style.height = "auto" : this.content.style.width = "auto", this.currentTranslate = 0, this.contentSetup = !1, void this.dispatchEvent("animation-not-needed");
        this.contentSetup = !0, this.dispatchEvent("clones-creating");
        var i = [];
        if (this.forceAnimationEnabled) {
            var n = this.calculateForceAnimationClones();
            t = Math.ceil(n / this.items.length);
            for(var s = document.createDocumentFragment(), o = 0; o < n; o++){
                var a = this.items[o % this.items.length].cloneNode(!0);
                a.classList.add("comet-marquee-clone"), s.appendChild(a), i.push(a);
            }
            this.content.appendChild(s);
        } else {
            var r = Math.max(this.containerWidth, window.innerWidth);
            t = Math.max(this.options.repeatCount, Math.ceil(r * this.options.repeatCount / this.contentWidth));
            for(var h = document.createDocumentFragment(), c = 0; c < t; c++)this.items.forEach(function(t) {
                var e = t.cloneNode(!0);
                e.classList.add("comet-marquee-clone"), h.appendChild(e), i.push(e);
            });
            this.content.appendChild(h);
        }
        var l = [];
        if (this.options.reverse) {
            for(var d = Math.max(this.containerWidth, window.innerWidth), u = Math.max(2, Math.ceil(d / this.contentWidth) + 1), m = document.createDocumentFragment(), p = 0; p < u; p++)this.items.forEach(function(t) {
                var e = t.cloneNode(!0);
                e.classList.add("comet-marquee-clone"), e.classList.add("comet-marquee-prepend"), m.appendChild(e), l.push(e);
            });
            this.content.insertBefore(m, this.content.firstChild);
        }
        this.dispatchEvent("clones-created", {
            cloneCount: i.length,
            prependedCount: l.length,
            repeatCount: t,
            forceAnimationEnabled: this.forceAnimationEnabled
        });
        var v = Array.from(this.content.children), f = v.length, g = v.reduce(function(t, i) {
            var n = i.getBoundingClientRect();
            return t + (e.isVertical ? n.height : n.width);
        }, 0) + this.options.gap * (f - 1);
        this.isVertical ? this.content.style.height = g + "px" : this.content.style.width = g + "px";
        var E = l.length > 0 ? l.reduce(function(t, i) {
            var n = i.getBoundingClientRect();
            return t + (e.isVertical ? n.height : n.width);
        }, 0) + this.options.gap * l.length : 0, w = 0;
        !0 === this.options.initialShift ? w = this.containerSize : "number" == typeof this.options.initialShift && (w = this.options.initialShift);
        var y = this.contentWidth + this.options.gap;
        this.loopWidth = y, this.prependWidth = E, this.currentTranslate = this.options.reverse ? -E - y + w : -w, this.content.style.transform = this.isVertical ? "translate3d(0," + this.currentTranslate + "px,0)" : "translate3d(" + this.currentTranslate + "px,0,0)", this.dispatchEvent("content-setup", {
            totalSize: g,
            initialTranslate: this.currentTranslate,
            forceAnimationEnabled: this.forceAnimationEnabled,
            isVertical: this.isVertical
        });
    }, n.init = function() {
        var t = this;
        this.isInitializing = !0, this.dispatchEvent("init-start"), this.container.classList.add("is-init-comet-marquee"), this.isVertical && (this.container.setAttribute("data-vertical", ""), null !== this.options.height ? this.container.style.setProperty("--comet-marquee-height", "number" == typeof this.options.height ? this.options.height + "px" : this.options.height) : this.options.develop && console.warn("[CometMarquee #" + this.idx + "] Vertical mode without explicit height. Using CSS default (--comet-marquee-height: 300px).")), this.options.fullWidth && this.applyFullSize(), this.calculateDimensions(), this.setupContent(), this.applyFadeEdges(), this.startAnimation(), this.dispatchEvent("init-complete"), this.isInitializing = !1, setTimeout(function() {
            t.isInitializing = !1;
        }, 300);
    }, n.applyFullSize = function() {
        var t = this;
        if (this.options.fullWidth) {
            this._originalContainerStyles || (this._originalContainerStyles = {
                width: this.container.style.width,
                height: this.container.style.height,
                maxWidth: this.container.style.maxWidth,
                maxHeight: this.container.style.maxHeight,
                marginLeft: this.container.style.marginLeft,
                marginTop: this.container.style.marginTop,
                position: this.container.style.position
            });
            var e = this.container.getBoundingClientRect();
            if (this.isVertical) {
                var i = e.top;
                this.container.style.height = "100vh", this.container.style.maxHeight = "100vh", this.container.style.marginTop = "-" + i + "px", this.dispatchEvent("fullsize-applied", {
                    offsetTop: i,
                    axis: "vertical"
                });
            } else {
                var n = e.left;
                this.container.style.width = "100vw", this.container.style.maxWidth = "100vw", this.container.style.marginLeft = "-" + n + "px", this.dispatchEvent("fullsize-applied", {
                    offsetLeft: n,
                    axis: "horizontal"
                });
            }
            "static" === getComputedStyle(this.container).position && (this.container.style.position = "relative"), this._fullWidthResizeHandler || (this._fullWidthResizeHandler = function() {
                t._fullWidthDebounceTimeout && clearTimeout(t._fullWidthDebounceTimeout), t._fullWidthDebounceTimeout = setTimeout(function() {
                    t.updateFullSize();
                }, 150);
            }, window.addEventListener("resize", this._fullWidthResizeHandler));
        }
    }, n.updateFullSize = function() {
        if (this.options.fullWidth) {
            var t, e, i, n;
            this.isVertical ? (this.container.style.height = (null == (t = this._originalContainerStyles) ? void 0 : t.height) || "", this.container.style.marginTop = (null == (e = this._originalContainerStyles) ? void 0 : e.marginTop) || "") : (this.container.style.width = (null == (i = this._originalContainerStyles) ? void 0 : i.width) || "", this.container.style.marginLeft = (null == (n = this._originalContainerStyles) ? void 0 : n.marginLeft) || "");
            var s = this.container.getBoundingClientRect();
            if (this.isVertical) {
                var o = s.top;
                this.container.style.height = "100vh", this.container.style.maxHeight = "100vh", this.container.style.marginTop = "-" + o + "px", this.dispatchEvent("fullsize-updated", {
                    offsetTop: o
                });
            } else {
                var a = s.left;
                this.container.style.width = "100vw", this.container.style.maxWidth = "100vw", this.container.style.marginLeft = "-" + a + "px", this.dispatchEvent("fullsize-updated", {
                    offsetLeft: a
                });
            }
        }
    }, n.startAnimation = function() {
        this.shouldAnimate ? (this.isAnimating = !0, this.isPaused = !1, this.lastTime = performance.now(), cancelAnimationFrame(this.animationId), this.dispatchEvent("animation-started"), this.animate()) : this.dispatchEvent("animation-skipped");
    }, n.pause = function() {
        var t = this, e = this.isPaused;
        this.isPaused = !0, e || this.dispatchEvent("animation-paused"), this.options.syncPause && window.__allCometMarqueeInstances && window.__allCometMarqueeInstances.forEach(function(e) {
            e !== t && (e.isPaused = !0);
        });
    }, n.resume = function() {
        var t = this;
        if (this.calculateDimensions(), this.shouldAnimate && !this.contentSetup && (this.options.develop && console.log("[CometMarquee #" + this.idx + "] Resume: forcing content setup (width: " + this.contentWidth + ")"), this.setupContent()), this.shouldAnimate) {
            var e = this.isPaused;
            this.isPaused && (this.isPaused = !1, this.lastTime = performance.now(), this.isAnimating ? e && this.dispatchEvent("animation-resumed") : (this.isAnimating = !0, this.startAnimation())), this.options.syncPause && window.__allCometMarqueeInstances && window.__allCometMarqueeInstances.forEach(function(e) {
                e !== t && e.isPaused && (e.calculateDimensions(), e.shouldAnimate && (e.isPaused = !1, e.lastTime = performance.now(), e.isAnimating || (e.isAnimating = !0, e.startAnimation())));
            });
        } else this.stop();
    }, n.stop = function() {
        var t = this.isAnimating;
        this.isAnimating = !1, this.animationId && cancelAnimationFrame(this.animationId), this.animationId = null, t && this.dispatchEvent("animation-stopped");
    }, n.refresh = function() {
        var t = this;
        this.isRefreshing || this.isInitializing ? this.options.develop && console.warn("[CometMarquee #" + this.idx + "] Refresh blocked - already in progress") : (this.isRefreshing = !0, this.dispatchEvent("refresh-start"), this.stop(), this.items = Array.from(this.content.children).filter(function(t) {
            return !t.classList.contains("comet-marquee-clone");
        }), this.init(), this.dispatchEvent("refresh-complete"), setTimeout(function() {
            t.isRefreshing = !1, t.options.develop && console.log("[CometMarquee #" + t.idx + "] Refresh guard cleared");
        }, 500));
    }, n.bindEvents = function() {
        var e = this;
        this.dispatchEvent("events-bound");
        var i = function() {
            var t = window.innerWidth >= 1024;
            e.container.removeEventListener("mouseenter", e._hoverPause), e.container.removeEventListener("mouseleave", e._hoverResume), e.container.removeEventListener("click", e._clickToggle), document.removeEventListener("click", e._documentClick), t ? (e._hoverPause = function() {
                e.dispatchEvent("hover-pause"), e.pause();
            }, e._hoverResume = function() {
                e.dispatchEvent("hover-resume"), e.resume();
            }, e.container.addEventListener("mouseenter", e._hoverPause), e.container.addEventListener("mouseleave", e._hoverResume)) : (e._clickToggle = function(t) {
                t.stopPropagation(), e.isPaused ? (e.dispatchEvent("click-resume"), e.resume()) : (e.dispatchEvent("click-pause"), e.pause());
            }, e._documentClick = function(t) {
                !e.container.contains(t.target) && e.isPaused && (e.dispatchEvent("outside-click-resume"), e.resume());
            }, e.container.addEventListener("click", e._clickToggle), document.addEventListener("click", e._documentClick));
        };
        this.options.adaptivePause ? (i(), this._resizeHandler = function() {
            e.dispatchEvent("adaptive-pause-resize"), i();
        }, window.addEventListener("resize", this._resizeHandler)) : (this.options.pauseOnHover && (this._hoverPause = function() {
            e.dispatchEvent("hover-pause"), e.pause();
        }, this._hoverResume = function() {
            e.dispatchEvent("hover-resume"), e.resume();
        }, this.container.addEventListener("mouseenter", this._hoverPause), this.container.addEventListener("mouseleave", this._hoverResume)), this.options.pauseOnClick && (this._clickToggle = function(t) {
            t.stopPropagation(), e.isPaused ? (e.dispatchEvent("click-resume"), e.resume()) : (e.dispatchEvent("click-pause"), e.pause());
        }, this._documentClick = function(t) {
            !e.container.contains(t.target) && e.isPaused && (e.dispatchEvent("outside-click-resume"), e.resume());
        }, this.container.addEventListener("click", this._clickToggle), document.addEventListener("click", this._documentClick))), this.options.pauseOnInvisible && (this.io = new IntersectionObserver(function(t) {
            t.forEach(function(t) {
                t.isIntersecting ? (e.dispatchEvent("visibility-resume"), e.resume()) : (e.dispatchEvent("visibility-pause"), e.pause());
            });
        }, {
            threshold: .1,
            rootMargin: "0px"
        }), this.io.observe(this.container)), this.ro = new ResizeObserver(function(i) {
            var n = performance.now();
            if (e.resizeObserverCallCount++, e.isRefreshing || e.isInitializing) e.options.develop && console.log("[CometMarquee #" + e.idx + "] RO blocked - refreshing/initializing");
            else {
                var s = n - e.lastResizeTimestamp;
                if (s < 50) e.options.develop && console.warn("[CometMarquee #" + e.idx + "] RO call too rapid (" + s.toFixed(1) + "ms) - ignoring");
                else {
                    if (e.lastResizeTimestamp = n, e.resizeObserverCallCount > 100) return console.error("[CometMarquee #" + e.idx + "] ResizeObserver loop detected! Disconnecting to prevent crash."), void e.ro.disconnect();
                    for(var o, a = e.isVertical ? window.innerHeight : window.innerWidth, r = a !== e.lastWindowWidth, h = !1, c = function(e) {
                        var i = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (i) return (i = i.call(e)).next.bind(i);
                        if (Array.isArray(e) || (i = function(e, i) {
                            if (e) {
                                if ("string" == typeof e) return $cd603d79ca5ddbcd$var$t(e, i);
                                var n = ({}).toString.call(e).slice(8, -1);
                                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $cd603d79ca5ddbcd$var$t(e, i) : void 0;
                            }
                        }(e))) {
                            i && (e = i);
                            var n = 0;
                            return function() {
                                return n >= e.length ? {
                                    done: !0
                                } : {
                                    done: !1,
                                    value: e[n++]
                                };
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }(i); !(o = c()).done;){
                        var l = o.value, d = Math.round(e.isVertical ? l.contentRect.height : l.contentRect.width);
                        if (0 === e.lastContainerRectWidth) return e.lastContainerRectWidth = d, void (e.options.develop && console.log("[CometMarquee #" + e.idx + "] Initial " + (e.isVertical ? "height" : "width") + ": " + d + "px"));
                        var u = Math.abs(d - e.lastContainerRectWidth);
                        if (u < 5) return void (e.options.develop && console.log("[CometMarquee #" + e.idx + "] Size change too small (" + u + "px) - ignoring"));
                        if (!r && u < 10) return void (e.options.develop && console.log("[CometMarquee #" + e.idx + "] Internal size change without window resize - ignoring"));
                        e.options.develop && console.log("[CometMarquee #" + e.idx + "] " + (e.isVertical ? "Height" : "Width") + ": " + e.lastContainerRectWidth + "px \u2192 " + d + "px (window: " + r + ")"), e.lastContainerRectWidth = d, h = !0;
                    }
                    (h || r) && (e.lastWindowWidth = a, e.dispatchEvent("container-resized"), e.applyFadeEdges(), e._refreshTimeout && clearTimeout(e._refreshTimeout), e._refreshTimeout = setTimeout(function() {
                        e.resizeObserverCallCount = 0, e.refresh();
                    }, 300));
                }
            }
        }), this.ro.observe(this.container), this._orientationChangeHandler = function() {
            e.dispatchEvent("orientation-change"), setTimeout(function() {
                e.applyFadeEdges(), e.refresh();
            }, 200);
        }, window.addEventListener("orientationchange", this._orientationChangeHandler), this._fadeEdgesResizeHandler = function() {
            e.applyFadeEdges();
        }, window.addEventListener("resize", this._fadeEdgesResizeHandler), this._visibilityHandler = function() {
            "visible" === document.visibilityState ? (e.dispatchEvent("document-visible"), e.resume()) : e.options.pauseOnInvisible && (e.dispatchEvent("document-hidden"), e.pause());
        }, document.addEventListener("visibilitychange", this._visibilityHandler);
        var n = window.matchMedia("(prefers-reduced-motion: reduce)");
        this._motionChangeHandler = function() {
            n.matches ? (e.dispatchEvent("reduced-motion-on"), e.pause()) : (e.dispatchEvent("reduced-motion-off"), e.resume());
        }, n.matches && this.pause(), n.addEventListener && n.addEventListener("change", this._motionChangeHandler);
    }, n.addItem = function(t) {
        this.dispatchEvent("item-adding", {
            itemHtml: t
        });
        var e = document.createElement("div");
        e.innerHTML = t;
        var i = e.firstElementChild, n = this.content.querySelector(".comet-marquee-clone");
        n ? this.content.insertBefore(i, n) : this.content.appendChild(i), this.refresh(), this.dispatchEvent("item-added", {
            newItem: i
        });
    }, n.removeItem = function() {
        var t = Array.from(this.content.children).filter(function(t) {
            return !t.classList.contains("comet-marquee-clone");
        });
        if (t.length > 0) {
            var e = t[t.length - 1];
            this.dispatchEvent("item-removing", {
                removedItem: e
            }), e.remove(), this.refresh(), this.dispatchEvent("item-removed");
        }
    }, n.destroy = function() {
        if (this.dispatchEvent("destroy-start"), this.stop(), this._refreshTimeout && clearTimeout(this._refreshTimeout), window.__allCometMarqueeInstances) {
            var t = window.__allCometMarqueeInstances.indexOf(this);
            t > -1 && window.__allCometMarqueeInstances.splice(t, 1);
        }
        this.io && this.io.disconnect(), this.ro && this.ro.disconnect(), this.container.removeEventListener("mouseenter", this._hoverPause), this.container.removeEventListener("mouseleave", this._hoverResume), this.container.removeEventListener("click", this._clickToggle), document.removeEventListener("click", this._documentClick), window.removeEventListener("resize", this._resizeHandler), window.removeEventListener("resize", this._fadeEdgesResizeHandler), window.removeEventListener("orientationchange", this._orientationChangeHandler), document.removeEventListener("visibilitychange", this._visibilityHandler), this._fullWidthResizeHandler && window.removeEventListener("resize", this._fullWidthResizeHandler), this._fullWidthDebounceTimeout && clearTimeout(this._fullWidthDebounceTimeout), this._originalContainerStyles && (this.container.style.width = this._originalContainerStyles.width, this.container.style.height = this._originalContainerStyles.height, this.container.style.maxWidth = this._originalContainerStyles.maxWidth, this.container.style.maxHeight = this._originalContainerStyles.maxHeight, this.container.style.marginLeft = this._originalContainerStyles.marginLeft, this.container.style.marginTop = this._originalContainerStyles.marginTop, this.container.style.position = this._originalContainerStyles.position), this.isVertical && this.container.removeAttribute("data-vertical");
        var e = window.matchMedia("(prefers-reduced-motion: reduce)");
        e.removeEventListener && e.removeEventListener("change", this._motionChangeHandler), this.dispatchEvent("destroy-complete");
    }, i;
}();
"undefined" != typeof window && (window.cometMarquee && window.cometMarquee.CometMarquee ? window.CometMarquee = window.cometMarquee.CometMarquee : window.CometMarquee = $cd603d79ca5ddbcd$export$2e2bcd8739ae039);
 //# sourceMappingURL=comet-marquee.modern.js.map



const $19e1907b2c861991$var$growthMarquee = new (0, $cd603d79ca5ddbcd$export$2e2bcd8739ae039)('#growth-marquee', {
    speed: 30,
    pauseOnHover: true,
    initialShift: true,
    pauseOnInvisible: true,
    syncPause: true,
    repeatCount: 3,
    forceAnimation: true,
    forceAnimationWidth: 2
});
const $19e1907b2c861991$var$marqueeElement = document.querySelector('#numbers-marquee');
if ($19e1907b2c861991$var$marqueeElement) {
    const numbersMarquee = new (0, $cd603d79ca5ddbcd$export$2e2bcd8739ae039)($19e1907b2c861991$var$marqueeElement, {
        speed: 20,
        pauseOnHover: true,
        initialShift: true,
        pauseOnInvisible: true,
        syncPause: true,
        repeatCount: 4,
        forceAnimation: true,
        forceAnimationWidth: 2
    });
    setTimeout(()=>{
        initContainerCountUp({
            container: '.numbers-sec__marquee'
        });
    }, 0);
}


/**
 * Form validation class that handles form error display and cleanup
 */ class $8a813c788bb79fef$var$FormValidator {
    /**
   * Initialize the FormValidator with default options
   */ constructor(){
        this.defaultOptions = {
            errorTextClasses: 'text-red-500',
            errorTextClassesCheckRadio: 'text-red-500 absolute bottom-0 left-0',
            errorTextClassesFile: 'text-red-500',
            errorTextClassesSelect: 'text-red-500',
            inputErrorClasses: '!border-red-500',
            selectErrorClasses: '!border-red-500',
            errorTextClassesForm: 'text-red-500',
            defaultErrorMessage: 'This field is required',
            errorClearDelay: 500,
            transitionDelay: 300
        };
    }
    /**
   * Main validation method that processes form data and displays errors
   * @param {string|object} formData - Form data as string or object
   * @returns {object} Object containing field errors
   */ validate(formData) {
        if (!document.querySelector('.portal')) try {
            console.log(formData);
            const data = typeof formData === 'string' ? JSON.parse(formData) : formData;
            console.log(data);
            const formId = data.form_id;
            const errorMessages = data.names;
            let formErrorMessage = '';
            let fieldErrors = {};
            if (data?.names && Array.isArray(data.names) && Array.isArray(data.names[0]) && typeof data.names[0][0] === 'string') formErrorMessage = data.names[0][0];
            else if (data?.names && typeof data.names === 'object' && !Array.isArray(data.names)) fieldErrors = data.names;
            const finalOptions = {
                ...this.defaultOptions
            };
            const errors = {};
            const form = document.getElementById(formId);
            if (!form) throw new Error(`Form with ID "${formId}" not found.`);
            if (formErrorMessage && formErrorMessage !== '') this.handleFormError(form, formErrorMessage, finalOptions);
            if (errorMessages && (typeof errorMessages !== 'object' || Array.isArray(errorMessages))) throw new Error('Invalid error format. Expected an object.');
            if (errorMessages) Object.keys(errorMessages).forEach((fieldName)=>{
                this.handleFieldError(form, fieldName, errorMessages[fieldName], finalOptions, errors);
            });
            this.updateAllSimpleBars();
            return errors;
        } catch (error) {
            console.error('Error parsing JSON data:', error.message);
            return {};
        }
    }
    /**
   * Handle form-level error display
   * @param {HTMLElement} form - The form element
   * @param {string} errorMessage - Error message to display
   * @param {object} options - Validation options
   */ handleFormError(form, errorMessage, options) {
        let formErrorElement = form.querySelector('.form-error-text');
        if (formErrorElement) formErrorElement.remove();
        formErrorElement = document.createElement('div');
        formErrorElement.className = `form-error-text ${options.errorTextClassesForm}`;
        formErrorElement.textContent = errorMessage;
        form.classList.add('error');
        form.appendChild(formErrorElement);
        console.log(form);
        if (form.querySelector('input, textarea')) {
            const inputs = form.querySelectorAll('input, textarea');
            inputs.forEach((input)=>{
                input.addEventListener('click', ()=>{
                    form.classList.remove('error');
                });
                input.addEventListener('change', ()=>{
                    form.classList.remove('error');
                });
            });
        }
    }
    /**
   * Handle field-level error display and setup
   * @param {HTMLElement} form - The form element
   * @param {string} fieldName - Name of the field with error
   * @param {array} fieldError - Error data for the field
   * @param {object} options - Validation options
   * @param {object} errors - Errors object to populate
   */ handleFieldError(form, fieldName, fieldError, options, errors) {
        let inputField = form.elements[fieldName];
        if (!inputField) {
            inputField = form.querySelector(`[name="${fieldName}[]"]`);
            const parentChecklist = inputField.closest('.meta-checklist');
            if (parentChecklist) parentChecklist.classList.add('error-array-checklist');
        }
        console.log(fieldName, inputField);
        if (!inputField) {
            console.warn(`Input field "${fieldName}" not found in form.`);
            return;
        }
        const parentElement = inputField.parentElement;
        const isCheckboxOrRadio = inputField.type === 'checkbox' || inputField.type === 'radio';
        const isFile = inputField.name === 'cv_field';
        const isSelect = inputField.tagName.toLowerCase() === 'select';
        const errorMessage = fieldError?.[0] || options.defaultErrorMessage;
        const errorTextClass = this.getErrorTextClass(isFile, isCheckboxOrRadio, isSelect, options);
        let errorTextElement = this.getErrorTextElement(isSelect, parentElement);
        if (!isCheckboxOrRadio && !isFile && !isSelect) this.handleRegularFieldError(inputField, parentElement, errorTextElement, errorMessage, errorTextClass, options, errors, fieldName);
        else if (isCheckboxOrRadio || isFile || isSelect) this.handleSpecialFieldError(inputField, parentElement, errorTextElement, errorMessage, errorTextClass, options, errors, fieldName, isCheckboxOrRadio, isFile, isSelect);
        this.handleMetaUploadFile(inputField);
        this.addFieldEventListeners(inputField, parentElement, errorTextElement, options);
    }
    /**
   * Get appropriate CSS class for error text based on field type
   * @param {boolean} isFile - Whether the field is a file input
   * @param {boolean} isCheckboxOrRadio - Whether the field is checkbox or radio
   * @param {boolean} isSelect - Whether the field is a select
   * @param {object} options - Validation options
   * @returns {string} CSS class for error text
   */ getErrorTextClass(isFile, isCheckboxOrRadio, isSelect, options) {
        if (isFile) return options.errorTextClassesFile;
        else if (isCheckboxOrRadio) return options.errorTextClassesCheckRadio;
        else if (isSelect) return options.errorTextClassesSelect;
        else return options.errorTextClasses;
    }
    /**
   * Find existing error text element based on field type
   * @param {boolean} isSelect - Whether the field is a select
   * @param {HTMLElement} parentElement - Parent element of the field
   * @returns {HTMLElement|null} Existing error text element or null
   */ getErrorTextElement(isSelect, parentElement) {
        return isSelect ? parentElement.parentElement.parentElement.querySelector('.error-text') : parentElement.querySelector('.error-text');
    }
    /**
   * Handle regular input field error display
   * @param {HTMLElement} inputField - The input field element
   * @param {HTMLElement} parentElement - Parent element of the field
   * @param {HTMLElement} errorTextElement - Error text element
   * @param {string} errorMessage - Error message to display
   * @param {string} errorTextClass - CSS class for error text
   * @param {object} options - Validation options
   * @param {object} errors - Errors object
   * @param {string} fieldName - Name of the field
   */ handleRegularFieldError(inputField, parentElement, errorTextElement, errorMessage, errorTextClass, options, errors, fieldName) {
        errors[fieldName] = errorMessage;
        inputField.classList.add('error', ...options.inputErrorClasses.split(' '));
        if (!errorTextElement) {
            errorTextElement = document.createElement('span');
            errorTextElement.className = `error-text ${errorTextClass}`;
            parentElement.appendChild(errorTextElement);
        }
        errorTextElement.textContent = errorMessage;
        this.addErrorTextEventListener(errorTextElement, inputField, parentElement, options);
    }
    /**
   * Handle special field error display (checkbox, radio, file, select)
   * @param {HTMLElement} inputField - The input field element
   * @param {HTMLElement} parentElement - Parent element of the field
   * @param {HTMLElement} errorTextElement - Error text element
   * @param {string} errorMessage - Error message to display
   * @param {string} errorTextClass - CSS class for error text
   * @param {object} options - Validation options
   * @param {object} errors - Errors object
   * @param {string} fieldName - Name of the field
   * @param {boolean} isCheckboxOrRadio - Whether the field is checkbox or radio
   * @param {boolean} isFile - Whether the field is a file input
   * @param {boolean} isSelect - Whether the field is a select
   */ handleSpecialFieldError(inputField, parentElement, errorTextElement, errorMessage, errorTextClass, options, errors, fieldName, isCheckboxOrRadio, isFile, isSelect) {
        errors[fieldName] = errorMessage;
        inputField.classList.add('error');
        if (isCheckboxOrRadio || isFile) {
            if (parentElement.closest('.error-array-checklist')) {
                const checkListArray = parentElement.closest('.error-array-checklist');
                checkListArray.classList.add('error');
            } else parentElement.classList.add('error');
        } else if (isSelect) {
            const selectParent = parentElement.parentElement;
            selectParent.classList.add('error', ...options.selectErrorClasses.split(' '));
        }
        if (!errorTextElement) {
            errorTextElement = document.createElement('span');
            errorTextElement.className = `error-text ${errorTextClass}`;
            if (isFile) {
                const metaUploadFileEl = parentElement.closest('.meta-upload-file');
                const errorTextsArr = metaUploadFileEl.querySelectorAll('.error-text');
                if (errorTextsArr.length) errorTextsArr.forEach((el)=>{
                    el.remove();
                });
                parentElement.insertAdjacentElement('afterend', errorTextElement);
            } else if (isSelect) {
                const selectParent = parentElement.parentElement;
                selectParent.insertAdjacentElement('afterend', errorTextElement);
            } else parentElement.appendChild(errorTextElement);
        }
        errorTextElement.textContent = errorMessage;
        if (parentElement.closest('.error-array-checklist')) {
            const checkListArray = inputField.closest('.error-array-checklist');
            const errorTextsArr = checkListArray.querySelectorAll('.error-text');
            if (errorTextsArr.length) for(let i = 0; i < errorTextsArr.length; i++)errorTextsArr[i].remove();
            checkListArray.appendChild(errorTextElement);
            errorTextElement.classList.remove(...options.errorTextClassesCheckRadio.split(' '));
            errorTextElement.classList.add('w-full', ...options.errorTextClasses.split(' '));
            this.addErrorChecklistArrayEventListener(errorTextElement, inputField, parentElement, options, fieldName);
        }
        this.addErrorTextEventListener(errorTextElement, inputField, parentElement, options);
    }
    /**
   * Handle meta upload file error styling
   * @param {HTMLElement} inputField - The input field element
   */ handleMetaUploadFile(inputField) {
        if (inputField.closest('.meta-upload-file')) {
            const metaUploadFileEl = inputField.closest('.meta-upload-file');
            metaUploadFileEl.classList.add('error');
        }
    }
    addErrorChecklistArrayEventListener(errorTextElement, inputField, parentElement, options, fieldName) {
        const checkListArray = inputField.closest('.error-array-checklist');
        if (checkListArray) {
            const checkListArrayElements = checkListArray.querySelectorAll(`[name="${fieldName}[]"]`);
            const errorTextHandler = ()=>{
                setTimeout(()=>{
                    this.clearFieldError(inputField, checkListArray, errorTextElement, options);
                    setTimeout(()=>{
                        const errorTextsArr = checkListArray.querySelectorAll('.error-text');
                        if (errorTextsArr.length) for(let i = 0; i < errorTextsArr.length; i++)errorTextsArr[i].remove();
                        errorTextElement.removeEventListener('click', errorTextHandler);
                        checkListArrayElements.forEach((el)=>{
                            el.removeEventListener('change', errorTextHandler);
                        });
                    }, options.errorClearDelay);
                }, options.errorClearDelay);
            };
            errorTextElement.addEventListener('click', errorTextHandler);
            checkListArrayElements.forEach((el)=>{
                el.addEventListener('change', (e)=>{
                    errorTextHandler();
                });
            });
        }
    }
    /**
   * Add event listeners to error text element for error clearing
   * @param {HTMLElement} errorTextElement - Error text element
   * @param {HTMLElement} inputField - The input field element
   * @param {HTMLElement} parentElement - Parent element of the field
   * @param {object} options - Validation options
   */ addErrorTextEventListener(errorTextElement, inputField, parentElement, options) {
        const oldErrorTextHandler = errorTextElement._validationErrorTextHandler;
        if (oldErrorTextHandler) errorTextElement.removeEventListener('click', oldErrorTextHandler);
        const errorTextHandler = ()=>{
            setTimeout(()=>{
                this.clearFieldError(inputField, parentElement, errorTextElement, options);
            }, options.errorClearDelay);
        };
        errorTextElement.addEventListener('click', errorTextHandler);
        errorTextElement._validationErrorTextHandler = errorTextHandler;
    }
    /**
   * Add event listeners to field and parent elements for error clearing
   * @param {HTMLElement} inputField - The input field element
   * @param {HTMLElement} parentElement - Parent element of the field
   * @param {HTMLElement} errorTextElement - Error text element
   * @param {object} options - Validation options
   */ addFieldEventListeners(inputField, parentElement, errorTextElement, options) {
        const oldClickHandler = inputField._validationClickHandler;
        if (oldClickHandler) inputField.removeEventListener('click', oldClickHandler);
        const clickHandler = ()=>{
            setTimeout(()=>{
                this.clearFieldError(inputField, parentElement, errorTextElement, options);
            }, options.errorClearDelay);
        };
        inputField.addEventListener('click', clickHandler);
        inputField._validationClickHandler = clickHandler;
        if (parentElement.parentElement) {
            const oldParentClickHandler = parentElement.parentElement._validationParentClickHandler;
            if (oldParentClickHandler) parentElement.parentElement.removeEventListener('click', oldParentClickHandler);
        /*const parentClickHandler = () => {
        setTimeout(() => {
          this.clearParentError(inputField, parentElement, options);
        }, options.errorClearDelay);
      };

      parentElement.parentElement.addEventListener('click', parentClickHandler);
      parentElement.parentElement._validationParentClickHandler =
        parentClickHandler;*/ }
        const oldDirectParentClickHandler = parentElement._validationDirectParentClickHandler;
        if (oldDirectParentClickHandler) parentElement.removeEventListener('click', oldDirectParentClickHandler);
        const directParentClickHandler = ()=>{
            setTimeout(()=>{
                this.clearParentError(inputField, parentElement, options);
            }, options.errorClearDelay);
        };
        parentElement.addEventListener('click', directParentClickHandler);
        parentElement._validationDirectParentClickHandler = directParentClickHandler;
    }
    /**
   * Clear field error styling and remove error elements
   * @param {HTMLElement} inputField - The input field element
   * @param {HTMLElement} parentElement - Parent element of the field
   * @param {HTMLElement} errorTextElement - Error text element
   * @param {object} options - Validation options
   */ clearFieldError(inputField, parentElement, errorTextElement, options) {
        inputField.classList.remove('error', ...options.inputErrorClasses.split(' '));
        inputField.closest('form').classList.remove('error');
        if (inputField.closest('.meta-upload-file')) {
            const metaUploadFileEl = inputField.closest('.meta-upload-file');
            metaUploadFileEl.classList.remove('error');
        }
        const errorTextElements = parentElement.querySelectorAll('.error-text');
        errorTextElements.forEach((el)=>{
            if (el.parentElement) el.parentElement.classList.remove('error');
            el.remove();
        });
        if (inputField.tagName.toLowerCase() === 'select') {
            const selectParent = parentElement.parentElement;
            if (selectParent) {
                const selectErrorElements = selectParent.querySelectorAll('.error-text');
                selectErrorElements.forEach((el)=>{
                    if (el.parentElement) el.parentElement.classList.remove('error');
                    el.remove();
                });
                selectParent.classList.remove('error', ...options.selectErrorClasses.split(' '));
            }
        }
        if (inputField.name === 'cv_field') {
            const nextSibling = parentElement.nextElementSibling;
            if (nextSibling && nextSibling.classList.contains('error-text')) nextSibling.remove();
        }
    }
    /**
   * Clear parent error styling and remove error elements
   * @param {HTMLElement} inputField - The input field element
   * @param {HTMLElement} parentElement - Parent element of the field
   * @param {object} options - Validation options
   */ clearParentError(inputField, parentElement, options) {
        parentElement.classList.remove('error');
        inputField.closest('form').classList.remove('error');
        console.log('test', inputField.closest('.meta-upload-file'));
        if (inputField.closest('.meta-upload-file')) {
            const metaUploadFileEl = inputField.closest('.meta-upload-file');
            metaUploadFileEl.classList.remove('error');
            const errorTextsArr = metaUploadFileEl.querySelectorAll('.error-text');
            if (errorTextsArr.length) errorTextsArr.forEach((el)=>{
                el.remove();
            });
        }
        const errorTextElements = parentElement.querySelectorAll('.error-text');
        errorTextElements.forEach((el)=>{
            if (el.parentElement) el.parentElement.classList.remove('error');
            el.remove();
        });
        if (inputField.tagName.toLowerCase() === 'select') {
            const selectParent = parentElement.parentElement;
            if (selectParent) {
                const selectErrorElements = selectParent.querySelectorAll('.error-text');
                selectErrorElements.forEach((el)=>{
                    if (el.parentElement) el.parentElement.classList.remove('error');
                    el.remove();
                });
                selectParent.classList.remove('error', ...options.selectErrorClasses.split(' '));
            }
        }
        if (inputField.name === 'cv_field') {
            const nextSibling = parentElement.nextElementSibling;
            if (nextSibling && nextSibling.classList.contains('error-text')) nextSibling.remove();
        }
    }
    /**
   * Update all SimpleBar instances to recalculate their dimensions
   */ updateAllSimpleBars() {
        document.querySelectorAll('.simplebar-content').forEach((content)=>{
            const simpleBarInstance = SimpleBar.instances.get(content.closest('[data-simplebar]'));
            if (simpleBarInstance) simpleBarInstance.recalculate();
        });
    }
}
/**
 * Global form validation instance
 */ const $8a813c788bb79fef$var$formValidator = new $8a813c788bb79fef$var$FormValidator();
/**
 * Global form validation function for backward compatibility
 * @param {string|object} formData - Form data as string or object
 * @returns {object} Object containing field errors
 */ window.formValidation = function(formData) {
    return $8a813c788bb79fef$var$formValidator.validate(formData);
};


window.uploadFile = function uploadFile1() {
    if (document.querySelector('[data-upload-file-animation]')) {
        const uploadFileBlocksArr = document.querySelectorAll('[data-upload-file-animation]');
        uploadFileBlocksArr.forEach((fileUpload)=>{
            fileUpload.addEventListener('dragover', function() {
                this.classList.add('drag');
                this.classList.remove('drop', 'done');
            });
            fileUpload.addEventListener('dragleave', function() {
                this.classList.remove('drag');
            });
            fileUpload.addEventListener('drop', start, false);
            fileUpload.addEventListener('change', start, false);
            function start() {
                this.classList.remove('drag');
                this.classList.add('drop');
                setTimeout(()=>this.classList.add('done'), 650);
                setTimeout(function() {
                    const inputs = document.querySelectorAll('.meta-upload-file__input input.error');
                    if (!inputs.length) return;
                    inputs.forEach((input)=>{
                        input.classList.remove('error');
                        const errorWrapper = input.closest('.error');
                        if (errorWrapper) errorWrapper.classList.remove('error');
                        const uploadWrapper = input.closest('.meta-upload-file');
                        if (uploadWrapper) uploadWrapper.classList.remove('error');
                        const errorTextEl = uploadWrapper?.querySelector('.error-text');
                        if (errorTextEl) {
                            errorTextEl.style.opacity = '0';
                            errorTextEl.style.overflow = 'hidden';
                            errorTextEl.style.maxHeight = '0px';
                            errorTextEl.style.height = '0px';
                        }
                    });
                }, 650);
            }
            fileUpload.addEventListener('click', function() {
                fileUpload.classList.remove('error');
                const errorsElArr = fileUpload.querySelectorAll('.error');
                for(let i = 0; i < errorsElArr.length; i++)errorsElArr[i].classList.remove('error');
                const errorTextEl = fileUpload.querySelector('.error-text');
                if (errorTextEl) {
                    errorTextEl.style.opacity = '0';
                    errorTextEl.style.overflow = 'hidden';
                    errorTextEl.style.maxHeight = '0px';
                    errorTextEl.style.height = '0px';
                }
            });
        });
    }
};
uploadFile();
window.initMetaUploadFile = function initMetaUploadFile1() {
    const metaUploadFileArr = document.querySelectorAll('.meta-upload-file');
    metaUploadFileArr.forEach((metaUploadFile)=>{
        if (!metaUploadFile.classList.contains('is-init-meta-upload-file')) {
            metaUploadFile.classList.add('is-init-meta-upload-file');
            const fileNameEl = metaUploadFile.querySelector('[data-meta-upload-file-name]');
            const inputEl = metaUploadFile.querySelector('input');
            if (inputEl && fileNameEl) inputEl.addEventListener('change', ()=>{
                const file = inputEl.files?.[0];
                fileNameEl.textContent = file ? file.name : 'No file selected';
            });
        }
    });
};
initMetaUploadFile();


const $6ad400af65f406ec$var$headerComponent = document.getElementsByClassName('header')[0];
// Header scroll
if ($6ad400af65f406ec$var$headerComponent) {
    const scrollContainer = ()=>document.documentElement || document.body;
    document.addEventListener('scroll', ()=>{
        if (scrollContainer().scrollTop > 100) $6ad400af65f406ec$var$headerComponent.classList.add('scrolled');
        else if (scrollContainer().scrollTop == 0) $6ad400af65f406ec$var$headerComponent.classList.remove('scrolled');
    });
    // menu handlers
    // check mobile menu show/hide condition
    const mobileMenuStartPoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mobile-menu-start-point'));
    let isMobileMenuEnable = window.outerWidth <= mobileMenuStartPoint || document.querySelector('.header-mobile');
    const dropdownToggle = document.querySelectorAll('.dropdown-toggle');
    dropdownToggle.forEach((toggle)=>{
        toggle.addEventListener('click', function(e) {
            if (isMobileMenuEnable) {
                const menuItem = this.closest('.menu-item.dropdown');
                const dropdownMenu = this.nextElementSibling;
                // close all opened sub menu
                const activeDropdowns = document.querySelectorAll('.menu-item.dropdown.active .dropdown-menu');
                activeDropdowns.forEach((menu)=>{
                    menu.style.display = 'none';
                    menu.closest('.dropdown').classList.remove('active');
                });
                // open current submenu
                menuItem.classList.toggle('active');
                if (menuItem.classList.contains('active')) {
                    e.preventDefault();
                    dropdownMenu.style.display = 'block';
                }
            }
        });
    });
    // toggle menu handler
    function menuToggleFunc() {
        const menuToggle = document.querySelector('.menu-toggle');
        const navbarNav = document.querySelector('.navbar-nav');
        const headerCloseWrapper = document.querySelector('.header-close-wrapper');
        $6ad400af65f406ec$var$headerComponent.classList.toggle('is-open-menu');
        menuToggle.classList.toggle('active');
        navbarNav.classList.toggle('active');
        headerCloseWrapper.classList.toggle('active');
        // LockScroll when burger open and enable when closed and enable scroll on menu
        if (scrollLock.getScrollState()) {
            scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
            scrollLock.addScrollableSelector('.simplebar-content-wrapper');
        } else scrollLock.enablePageScroll();
    }
    // menu update function
    function updateMenu() {
        isMobileMenuEnable = window.outerWidth <= mobileMenuStartPoint || document.querySelector('.mobile-header');
        if (!isMobileMenuEnable) {
            const dropdownMenus = document.querySelectorAll('.dropdown-menu');
            dropdownMenus.forEach((menu)=>{
                menu.style.display = '';
            });
            const headerCloseWrapper = document.querySelector('.header-close-wrapper');
            headerCloseWrapper.classList.remove('active');
            const activeMenuItems = document.querySelectorAll('.menu-item.active');
            activeMenuItems.forEach((item)=>{
                item.classList.remove('active');
            });
            const navbarNav = document.querySelector('.navbar-nav');
            navbarNav.classList.remove('active');
            const menuToggle = document.querySelector('.menu-toggle');
            menuToggle.classList.remove('active');
            $6ad400af65f406ec$var$headerComponent.classList.remove('is-open-menu');
            // LockScroll when burger open and enable when closed
            scrollLock.enablePageScroll();
        }
    }
    window.addEventListener('resize', updateMenu);
    window.addEventListener('orientationchange', updateMenu);
    // end of toggle menu handler
    const menuToggle = document.querySelector('.menu-toggle');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');
    menuToggle.addEventListener('click', menuToggleFunc);
    headerCloseWrapper.addEventListener('click', menuToggleFunc);
    // Hide and show Header when scroll up
    function headerSticky() {
        let prevScrollPos = window.pageYOffset;
        document.onscroll = ()=>{
            const currentScrollPos = window.pageYOffset;
            const headerHeight = $6ad400af65f406ec$var$headerComponent.scrollHeight;
            if (window.scrollY > 0) {
                if (prevScrollPos > currentScrollPos) {
                    $6ad400af65f406ec$var$headerComponent.style.top = 0;
                    $6ad400af65f406ec$var$headerComponent.classList.add('scrolled');
                } else $6ad400af65f406ec$var$headerComponent.style.top = `-${headerHeight + 3}px`;
            }
            if (window.scrollY === 0) $6ad400af65f406ec$var$headerComponent.classList.remove('scrolled');
            prevScrollPos = currentScrollPos;
        };
        if (window.scrollY !== 0) $6ad400af65f406ec$var$headerComponent.classList.add('scrolled');
    }
    headerSticky();
}


window.autosizeTextarea = function autosizeTextarea1() {
    if (document.querySelector('textarea[data-autosize]')) {
        const autosizeTextareaElements = document.querySelectorAll('textarea[data-autosize]');
        autosizeTextareaElements.forEach((textarea)=>{
            const startHeight = textarea.offsetHeight;
            textarea.addEventListener('input', autosize);
            function autosize() {
                const el = this;
                const newHeight = el.scrollHeight;
                if (newHeight > startHeight) el.style.minHeight = `${el.scrollHeight}px`;
                else el.style.minHeight = startHeight;
            }
        });
    }
};
autosizeTextarea();


var $c63fa967237543b8$exports = {};
(function(f) {
    var g;
    $c63fa967237543b8$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(_e) {
                    var n = t[o][1][_e];
                    return s(n ? n : _e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(require1, module1, exports) {
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
                /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;
                function toObject(val) {
                    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
                    return Object(val);
                }
                function shouldUseNative() {
                    try {
                        if (!Object.assign) return false;
                        // Detect buggy property enumeration order in older V8 versions.
                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
                        test1[5] = 'de';
                        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
                        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                            return test2[n];
                        });
                        if (order2.join('') !== '0123456789') return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }
                module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
                    var from;
                    var to = toObject(target);
                    var symbols;
                    for(var s = 1; s < arguments.length; s++){
                        from = Object(arguments[s]);
                        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                        if (getOwnPropertySymbols) {
                            symbols = getOwnPropertySymbols(from);
                            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                        }
                    }
                    return to;
                };
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                (function(process) {
                    // Generated by CoffeeScript 1.12.2
                    (function() {
                        var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
                        if (typeof performance !== "undefined" && performance !== null && performance.now) module1.exports = function() {
                            return performance.now();
                        };
                        else if (typeof process !== "undefined" && process !== null && process.hrtime) {
                            module1.exports = function() {
                                return (getNanoSeconds() - nodeLoadTime) / 1e6;
                            };
                            hrtime = process.hrtime;
                            getNanoSeconds = function() {
                                var hr;
                                hr = hrtime();
                                return hr[0] * 1e9 + hr[1];
                            };
                            moduleLoadTime = getNanoSeconds();
                            upTime = process.uptime() * 1e9;
                            nodeLoadTime = moduleLoadTime - upTime;
                        } else if (Date.now) {
                            module1.exports = function() {
                                return Date.now() - loadTime;
                            };
                            loadTime = Date.now();
                        } else {
                            module1.exports = function() {
                                return new Date().getTime() - loadTime;
                            };
                            loadTime = new Date().getTime();
                        }
                    }).call(this);
                }).call(this, require1('_process'));
            },
            {
                "_process": 3
            }
        ],
        3: [
            function(require1, module1, exports) {
                // shim for using process in browser
                var process = module1.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error('setTimeout has not been defined');
                }
                function defaultClearTimeout() {
                    throw new Error('clearTimeout has not been defined');
                }
                (function() {
                    try {
                        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = 'browser';
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ''; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error('process.binding is not supported');
                };
                process.cwd = function() {
                    return '/';
                };
                process.chdir = function(dir) {
                    throw new Error('process.chdir is not supported');
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        4: [
            function(require1, module1, exports) {
                (function(global1) {
                    var now = require1('performance-now'), root = typeof window === 'undefined' ? global1 : window, vendors = [
                        'moz',
                        'webkit'
                    ], suffix = 'AnimationFrame', raf = root['request' + suffix], caf = root['cancel' + suffix] || root['cancelRequest' + suffix];
                    for(var i = 0; !raf && i < vendors.length; i++){
                        raf = root[vendors[i] + 'Request' + suffix];
                        caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
                    }
                    // Some versions of FF have rAF but not cAF
                    if (!raf || !caf) {
                        var last = 0, id = 0, queue = [], frameDuration = 1000 / 60;
                        raf = function(callback) {
                            if (queue.length === 0) {
                                var _now = now(), next = Math.max(0, frameDuration - (_now - last));
                                last = next + _now;
                                setTimeout(function() {
                                    var cp = queue.slice(0);
                                    // Clear queue here to prevent
                                    // callbacks from appending listeners
                                    // to the current frame's queue
                                    queue.length = 0;
                                    for(var i = 0; i < cp.length; i++){
                                        if (!cp[i].cancelled) try {
                                            cp[i].callback(last);
                                        } catch (e) {
                                            setTimeout(function() {
                                                throw e;
                                            }, 0);
                                        }
                                    }
                                }, Math.round(next));
                            }
                            queue.push({
                                handle: ++id,
                                callback: callback,
                                cancelled: false
                            });
                            return id;
                        };
                        caf = function(handle) {
                            for(var i = 0; i < queue.length; i++)if (queue[i].handle === handle) queue[i].cancelled = true;
                        };
                    }
                    module1.exports = function(fn) {
                        // Wrap in a new function to prevent
                        // `cancel` potentially being assigned
                        // to the native rAF function
                        return raf.call(root, fn);
                    };
                    module1.exports.cancel = function() {
                        caf.apply(root, arguments);
                    };
                    module1.exports.polyfill = function() {
                        root.requestAnimationFrame = raf;
                        root.cancelAnimationFrame = caf;
                    };
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "performance-now": 2
            }
        ],
        5: [
            function(require1, module1, exports) {
                'use strict';
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                /**
* Parallax.js
* @author Matthew Wagerfield - @wagerfield, René Roth - mail@reneroth.org
* @description Creates a parallax effect between an array of layers,
*              driving the motion from the gyroscope output of a smartdevice.
*              If no gyroscope is available, the cursor position is used.
*/ var rqAnFr = require1('raf');
                var objectAssign = require1('object-assign');
                var helpers = {
                    propertyCache: {},
                    vendors: [
                        null,
                        [
                            '-webkit-',
                            'webkit'
                        ],
                        [
                            '-moz-',
                            'Moz'
                        ],
                        [
                            '-o-',
                            'O'
                        ],
                        [
                            '-ms-',
                            'ms'
                        ]
                    ],
                    clamp: function clamp(value, min, max) {
                        return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
                    },
                    data: function data(element, name) {
                        return helpers.deserialize(element.getAttribute('data-' + name));
                    },
                    deserialize: function deserialize(value) {
                        if (value === 'true') return true;
                        else if (value === 'false') return false;
                        else if (value === 'null') return null;
                        else if (!isNaN(parseFloat(value)) && isFinite(value)) return parseFloat(value);
                        else return value;
                    },
                    camelCase: function camelCase(value) {
                        return value.replace(/-+(.)?/g, function(match, character) {
                            return character ? character.toUpperCase() : '';
                        });
                    },
                    accelerate: function accelerate(element) {
                        helpers.css(element, 'transform', 'translate3d(0,0,0) rotate(0.0001deg)');
                        helpers.css(element, 'transform-style', 'preserve-3d');
                        helpers.css(element, 'backface-visibility', 'hidden');
                    },
                    transformSupport: function transformSupport(value) {
                        var element = document.createElement('div'), propertySupport = false, propertyValue = null, featureSupport = false, cssProperty = null, jsProperty = null;
                        for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) {
                                cssProperty = helpers.vendors[i][0] + 'transform';
                                jsProperty = helpers.vendors[i][1] + 'Transform';
                            } else {
                                cssProperty = 'transform';
                                jsProperty = 'transform';
                            }
                            if (element.style[jsProperty] !== undefined) {
                                propertySupport = true;
                                break;
                            }
                        }
                        switch(value){
                            case '2D':
                                featureSupport = propertySupport;
                                break;
                            case '3D':
                                if (propertySupport) {
                                    var body = document.body || document.createElement('body'), documentElement = document.documentElement, documentOverflow = documentElement.style.overflow, isCreatedBody = false;
                                    if (!document.body) {
                                        isCreatedBody = true;
                                        documentElement.style.overflow = 'hidden';
                                        documentElement.appendChild(body);
                                        body.style.overflow = 'hidden';
                                        body.style.background = '';
                                    }
                                    body.appendChild(element);
                                    element.style[jsProperty] = 'translate3d(1px,1px,1px)';
                                    propertyValue = window.getComputedStyle(element).getPropertyValue(cssProperty);
                                    featureSupport = propertyValue !== undefined && propertyValue.length > 0 && propertyValue !== 'none';
                                    documentElement.style.overflow = documentOverflow;
                                    body.removeChild(element);
                                    if (isCreatedBody) {
                                        body.removeAttribute('style');
                                        body.parentNode.removeChild(body);
                                    }
                                }
                                break;
                        }
                        return featureSupport;
                    },
                    css: function css(element, property, value) {
                        var jsProperty = helpers.propertyCache[property];
                        if (!jsProperty) for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) jsProperty = helpers.camelCase(helpers.vendors[i][1] + '-' + property);
                            else jsProperty = property;
                            if (element.style[jsProperty] !== undefined) {
                                helpers.propertyCache[property] = jsProperty;
                                break;
                            }
                        }
                        element.style[jsProperty] = value;
                    }
                };
                var MAGIC_NUMBER = 30, DEFAULTS = {
                    relativeInput: false,
                    clipRelativeInput: false,
                    inputElement: null,
                    hoverOnly: false,
                    calibrationThreshold: 100,
                    calibrationDelay: 500,
                    supportDelay: 500,
                    calibrateX: false,
                    calibrateY: true,
                    invertX: true,
                    invertY: true,
                    limitX: false,
                    limitY: false,
                    scalarX: 10.0,
                    scalarY: 10.0,
                    frictionX: 0.1,
                    frictionY: 0.1,
                    originX: 0.5,
                    originY: 0.5,
                    pointerEvents: false,
                    precision: 1,
                    onReady: null,
                    selector: null
                };
                var Parallax = function() {
                    function Parallax(element, options) {
                        _classCallCheck(this, Parallax);
                        this.element = element;
                        var data = {
                            calibrateX: helpers.data(this.element, 'calibrate-x'),
                            calibrateY: helpers.data(this.element, 'calibrate-y'),
                            invertX: helpers.data(this.element, 'invert-x'),
                            invertY: helpers.data(this.element, 'invert-y'),
                            limitX: helpers.data(this.element, 'limit-x'),
                            limitY: helpers.data(this.element, 'limit-y'),
                            scalarX: helpers.data(this.element, 'scalar-x'),
                            scalarY: helpers.data(this.element, 'scalar-y'),
                            frictionX: helpers.data(this.element, 'friction-x'),
                            frictionY: helpers.data(this.element, 'friction-y'),
                            originX: helpers.data(this.element, 'origin-x'),
                            originY: helpers.data(this.element, 'origin-y'),
                            pointerEvents: helpers.data(this.element, 'pointer-events'),
                            precision: helpers.data(this.element, 'precision'),
                            relativeInput: helpers.data(this.element, 'relative-input'),
                            clipRelativeInput: helpers.data(this.element, 'clip-relative-input'),
                            hoverOnly: helpers.data(this.element, 'hover-only'),
                            inputElement: document.querySelector(helpers.data(this.element, 'input-element')),
                            selector: helpers.data(this.element, 'selector')
                        };
                        for(var key in data)if (data[key] === null) delete data[key];
                        objectAssign(this, DEFAULTS, data, options);
                        if (!this.inputElement) this.inputElement = this.element;
                        this.calibrationTimer = null;
                        this.calibrationFlag = true;
                        this.enabled = false;
                        this.depthsX = [];
                        this.depthsY = [];
                        this.raf = null;
                        this.bounds = null;
                        this.elementPositionX = 0;
                        this.elementPositionY = 0;
                        this.elementWidth = 0;
                        this.elementHeight = 0;
                        this.elementCenterX = 0;
                        this.elementCenterY = 0;
                        this.elementRangeX = 0;
                        this.elementRangeY = 0;
                        this.calibrationX = 0;
                        this.calibrationY = 0;
                        this.inputX = 0;
                        this.inputY = 0;
                        this.motionX = 0;
                        this.motionY = 0;
                        this.velocityX = 0;
                        this.velocityY = 0;
                        this.onMouseMove = this.onMouseMove.bind(this);
                        this.onDeviceOrientation = this.onDeviceOrientation.bind(this);
                        this.onDeviceMotion = this.onDeviceMotion.bind(this);
                        this.onOrientationTimer = this.onOrientationTimer.bind(this);
                        this.onMotionTimer = this.onMotionTimer.bind(this);
                        this.onCalibrationTimer = this.onCalibrationTimer.bind(this);
                        this.onAnimationFrame = this.onAnimationFrame.bind(this);
                        this.onWindowResize = this.onWindowResize.bind(this);
                        this.windowWidth = null;
                        this.windowHeight = null;
                        this.windowCenterX = null;
                        this.windowCenterY = null;
                        this.windowRadiusX = null;
                        this.windowRadiusY = null;
                        this.portrait = false;
                        this.desktop = !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i);
                        this.motionSupport = !!window.DeviceMotionEvent && !this.desktop;
                        this.orientationSupport = !!window.DeviceOrientationEvent && !this.desktop;
                        this.orientationStatus = 0;
                        this.motionStatus = 0;
                        this.initialise();
                    }
                    _createClass(Parallax, [
                        {
                            key: 'initialise',
                            value: function initialise() {
                                if (this.transform2DSupport === undefined) {
                                    this.transform2DSupport = helpers.transformSupport('2D');
                                    this.transform3DSupport = helpers.transformSupport('3D');
                                }
                                // Configure Context Styles
                                if (this.transform3DSupport) helpers.accelerate(this.element);
                                var style = window.getComputedStyle(this.element);
                                if (style.getPropertyValue('position') === 'static') this.element.style.position = 'relative';
                                // Pointer events
                                if (!this.pointerEvents) this.element.style.pointerEvents = 'none';
                                // Setup
                                this.updateLayers();
                                this.updateDimensions();
                                this.enable();
                                this.queueCalibration(this.calibrationDelay);
                            }
                        },
                        {
                            key: 'doReadyCallback',
                            value: function doReadyCallback() {
                                if (this.onReady) this.onReady();
                            }
                        },
                        {
                            key: 'updateLayers',
                            value: function updateLayers() {
                                if (this.selector) this.layers = this.element.querySelectorAll(this.selector);
                                else this.layers = this.element.children;
                                if (!this.layers.length) console.warn('ParallaxJS: Your scene does not have any layers.');
                                this.depthsX = [];
                                this.depthsY = [];
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index];
                                    if (this.transform3DSupport) helpers.accelerate(layer);
                                    layer.style.position = index ? 'absolute' : 'relative';
                                    layer.style.display = 'block';
                                    layer.style.left = 0;
                                    layer.style.top = 0;
                                    var depth = helpers.data(layer, 'depth') || 0;
                                    this.depthsX.push(helpers.data(layer, 'depth-x') || depth);
                                    this.depthsY.push(helpers.data(layer, 'depth-y') || depth);
                                }
                            }
                        },
                        {
                            key: 'updateDimensions',
                            value: function updateDimensions() {
                                this.windowWidth = window.innerWidth;
                                this.windowHeight = window.innerHeight;
                                this.windowCenterX = this.windowWidth * this.originX;
                                this.windowCenterY = this.windowHeight * this.originY;
                                this.windowRadiusX = Math.max(this.windowCenterX, this.windowWidth - this.windowCenterX);
                                this.windowRadiusY = Math.max(this.windowCenterY, this.windowHeight - this.windowCenterY);
                            }
                        },
                        {
                            key: 'updateBounds',
                            value: function updateBounds() {
                                this.bounds = this.inputElement.getBoundingClientRect();
                                this.elementPositionX = this.bounds.left;
                                this.elementPositionY = this.bounds.top;
                                this.elementWidth = this.bounds.width;
                                this.elementHeight = this.bounds.height;
                                this.elementCenterX = this.elementWidth * this.originX;
                                this.elementCenterY = this.elementHeight * this.originY;
                                this.elementRangeX = Math.max(this.elementCenterX, this.elementWidth - this.elementCenterX);
                                this.elementRangeY = Math.max(this.elementCenterY, this.elementHeight - this.elementCenterY);
                            }
                        },
                        {
                            key: 'queueCalibration',
                            value: function queueCalibration(delay) {
                                clearTimeout(this.calibrationTimer);
                                this.calibrationTimer = setTimeout(this.onCalibrationTimer, delay);
                            }
                        },
                        {
                            key: 'enable',
                            value: function enable() {
                                if (this.enabled) return;
                                this.enabled = true;
                                if (this.orientationSupport) {
                                    this.portrait = false;
                                    window.addEventListener('deviceorientation', this.onDeviceOrientation);
                                    this.detectionTimer = setTimeout(this.onOrientationTimer, this.supportDelay);
                                } else if (this.motionSupport) {
                                    this.portrait = false;
                                    window.addEventListener('devicemotion', this.onDeviceMotion);
                                    this.detectionTimer = setTimeout(this.onMotionTimer, this.supportDelay);
                                } else {
                                    this.calibrationX = 0;
                                    this.calibrationY = 0;
                                    this.portrait = false;
                                    window.addEventListener('mousemove', this.onMouseMove);
                                    this.doReadyCallback();
                                }
                                window.addEventListener('resize', this.onWindowResize);
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: 'disable',
                            value: function disable() {
                                if (!this.enabled) return;
                                this.enabled = false;
                                if (this.orientationSupport) window.removeEventListener('deviceorientation', this.onDeviceOrientation);
                                else if (this.motionSupport) window.removeEventListener('devicemotion', this.onDeviceMotion);
                                else window.removeEventListener('mousemove', this.onMouseMove);
                                window.removeEventListener('resize', this.onWindowResize);
                                rqAnFr.cancel(this.raf);
                            }
                        },
                        {
                            key: 'calibrate',
                            value: function calibrate(x, y) {
                                this.calibrateX = x === undefined ? this.calibrateX : x;
                                this.calibrateY = y === undefined ? this.calibrateY : y;
                            }
                        },
                        {
                            key: 'invert',
                            value: function invert(x, y) {
                                this.invertX = x === undefined ? this.invertX : x;
                                this.invertY = y === undefined ? this.invertY : y;
                            }
                        },
                        {
                            key: 'friction',
                            value: function friction(x, y) {
                                this.frictionX = x === undefined ? this.frictionX : x;
                                this.frictionY = y === undefined ? this.frictionY : y;
                            }
                        },
                        {
                            key: 'scalar',
                            value: function scalar(x, y) {
                                this.scalarX = x === undefined ? this.scalarX : x;
                                this.scalarY = y === undefined ? this.scalarY : y;
                            }
                        },
                        {
                            key: 'limit',
                            value: function limit(x, y) {
                                this.limitX = x === undefined ? this.limitX : x;
                                this.limitY = y === undefined ? this.limitY : y;
                            }
                        },
                        {
                            key: 'origin',
                            value: function origin(x, y) {
                                this.originX = x === undefined ? this.originX : x;
                                this.originY = y === undefined ? this.originY : y;
                            }
                        },
                        {
                            key: 'setInputElement',
                            value: function setInputElement(element) {
                                this.inputElement = element;
                                this.updateDimensions();
                            }
                        },
                        {
                            key: 'setPosition',
                            value: function setPosition(element, x, y) {
                                x = x.toFixed(this.precision) + 'px';
                                y = y.toFixed(this.precision) + 'px';
                                if (this.transform3DSupport) helpers.css(element, 'transform', 'translate3d(' + x + ',' + y + ',0)');
                                else if (this.transform2DSupport) helpers.css(element, 'transform', 'translate(' + x + ',' + y + ')');
                                else {
                                    element.style.left = x;
                                    element.style.top = y;
                                }
                            }
                        },
                        {
                            key: 'onOrientationTimer',
                            value: function onOrientationTimer() {
                                if (this.orientationSupport && this.orientationStatus === 0) {
                                    this.disable();
                                    this.orientationSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: 'onMotionTimer',
                            value: function onMotionTimer() {
                                if (this.motionSupport && this.motionStatus === 0) {
                                    this.disable();
                                    this.motionSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: 'onCalibrationTimer',
                            value: function onCalibrationTimer() {
                                this.calibrationFlag = true;
                            }
                        },
                        {
                            key: 'onWindowResize',
                            value: function onWindowResize() {
                                this.updateDimensions();
                            }
                        },
                        {
                            key: 'onAnimationFrame',
                            value: function onAnimationFrame() {
                                this.updateBounds();
                                var calibratedInputX = this.inputX - this.calibrationX, calibratedInputY = this.inputY - this.calibrationY;
                                if (Math.abs(calibratedInputX) > this.calibrationThreshold || Math.abs(calibratedInputY) > this.calibrationThreshold) this.queueCalibration(0);
                                if (this.portrait) {
                                    this.motionX = this.calibrateX ? calibratedInputY : this.inputY;
                                    this.motionY = this.calibrateY ? calibratedInputX : this.inputX;
                                } else {
                                    this.motionX = this.calibrateX ? calibratedInputX : this.inputX;
                                    this.motionY = this.calibrateY ? calibratedInputY : this.inputY;
                                }
                                this.motionX *= this.elementWidth * (this.scalarX / 100);
                                this.motionY *= this.elementHeight * (this.scalarY / 100);
                                if (!isNaN(parseFloat(this.limitX))) this.motionX = helpers.clamp(this.motionX, -this.limitX, this.limitX);
                                if (!isNaN(parseFloat(this.limitY))) this.motionY = helpers.clamp(this.motionY, -this.limitY, this.limitY);
                                this.velocityX += (this.motionX - this.velocityX) * this.frictionX;
                                this.velocityY += (this.motionY - this.velocityY) * this.frictionY;
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index], depthX = this.depthsX[index], depthY = this.depthsY[index], xOffset = this.velocityX * (depthX * (this.invertX ? -1 : 1)), yOffset = this.velocityY * (depthY * (this.invertY ? -1 : 1));
                                    this.setPosition(layer, xOffset, yOffset);
                                }
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: 'rotate',
                            value: function rotate(beta, gamma) {
                                // Extract Rotation
                                var x = (beta || 0) / MAGIC_NUMBER, //  -90 :: 90
                                y = (gamma || 0) / MAGIC_NUMBER; // -180 :: 180
                                // Detect Orientation Change
                                var portrait = this.windowHeight > this.windowWidth;
                                if (this.portrait !== portrait) {
                                    this.portrait = portrait;
                                    this.calibrationFlag = true;
                                }
                                if (this.calibrationFlag) {
                                    this.calibrationFlag = false;
                                    this.calibrationX = x;
                                    this.calibrationY = y;
                                }
                                this.inputX = x;
                                this.inputY = y;
                            }
                        },
                        {
                            key: 'onDeviceOrientation',
                            value: function onDeviceOrientation(event) {
                                var beta = event.beta;
                                var gamma = event.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.orientationStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: 'onDeviceMotion',
                            value: function onDeviceMotion(event) {
                                var beta = event.rotationRate.beta;
                                var gamma = event.rotationRate.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.motionStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: 'onMouseMove',
                            value: function onMouseMove(event) {
                                var clientX = event.clientX, clientY = event.clientY;
                                // reset input to center if hoverOnly is set and we're not hovering the element
                                if (this.hoverOnly && (clientX < this.elementPositionX || clientX > this.elementPositionX + this.elementWidth || clientY < this.elementPositionY || clientY > this.elementPositionY + this.elementHeight)) {
                                    this.inputX = 0;
                                    this.inputY = 0;
                                    return;
                                }
                                if (this.relativeInput) {
                                    // Clip mouse coordinates inside element bounds.
                                    if (this.clipRelativeInput) {
                                        clientX = Math.max(clientX, this.elementPositionX);
                                        clientX = Math.min(clientX, this.elementPositionX + this.elementWidth);
                                        clientY = Math.max(clientY, this.elementPositionY);
                                        clientY = Math.min(clientY, this.elementPositionY + this.elementHeight);
                                    }
                                    // Calculate input relative to the element.
                                    if (this.elementRangeX && this.elementRangeY) {
                                        this.inputX = (clientX - this.elementPositionX - this.elementCenterX) / this.elementRangeX;
                                        this.inputY = (clientY - this.elementPositionY - this.elementCenterY) / this.elementRangeY;
                                    }
                                } else // Calculate input relative to the window.
                                if (this.windowRadiusX && this.windowRadiusY) {
                                    this.inputX = (clientX - this.windowCenterX) / this.windowRadiusX;
                                    this.inputY = (clientY - this.windowCenterY) / this.windowRadiusY;
                                }
                            }
                        },
                        {
                            key: 'destroy',
                            value: function destroy() {
                                this.disable();
                                clearTimeout(this.calibrationTimer);
                                clearTimeout(this.detectionTimer);
                                this.element.removeAttribute('style');
                                for(var index = 0; index < this.layers.length; index++)this.layers[index].removeAttribute('style');
                                delete this.element;
                                delete this.layers;
                            }
                        },
                        {
                            key: 'version',
                            value: function version() {
                                return '3.1.0';
                            }
                        }
                    ]);
                    return Parallax;
                }();
                module1.exports = Parallax;
            },
            {
                "object-assign": 1,
                "raf": 4
            }
        ]
    }, {}, [
        5
    ])(5);
});


if (document.querySelector('[data-parallax-el]') && window.innerWidth >= 1025) {
    const parallaxContainer = document.querySelectorAll('[data-parallax-el]');
    parallaxContainer.forEach((elem)=>{
        let parallaxInstance = new (0, (/*@__PURE__*/$parcel$interopDefault($c63fa967237543b8$exports)))(elem);
        parallaxInstance.enable();
    });
}
if (document.querySelector('[data-splitting-title]')) {
    const splittingArr = document.querySelectorAll('[data-splitting-title]');
    splittingArr.forEach((item)=>{
        Splitting({
            target: item,
            by: 'words'
        });
    });
}
if (document.querySelector('[data-splitting-chars]')) {
    const splittingArr = document.querySelectorAll('[data-splitting-chars]');
    splittingArr.forEach((item)=>{
        Splitting({
            target: item,
            by: 'chars'
        });
    });
}


window.plyrInit = function plyrInit1() {
    const videoPlayer = document.getElementsByClassName('video-player')[0];
    if (videoPlayer) {
        const videoPlayersArr = document.querySelectorAll('.video-player');
        for(let i = 0; i < videoPlayersArr.length; i++)if (!videoPlayersArr[i].classList.contains('is-init')) {
            videoPlayersArr[i].classList.add('is-init');
            const parentEl = videoPlayersArr[i].parentElement;
            let ratio = window.innerWidth >= 640 ? '16:9' : '16:11';
            const player = new Plyr(videoPlayersArr[i], {
                controls: [
                    'play-large',
                    'play',
                    'progress',
                    'current-time',
                    'mute',
                    'volume',
                    'captions',
                    'settings',
                    'fullscreen',
                    'pip',
                    'airplay'
                ],
                ratio: ratio,
                tooltips: {
                    controls: !0
                },
                fullscreen: {
                    iosNative: true
                }
            });
            player.on('enterfullscreen', function() {
                console.log('enterfullscreen');
            });
            player.on('exitfullscreen', function() {
                console.log('exitfullscreen');
            });
            player.on('play', function() {
                parentEl.classList.add('is-played');
            });
            player.on('pause', function() {
                parentEl.classList.remove('is-played');
            });
            // Expose player so it can be used from the console
            window.player = player;
            if (window.innerWidth >= 1024) setTimeout(function() {
                const plyrArr = document.querySelectorAll('.plyr');
                for(let j = 0; j < plyrArr.length; j++)plyrArr[i].classList.add('plyr-hide-controls');
                plyrArr[i].addEventListener('mouseenter', ()=>{
                    plyrArr[i].classList.remove('plyr-hide-controls');
                });
                plyrArr[i].addEventListener('mouseleave', ()=>{
                    plyrArr[i].classList.add('plyr-hide-controls');
                });
            }, 300);
        }
    }
};
plyrInit();


/**
 * Function to getPosition of element in DOM
 * **/ function $02801b378bcbcc88$export$1690e12b840569b9(element) {
    var xPosition = 0;
    var yPosition = 0;
    while(element){
        xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
        yPosition += element.offsetTop - element.scrollTop + element.clientTop;
        element = element.offsetParent;
    }
    return {
        x: xPosition,
        y: yPosition
    };
}
function $02801b378bcbcc88$export$eebd1d6b9908ac73(element, classname) {
    if (element.className.split(' ').indexOf(classname) >= 0) return true;
    return element.parentNode && $02801b378bcbcc88$export$eebd1d6b9908ac73(element.parentNode, classname);
}
function $02801b378bcbcc88$export$ff7f7c97cdce86e(arr, needle) {
    return arr.reduce((a, b)=>{
        return Math.abs(b - needle) < Math.abs(a - needle) ? b : a;
    });
}
const $02801b378bcbcc88$export$ef7b59bbfcfa5534 = (defaultValue, callback, callAfterInit = false)=>{
    const proxyHandler = {
        set (obj, prop, value) {
            if (prop === 'value') {
                obj[prop] = value;
                callback(value);
                return true;
            }
            return true;
        }
    };
    if (callAfterInit) callback(defaultValue);
    return new Proxy({
        value: defaultValue
    }, proxyHandler);
};


const $2d81c8b5028a8743$export$7d21786059c86dc = ({ sidebar: sidebar, contentSticky: contentSticky, sidebarInnerSelector: sidebarInnerSelector = '.following-sidebar-inner', isHeaderCalc: // calc header height for top side gap
isHeaderCalc = false, gap: // gap on top and bottom of sticky sidebar
gap = 130 })=>{
    console.log(sidebar);
    const sidebarInner = sidebar.querySelector(sidebarInnerSelector);
    const sidebarBuffer = document.createElement('DIV');
    sidebarBuffer.classList.add('following-sidebar-buffer');
    sidebarInner.style.position = 'sticky';
    const header = document.querySelector('header');
    sidebar.insertAdjacentElement('afterbegin', sidebarBuffer);
    const headerHeight = isHeaderCalc && header ? header.offsetHeight : 0;
    let lastScrollTop = 0;
    // if flag true === scrolling down else scrolling up
    let isScrollingDown = null;
    // if isSidebarHigherViewport true === sidebar is higher than viewport height
    let isSidebarHigherViewport = sidebarInner.getBoundingClientRect().height > window.innerHeight - headerHeight;
    function calcHeightOfSidebar(isScrollingDown) {
        const contentStickyTop = (0, $02801b378bcbcc88$export$1690e12b840569b9)(contentSticky).y;
        const sidebarInnerTop = (0, $02801b378bcbcc88$export$1690e12b840569b9)(sidebarInner).y;
        sidebarBuffer.style.height = `${sidebarInnerTop - contentStickyTop}px`;
        if (isScrollingDown) {
            // scroll down
            sidebarInner.style.top = '';
            sidebarInner.style.bottom = `${-headerHeight - gap + window.innerHeight - sidebarInner.getBoundingClientRect().height}px`;
        } else {
            // scroll up
            sidebarInner.style.bottom = '';
            sidebarInner.style.top = `${Math.min(window.innerHeight - sidebarInner.getBoundingClientRect().height, headerHeight) - gap}px`;
        }
        isSidebarHigherViewport = sidebarInner.getBoundingClientRect().height > window.innerHeight - headerHeight;
    }
    function resetSticky() {
        sidebarInner.style.bottom = '';
        sidebarInner.style.top = `${headerHeight + gap}px`;
        sidebarBuffer.style.height = '0';
    }
    if (!isSidebarHigherViewport) resetSticky();
    else calcHeightOfSidebar(false);
    window.addEventListener('scroll', function() {
        let st = window.scrollY || document.documentElement.scrollTop;
        if (!isSidebarHigherViewport) resetSticky();
        if (st > lastScrollTop && !isScrollingDown) {
            // scroll down
            calcHeightOfSidebar(isScrollingDown);
            isScrollingDown = true;
        } else if (st < lastScrollTop && isScrollingDown) {
            // scroll up
            calcHeightOfSidebar(isScrollingDown);
            isScrollingDown = false;
        }
        lastScrollTop = st <= 0 ? 0 : st;
    });
    const updateSidebar = ()=>{
        if (!isSidebarHigherViewport) resetSticky();
        calcHeightOfSidebar(true);
        calcHeightOfSidebar(false);
    };
    let windowWidth = window.innerWidth;
    window.addEventListener('resize', ()=>{
        if (windowWidth !== window.innerWidth) {
            windowWidth = window.innerWidth;
            updateSidebar();
        }
    });
};


const $0aef0301946e5878$var$searchSection = document.querySelector('.search-sec');
if ($0aef0301946e5878$var$searchSection) {
    const sidebar = $0aef0301946e5878$var$searchSection.querySelector('#sidebar');
    const contentSticky = $0aef0301946e5878$var$searchSection.querySelector('#content-sticky');
    const filtersBtn = $0aef0301946e5878$var$searchSection.querySelector('#filters-btn');
    const submitBtn = $0aef0301946e5878$var$searchSection.querySelector('.submit_btn');
    const contentResult = $0aef0301946e5878$var$searchSection.querySelector('#content-result');
    const isColumnTypeSec = $0aef0301946e5878$var$searchSection.classList.contains('column-type');
    if (sidebar && window.innerWidth >= 852 && !isColumnTypeSec) (0, $2d81c8b5028a8743$export$7d21786059c86dc)({
        sidebar: sidebar,
        contentSticky: contentSticky
    });
    if (filtersBtn) {
        filtersBtn.addEventListener('click', ()=>{
            filtersBtn.classList.toggle('is-open-filters');
            sidebar.classList.toggle('is-open-filters');
            contentSticky.classList.toggle('is-open-filters');
            contentResult.classList.toggle('is-open-filters');
        });
        submitBtn?.addEventListener('click', ()=>{
            filtersBtn.classList.toggle('is-open-filters');
            sidebar.classList.toggle('is-open-filters');
            contentSticky.classList.toggle('is-open-filters');
            contentResult.classList.toggle('is-open-filters');
        });
        contentResult.addEventListener('click', ()=>{
            if (contentResult.classList.contains('is-open-filters')) {
                filtersBtn.classList.remove('is-open-filters');
                sidebar.classList.remove('is-open-filters');
                contentSticky.classList.remove('is-open-filters');
                contentResult.classList.remove('is-open-filters');
            }
        });
    }
} /*if (document.getElementsByClassName('job-search-section__form')[0]) {
  const checkboxesTypes = document.querySelectorAll(
    'input[type="checkbox"][name="type[]"], input[type="checkbox"][name="type_second[]"]'
  );

  function syncCheckboxes(event) {
    const targetCheckbox = event.target;
    const isChecked = targetCheckbox.checked;
    const targetValue = targetCheckbox.value;

    checkboxesTypes.forEach((checkbox) => {
      if (checkbox.value === targetValue) {
        checkbox.checked = isChecked;
      }
    });
  }

  checkboxesTypes.forEach((checkbox) => {
    checkbox.addEventListener('change', syncCheckboxes);
  });

  const checkboxesSectors = document.querySelectorAll(
    'input[type="checkbox"][name="sector[]"], input[type="checkbox"][name="sector_second[]"]'
  );

  function syncCheckboxesSectors(event) {
    const targetCheckbox = event.target;
    const isChecked = targetCheckbox.checked;
    const targetValue = targetCheckbox.value;

    checkboxesSectors.forEach((checkbox) => {
      if (checkbox.value === targetValue) {
        checkbox.checked = isChecked;
      }
    });
  }

  checkboxesSectors.forEach((checkbox) => {
    checkbox.addEventListener('change', syncCheckboxesSectors);
  });
}*/ 


const $84a416155f33d641$var$connectToggles = document.querySelectorAll('.connect-sec__toggle'), $84a416155f33d641$var$connectForms = document.querySelectorAll('.connect-sec__form');
if ($84a416155f33d641$var$connectToggles.length) {
    $84a416155f33d641$var$connectToggles[0].classList.add('active');
    $84a416155f33d641$var$connectForms[0].classList.add('active');
    $84a416155f33d641$var$connectToggles?.forEach((toggle, i)=>{
        toggle.addEventListener('click', ()=>{
            $84a416155f33d641$var$connectToggles.forEach((t)=>t.classList.remove('active'));
            toggle.classList.add('active');
            $84a416155f33d641$var$connectForms.forEach((f)=>f.classList.remove('active'));
            $84a416155f33d641$var$connectForms[i].classList.add('active');
        });
    });
}


// Инициализация всех секций с миссией на странице
const $9deab51236adcadd$var$initMissionSections = ()=>{
    const sections = document.querySelectorAll('.our-mission-sec');
    sections.forEach((section)=>{
        const images = section.querySelectorAll('.our-mission-sec__image');
        const items = section.querySelectorAll('.our-mission-sec__item');
        // Проверка наличия элементов списка
        if (!items.length) return;
        let activeIndex = 0;
        const hasImages = images.length > 0;
        const prevArrows = section.querySelectorAll('.swiper-button-prev');
        const nextArrows = section.querySelectorAll('.swiper-button-next');
        /**
     * Обновляет высоту активного элемента
     * @param {number} index - индекс активного элемента
     */ const updateHeight = (index)=>{
            const activeItem = items[index];
            if (!activeItem) return;
            activeItem.classList.add('active');
            const itemBody = activeItem.querySelector('.our-mission-sec__item-body');
            if (itemBody) itemBody.style.maxHeight = `${itemBody.scrollHeight + 80}px`;
        };
        /**
     * Обновляет состояние секции (активные элементы и изображения)
     * @param {number} index - индекс нового активного элемента
     */ const updateState = (index)=>{
            // Сброс всех элементов
            items.forEach((item)=>{
                item.classList.remove('active');
                const body = item.querySelector('.our-mission-sec__item-body');
                if (body) body.style.maxHeight = null;
            });
            // Сброс изображений (только если они есть)
            if (hasImages) images.forEach((img)=>{
                img.classList.remove('active');
                img.style.display = 'none';
                img.style.opacity = '0';
            });
            // Активация текущего элемента
            updateHeight(index);
            // Активация текущего изображения (только если изображения присутствуют)
            if (hasImages && images[index]) {
                const activeImage = images[index];
                activeImage.style.display = 'block';
                requestAnimationFrame(()=>{
                    activeImage.style.opacity = '1';
                    activeImage.classList.add('active');
                });
            }
            // Обновление состояния стрелок навигации
            prevArrows.forEach((arrow)=>{
                arrow.classList.toggle('disabled', index === 0);
            });
            nextArrows.forEach((arrow)=>{
                arrow.classList.toggle('disabled', index === items.length - 1);
            });
        };
        // Инициализация начального состояния
        updateState(activeIndex);
        // Обработчики кликов на элементах списка
        items.forEach((item, index)=>{
            const itemNav = item.querySelector('.our-mission-sec__item-nav');
            if (!itemNav) return;
            itemNav.addEventListener('click', ()=>{
                if (index === activeIndex) return;
                activeIndex = index;
                updateState(activeIndex);
            });
        });
        // Обработчики кликов на стрелках "назад"
        prevArrows.forEach((arrow)=>{
            arrow.addEventListener('click', ()=>{
                if (activeIndex > 0) {
                    activeIndex--;
                    updateState(activeIndex);
                }
            });
        });
        // Обработчики кликов на стрелках "вперед"
        nextArrows.forEach((arrow)=>{
            arrow.addEventListener('click', ()=>{
                if (activeIndex < items.length - 1) {
                    activeIndex++;
                    updateState(activeIndex);
                }
            });
        });
        // Обработчик изменения размера окна (с debounce для оптимизации)
        let resizeTimeout;
        const handleResize = ()=>{
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(()=>{
                updateHeight(activeIndex);
            }, 100);
        };
        window.addEventListener('resize', handleResize);
    });
};
// Инициализация после загрузки DOM
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $9deab51236adcadd$var$initMissionSections);
else $9deab51236adcadd$var$initMissionSections();


const $303d550b81fbbfd1$var$joinSecEl = document.querySelector('.join-us-sec');
if ($303d550b81fbbfd1$var$joinSecEl) {
    const items = document.querySelectorAll(".join-us-sec__item");
    const images = document.querySelectorAll(".join-us-sec__image");
    const AUTOPLAY_DELAY = 3000;
    let activeIndex = 0;
    let autoplayTimer = null;
    let isHovering = false;
    function setActive(index) {
        items.forEach((item)=>item.classList.remove('is-active'));
        images.forEach((image)=>image.classList.remove('is-active'));
        if (items[index]) items[index].classList.add('is-active');
        if (images[index]) images[index].classList.add('is-active');
        activeIndex = index;
    }
    function nextSlide() {
        const nextIndex = (activeIndex + 1) % items.length;
        setActive(nextIndex);
    }
    function startAutoplay() {
        stopAutoplay();
        autoplayTimer = setTimeout(()=>{
            if (!isHovering) {
                nextSlide();
                startAutoplay();
            }
        }, AUTOPLAY_DELAY);
    }
    function stopAutoplay() {
        if (autoplayTimer) {
            clearTimeout(autoplayTimer);
            autoplayTimer = null;
        }
    }
    setActive(0);
    startAutoplay();
    const isMobile = ()=>window.innerWidth <= 1024;
    items.forEach((item, index)=>{
        item.addEventListener('mouseenter', ()=>{
            if (!isMobile()) {
                isHovering = true;
                stopAutoplay();
                setActive(index);
            }
        });
        item.addEventListener('mouseleave', ()=>{
            if (!isMobile()) {
                isHovering = false;
                startAutoplay();
            }
        });
        item.addEventListener('click', (e)=>{
            if (isMobile()) {
                e.preventDefault();
                stopAutoplay();
                setActive(index);
                startAutoplay();
            } else {
                setActive(index);
                stopAutoplay();
                startAutoplay();
            }
        });
    });
    let resizeTimer;
    window.addEventListener('resize', ()=>{
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(()=>{
            stopAutoplay();
            startAutoplay();
        }, 250);
    });
}


/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ /* eslint no-param-reassign: "off" */ 
var $4acFp = parcelRequire("4acFp");

var $5apVM = parcelRequire("5apVM");
const $90a9de1e3d9f56dd$var$Methods = {
    addClass: $5apVM.addClass,
    removeClass: $5apVM.removeClass,
    hasClass: $5apVM.hasClass,
    toggleClass: $5apVM.toggleClass,
    attr: $5apVM.attr,
    removeAttr: $5apVM.removeAttr,
    transform: $5apVM.transform,
    transition: $5apVM.transition,
    on: $5apVM.on,
    off: $5apVM.off,
    trigger: $5apVM.trigger,
    transitionEnd: $5apVM.transitionEnd,
    outerWidth: $5apVM.outerWidth,
    outerHeight: $5apVM.outerHeight,
    styles: $5apVM.styles,
    offset: $5apVM.offset,
    css: $5apVM.css,
    each: $5apVM.each,
    html: $5apVM.html,
    text: $5apVM.text,
    is: $5apVM.is,
    index: $5apVM.index,
    eq: $5apVM.eq,
    append: $5apVM.append,
    prepend: $5apVM.prepend,
    next: $5apVM.next,
    nextAll: $5apVM.nextAll,
    prev: $5apVM.prev,
    prevAll: $5apVM.prevAll,
    parent: $5apVM.parent,
    parents: $5apVM.parents,
    closest: $5apVM.closest,
    find: $5apVM.find,
    children: $5apVM.children,
    filter: $5apVM.filter,
    remove: $5apVM.remove
};
Object.keys($90a9de1e3d9f56dd$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $5apVM.$).fn, methodName, {
        value: $90a9de1e3d9f56dd$var$Methods[methodName],
        writable: true
    });
});
var $90a9de1e3d9f56dd$export$2e2bcd8739ae039 = (0, $5apVM.$);



var $4acFp = parcelRequire("4acFp");
function $b254fe4b7c9c1178$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $b254fe4b7c9c1178$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $b254fe4b7c9c1178$export$461939dd4422153() {
    return Date.now();
}
function $b254fe4b7c9c1178$export$3735103072e4a80(el) {
    const window1 = (0, $4acFp.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $b254fe4b7c9c1178$export$5ec402b7fcf74398(el, axis = 'x') {
    const window1 = (0, $4acFp.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $b254fe4b7c9c1178$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $b254fe4b7c9c1178$export$a6cdc56e425d0d0a(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $b254fe4b7c9c1178$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $b254fe4b7c9c1178$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$b254fe4b7c9c1178$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($b254fe4b7c9c1178$export$a6cdc56e425d0d0a(to[nextKey]) && $b254fe4b7c9c1178$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $b254fe4b7c9c1178$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$b254fe4b7c9c1178$export$a6cdc56e425d0d0a(to[nextKey]) && $b254fe4b7c9c1178$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $b254fe4b7c9c1178$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $b254fe4b7c9c1178$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $b254fe4b7c9c1178$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $4acFp.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}



var $4acFp = parcelRequire("4acFp");
let $23cabd961154dd1d$var$support;
function $23cabd961154dd1d$var$calcSupport() {
    const window = (0, $4acFp.getWindow)();
    const document = (0, $4acFp.getDocument)();
    return {
        smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener('testPassiveListener', null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return 'ongesturestart' in window;
        }()
    };
}
function $23cabd961154dd1d$export$d61c7b85ff180578() {
    if (!$23cabd961154dd1d$var$support) $23cabd961154dd1d$var$support = $23cabd961154dd1d$var$calcSupport();
    return $23cabd961154dd1d$var$support;
}



var $4acFp = parcelRequire("4acFp");

let $1d5a11620700da71$var$deviceCached;
function $1d5a11620700da71$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $23cabd961154dd1d$export$d61c7b85ff180578)();
    const window = (0, $4acFp.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel'; // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    } // Export object
    return device;
}
function $1d5a11620700da71$export$30c823bc834d6ab4(overrides = {}) {
    if (!$1d5a11620700da71$var$deviceCached) $1d5a11620700da71$var$deviceCached = $1d5a11620700da71$var$calcDevice(overrides);
    return $1d5a11620700da71$var$deviceCached;
}



var $4acFp = parcelRequire("4acFp");
let $251e4c8fce621376$var$browser;
function $251e4c8fce621376$var$calcBrowser() {
    const window = (0, $4acFp.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $251e4c8fce621376$export$89e15fc796a4a429() {
    if (!$251e4c8fce621376$var$browser) $251e4c8fce621376$var$browser = $251e4c8fce621376$var$calcBrowser();
    return $251e4c8fce621376$var$browser;
}



var $4acFp = parcelRequire("4acFp");
function $4d70267c217bac06$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $4acFp.getWindow)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
}



var $4acFp = parcelRequire("4acFp");
function $d0e6f8dae4d7097b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $4acFp.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: typeof options.childList === 'undefined' ? true : options.childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}


/* eslint-disable no-underscore-dangle */ var $74b464c34803e653$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};


function $b96a7e23bdc0c3e1$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $0d8e0e75b56b918a$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
    });
    else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $b254fe4b7c9c1178$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', '');
        (0, $b254fe4b7c9c1178$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css('display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = 'none';
            if (currentWebKitTransform) slide[0].style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $b254fe4b7c9c1178$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $b254fe4b7c9c1178$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}



function $fc0231be1e9178c0$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}


function $11d42bb20eb9d9eb$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}



function $6c97f7622d9f4ced$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.visibleSlides);
}


function $8d57fff72a19789d$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}


function $d271fe0693747d09$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}


function $2859f72c9b0c677a$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === 'undefined') {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit('slideChange');
}



function $fb52046cc124fe07$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slide).attr('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $8f4a1bd5616070ce$export$2e2bcd8739ae039 = {
    updateSize: $b96a7e23bdc0c3e1$export$2e2bcd8739ae039,
    updateSlides: $0d8e0e75b56b918a$export$2e2bcd8739ae039,
    updateAutoHeight: $fc0231be1e9178c0$export$2e2bcd8739ae039,
    updateSlidesOffset: $11d42bb20eb9d9eb$export$2e2bcd8739ae039,
    updateSlidesProgress: $6c97f7622d9f4ced$export$2e2bcd8739ae039,
    updateProgress: $8d57fff72a19789d$export$2e2bcd8739ae039,
    updateSlidesClasses: $d271fe0693747d09$export$2e2bcd8739ae039,
    updateActiveIndex: $2859f72c9b0c677a$export$2e2bcd8739ae039,
    updateClickedSlide: $fb52046cc124fe07$export$2e2bcd8739ae039
};



function $60df7d7ac2ffbb4e$export$2e2bcd8739ae039(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $b254fe4b7c9c1178$export$5ec402b7fcf74398)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $e7445ee6d3074e4c$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}


function $d56e9d558de83ab3$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $d54ad53b6e1f47e6$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}



function $ab9b0648313b094c$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $b254fe4b7c9c1178$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $9f58678d892afa12$export$2e2bcd8739ae039 = {
    getTranslate: $60df7d7ac2ffbb4e$export$2e2bcd8739ae039,
    setTranslate: $e7445ee6d3074e4c$export$2e2bcd8739ae039,
    minTranslate: $d56e9d558de83ab3$export$2e2bcd8739ae039,
    maxTranslate: $d54ad53b6e1f47e6$export$2e2bcd8739ae039,
    translateTo: $ab9b0648313b094c$export$2e2bcd8739ae039
};


function $e221a96f24e2daec$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit('setTransition', duration, byController);
}


function $6cbaeefea937afb9$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}


function $109986cb6d9bdc87$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $6cbaeefea937afb9$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}



function $b103cd34ed644041$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $6cbaeefea937afb9$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}


var $3f2b868738e95e42$export$2e2bcd8739ae039 = {
    setTransition: $e221a96f24e2daec$export$2e2bcd8739ae039,
    transitionStart: $109986cb6d9bdc87$export$2e2bcd8739ae039,
    transitionEnd: $b103cd34ed644041$export$2e2bcd8739ae039
};



function $4d9dea3156e195f0$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== 'number' && typeof index !== 'string') throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset'; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $b254fe4b7c9c1178$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $9635d3c5e8c369f6$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $af0b2a703a605a3e$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $8e1a3d4ea0cb9e06$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $68e0ccc72a9aa9ef$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $ac7624697f897e03$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}




function $495e32765e97ad9d$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $bc69c4bbb0402867$export$2e2bcd8739ae039 = {
    slideTo: $4d9dea3156e195f0$export$2e2bcd8739ae039,
    slideToLoop: $9635d3c5e8c369f6$export$2e2bcd8739ae039,
    slideNext: $af0b2a703a605a3e$export$2e2bcd8739ae039,
    slidePrev: $8e1a3d4ea0cb9e06$export$2e2bcd8739ae039,
    slideReset: $68e0ccc72a9aa9ef$export$2e2bcd8739ae039,
    slideToClosest: $ac7624697f897e03$export$2e2bcd8739ae039,
    slideToClickedSlide: $495e32765e97ad9d$export$2e2bcd8739ae039
};



var $4acFp = parcelRequire("4acFp");

function $66ecee90d80ea70f$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $4acFp.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el);
        slide.attr('data-swiper-slide-index', index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}


function $16d125a6f5791ce5$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit('beforeLoopFix');
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
}


function $b75eb75dc08558ea$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr('data-swiper-slide-index');
}


var $f929d5d48e6fbbb6$export$2e2bcd8739ae039 = {
    loopCreate: $66ecee90d80ea70f$export$2e2bcd8739ae039,
    loopFix: $16d125a6f5791ce5$export$2e2bcd8739ae039,
    loopDestroy: $b75eb75dc08558ea$export$2e2bcd8739ae039
};


function $e005bc3bd89ee5bb$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
}


function $f01ee6c3f655d819$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}


var $90248c4085b54b52$export$2e2bcd8739ae039 = {
    setGrabCursor: $e005bc3bd89ee5bb$export$2e2bcd8739ae039,
    unsetGrabCursor: $f01ee6c3f655d819$export$2e2bcd8739ae039
};



var $4acFp = parcelRequire("4acFp");

var $4acFp = parcelRequire("4acFp");


function $b15d160745c3babc$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $4acFp.getDocument)() || el === (0, $4acFp.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $b15d160745c3babc$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $4acFp.getDocument)();
    const window = (0, $4acFp.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target);
    if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $b15d160745c3babc$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === 'SELECT') data.isTouched = false;
        }
        if (document.activeElement && (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}



var $4acFp = parcelRequire("4acFp");


function $2a78afa7725f20a7$export$2e2bcd8739ae039(event) {
    const document = (0, $4acFp.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $d08783fc78d02175$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
    (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}


function $1b1643a6bb74221f$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $47b5e8b66ebb5a6e$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $a94b8f37e4c27a3c$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}


let $dc24c96bad3f572c$var$dummyEventAttached = false;
function $dc24c96bad3f572c$var$dummyEventListener() {}
const $dc24c96bad3f572c$var$events = (swiper, method)=>{
    const document = (0, $4acFp.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $1b1643a6bb74221f$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]('observerUpdate', (0, $1b1643a6bb74221f$export$2e2bcd8739ae039), true);
};
function $dc24c96bad3f572c$var$attachEvents() {
    const swiper = this;
    const document = (0, $4acFp.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $b15d160745c3babc$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $2a78afa7725f20a7$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $d08783fc78d02175$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $a94b8f37e4c27a3c$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $47b5e8b66ebb5a6e$export$2e2bcd8739ae039).bind(swiper);
    if (support.touch && !$dc24c96bad3f572c$var$dummyEventAttached) {
        document.addEventListener('touchstart', $dc24c96bad3f572c$var$dummyEventListener);
        $dc24c96bad3f572c$var$dummyEventAttached = true;
    }
    $dc24c96bad3f572c$var$events(swiper, 'on');
}
function $dc24c96bad3f572c$var$detachEvents() {
    const swiper = this;
    $dc24c96bad3f572c$var$events(swiper, 'off');
}
var $dc24c96bad3f572c$export$2e2bcd8739ae039 = {
    attachEvents: $dc24c96bad3f572c$var$attachEvents,
    detachEvents: $dc24c96bad3f572c$var$detachEvents
};



const $9d748ea43e402950$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $9d748ea43e402950$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $9d748ea43e402950$var$isGridEnabled(swiper, params);
    const isMultiRow = $9d748ea43e402950$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $b254fe4b7c9c1178$export$8b58be045bf06082)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakpointParams);
}



var $4acFp = parcelRequire("4acFp");
function $7a29e4db01987bc4$export$2e2bcd8739ae039(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $4acFp.getWindow)();
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}


var $ee7f6089a376b64d$export$2e2bcd8739ae039 = {
    setBreakpoint: $9d748ea43e402950$export$2e2bcd8739ae039,
    getBreakpoint: $7a29e4db01987bc4$export$2e2bcd8739ae039
};


function $2190804c4655748f$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $2190804c4655748f$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $2190804c4655748f$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'pointer-events': !support.touch
        },
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(' '));
    swiper.emitContainerClasses();
}


function $fa3eea195c5fe69d$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
}


var $d63baffdaeae902c$export$2e2bcd8739ae039 = {
    addClasses: $2190804c4655748f$export$2e2bcd8739ae039,
    removeClasses: $fa3eea195c5fe69d$export$2e2bcd8739ae039
};



var $4acFp = parcelRequire("4acFp");

function $017c5524d7ef69d4$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $4acFp.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}


function $b6f2f49d7141bb2e$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit('imagesReady');
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
}


var $73157fd5be78b253$export$2e2bcd8739ae039 = {
    loadImage: $017c5524d7ef69d4$export$2e2bcd8739ae039,
    preloadImages: $b6f2f49d7141bb2e$export$2e2bcd8739ae039
};


function $8d9c247da82d0131$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $8d9c247da82d0131$export$2e2bcd8739ae039 = {
    checkOverflow: $8d9c247da82d0131$var$checkOverflow
};


var $64df97bf2a11c9d8$export$2e2bcd8739ae039 = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



function $ce955312af607476$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $b254fe4b7c9c1178$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            'navigation',
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $b254fe4b7c9c1178$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $b254fe4b7c9c1178$export$8b58be045bf06082)(allModulesParams, obj);
    };
}


const $85f4b8a35c4e1acd$var$prototypes = {
    eventsEmitter: $74b464c34803e653$export$2e2bcd8739ae039,
    update: $8f4a1bd5616070ce$export$2e2bcd8739ae039,
    translate: $9f58678d892afa12$export$2e2bcd8739ae039,
    transition: $3f2b868738e95e42$export$2e2bcd8739ae039,
    slide: $bc69c4bbb0402867$export$2e2bcd8739ae039,
    loop: $f929d5d48e6fbbb6$export$2e2bcd8739ae039,
    grabCursor: $90248c4085b54b52$export$2e2bcd8739ae039,
    events: $dc24c96bad3f572c$export$2e2bcd8739ae039,
    breakpoints: $ee7f6089a376b64d$export$2e2bcd8739ae039,
    checkOverflow: $8d9c247da82d0131$export$2e2bcd8739ae039,
    classes: $d63baffdaeae902c$export$2e2bcd8739ae039,
    images: $73157fd5be78b253$export$2e2bcd8739ae039
};
const $85f4b8a35c4e1acd$var$extendedDefaults = {};
class $85f4b8a35c4e1acd$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(params.el).length > 1) {
            const swipers = [];
            (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(params.el).each((containerEl)=>{
                const newParams = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new $85f4b8a35c4e1acd$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $23cabd961154dd1d$export$d61c7b85ff180578)();
        swiper.device = (0, $1d5a11620700da71$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $251e4c8fce621376$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $ce955312af607476$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, (0, $64df97bf2a11c9d8$export$2e2bcd8739ae039), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, swiperParams, $85f4b8a35c4e1acd$var$extendedDefaults, params);
        swiper.originalParams = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    'touchstart',
                    'touchmove',
                    'touchend',
                    'touchcancel'
                ];
                const desktop = [
                    'pointerdown',
                    'pointermove',
                    'pointerup'
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $b254fe4b7c9c1178$export$461939dd4422153)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper'); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $4acFp.getDocument)();
            const wrapper = document.createElement('div');
            $wrapperEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
            wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit'); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy'); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr('style');
            $wrapperEl.removeAttr('style');
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
        swiper.emit('destroy'); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $b254fe4b7c9c1178$export$8694e5c03a4df8e6)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $b254fe4b7c9c1178$export$8b58be045bf06082)($85f4b8a35c4e1acd$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $85f4b8a35c4e1acd$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $64df97bf2a11c9d8$export$2e2bcd8739ae039;
    }
    static installModule(mod) {
        if (!$85f4b8a35c4e1acd$var$Swiper.prototype.__modules__) $85f4b8a35c4e1acd$var$Swiper.prototype.__modules__ = [];
        const modules = $85f4b8a35c4e1acd$var$Swiper.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$85f4b8a35c4e1acd$var$Swiper.installModule(m));
            return $85f4b8a35c4e1acd$var$Swiper;
        }
        $85f4b8a35c4e1acd$var$Swiper.installModule(module);
        return $85f4b8a35c4e1acd$var$Swiper;
    }
}
Object.keys($85f4b8a35c4e1acd$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($85f4b8a35c4e1acd$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $85f4b8a35c4e1acd$var$Swiper.prototype[protoMethod] = $85f4b8a35c4e1acd$var$prototypes[prototypeGroup][protoMethod];
    });
});
$85f4b8a35c4e1acd$var$Swiper.use([
    (0, $4d70267c217bac06$export$2e2bcd8739ae039),
    (0, $d0e6f8dae4d7097b$export$2e2bcd8739ae039)
]);
var $85f4b8a35c4e1acd$export$2e2bcd8739ae039 = $85f4b8a35c4e1acd$var$Swiper;




function $0ed6abb29af34172$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(params.renderSlide.call(swiper, slide, index)) : (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
                if (cachedElIndex) $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $b254fe4b7c9c1178$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 
var $4acFp = parcelRequire("4acFp");

function $38f924aa78a8f5bb$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $4acFp.getDocument)();
    const window = (0, $4acFp.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(document).on('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(document).off('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 
var $4acFp = parcelRequire("4acFp");


function $d4f01ea054a44f20$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $4acFp.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $b254fe4b7c9c1178$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $b254fe4b7c9c1178$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $b254fe4b7c9c1178$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $b254fe4b7c9c1178$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        target[method]('mouseenter', handleMouseEnter);
        target[method]('mouseleave', handleMouseLeave);
        target[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('on');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('off');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



var $4acFp = parcelRequire("4acFp");
function $ebb110cd73bf06ce$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $4acFp.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement('div');
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $482b46abf0b619ea$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el);
            if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
            if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $ebb110cd73bf06ce$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on('click', onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on('click', onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off('click', onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off('click', onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    });
    on('click', (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(targetEl).is($prevEl) && !(0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}



function $636b3690d5e49284$export$2e2bcd8739ae039(classes = '') {
    return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}



function $66a0766673700297$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                '',
                '-next',
                '-next-next',
                '-prev',
                '-prev-prev',
                '-main'
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(' '));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets($bullet, 'next');
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, 'prev');
                            setSideBullets($lastDisplayedBullet, 'next');
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, 'prev');
                        setSideBullets($lastDisplayedBullet, 'next');
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
            }
        }
        if (params.type === 'fraction') {
            $el.find((0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === 'horizontal') scaleX = scale;
            else scaleY = scale;
            $el.find((0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit('paginationRender', $el[0]);
        } else emit('paginationUpdate', $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.bulletClass));
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== 'custom') emit('paginationRender', swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $ebb110cd73bf06ce$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el).parents('.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === 'bullets' && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === 'bullets' && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on('click', (0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off('click', (0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.bulletClass));
    }
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        if (!swiper.params.loop) update();
    });
    on('slidesLengthChange', ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on('snapGridLengthChange', ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}



var $4acFp = parcelRequire("4acFp");



function $558f0a9ee089358a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $4acFp.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = 'none';
        else $el[0].style.display = '';
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css('opacity', 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css('scroll-snap-type', 'none');
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css('scroll-snap-type', '');
            $wrapperEl.transition('');
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                $el.css('opacity', 0);
                $el.transition(400);
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $ebb110cd73bf06ce$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $6b0ad44af32694c9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr('data-swiper-parallax') || '0';
        let x = $el.attr('data-swiper-parallax-x');
        let y = $el.attr('data-swiper-parallax-y');
        const scale = $el.attr('data-swiper-parallax-scale');
        const opacity = $el.attr('data-swiper-parallax-opacity');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === 'undefined' || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((parallaxEl)=>{
            const $parallaxEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}



var $4acFp = parcelRequire("4acFp");


function $e236535974c64ffc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $4acFp.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === 'gesturechange') onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $b254fe4b7c9c1178$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'x') || 0;
            image.startY = (0, $b254fe4b7c9c1178$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'y') || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform('translate3d(0,0,0)');
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures('on');
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures('off');
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



var $4acFp = parcelRequire("4acFp");

function $470215bb19934ee4$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: '',
            elementClass: 'swiper-lazy',
            loadingClass: 'swiper-lazy-loading',
            loadedClass: 'swiper-lazy-loaded',
            preloaderClass: 'swiper-lazy-preloader'
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === 'undefined') return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr('data-background');
            const src = $imageEl.attr('data-src');
            const srcset = $imageEl.attr('data-srcset');
            const sizes = $imageEl.attr('data-sizes');
            const $pictureEl = $imageEl.parent('picture');
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css('background-image', `url("${background}")`);
                    $imageEl.removeAttr('data-background');
                } else {
                    if (srcset) {
                        $imageEl.attr('srcset', srcset);
                        $imageEl.removeAttr('data-srcset');
                    }
                    if (sizes) {
                        $imageEl.attr('sizes', sizes);
                        $imageEl.removeAttr('data-sizes');
                    }
                    if ($pictureEl.length) $pictureEl.children('source').each((sourceEl)=>{
                        const $source = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(sourceEl);
                        if ($source.attr('data-srcset')) {
                            $source.attr('srcset', $source.attr('data-srcset'));
                            $source.removeAttr('data-srcset');
                        }
                    });
                    if (src) {
                        $imageEl.attr('src', src);
                        $imageEl.removeAttr('data-src');
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit('lazyImageReady', $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === 'auto') slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index');
            return (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index') : (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $4acFp.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.params.lazy.scrollingElement) : (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
        }
    }
    on('beforeInit', ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on('init', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('scroll', ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on('scrollbarDragMove resize _freeModeNoMomentumRelease', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('transitionStart', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on('transitionEnd', ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('slideChange', ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on('destroy', ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $94e9e4e6f84e5251$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === 'slide') c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $f01ccbf3aeabc885$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
    }
    function makeElNotFocusable($el) {
        $el.attr('tabIndex', '-1');
    }
    function addElRole($el, role) {
        $el.attr('role', role);
    }
    function addElRoleDescription($el, description) {
        $el.attr('aria-roledescription', description);
    }
    function addElControls($el, controls) {
        $el.attr('aria-controls', controls);
    }
    function addElLabel($el, label) {
        $el.attr('aria-label', label);
    }
    function addElId($el, id) {
        $el.attr('id', id);
    }
    function addElLive($el, live) {
        $el.attr('aria-live', live);
    }
    function disableEl($el) {
        $el.attr('aria-disabled', true);
    }
    function enableEl($el) {
        $el.attr('aria-disabled', false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $636b3690d5e49284$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, 'button');
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr('aria-current', 'true');
            else $bulletEl.removeAttr('aria-current');
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== 'BUTTON') {
            addElRole($el, 'button');
            $el.on('keydown', onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on('keydown', (0, $636b3690d5e49284$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on('focus', handleFocus, true);
        swiper.$el.on('pointerdown', handlePointerDown, true);
        swiper.$el.on('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off('keydown', onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off('keydown', onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off('keydown', (0, $636b3690d5e49284$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off('focus', handleFocus, true);
        swiper.$el.off('pointerdown', handlePointerDown, true);
        swiper.$el.off('pointerup', handlePointerUp, true);
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



var $4acFp = parcelRequire("4acFp");
function $a8d75c807afc5954$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $4acFp.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $4acFp.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr('data-history'));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $4acFp.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $4acFp.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}



var $4acFp = parcelRequire("4acFp");

function $d38d7f1432d0d671$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $4acFp.getDocument)();
    const window = (0, $4acFp.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === 'undefined') return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
            emit('hashSet');
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr('data-hash') || slide.attr('data-history');
            document.location.hash = hash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr('data-hash') || slide.attr('data-history');
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(window).on('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(window).off('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $4acFp = parcelRequire("4acFp");

function $11e8d961c11b7050$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit('autoplay');
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit('autoplay');
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit('autoplayStart');
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === 'undefined') return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit('autoplayStop');
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $4acFp.getDocument)();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) pause();
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit('autoplayPause');
            pause();
        }
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit('autoplayResume');
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on('mouseenter', onMouseEnter);
            swiper.$el.on('mouseleave', onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off('mouseenter', onMouseEnter);
        swiper.$el.off('mouseleave', onMouseLeave);
    }
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $4acFp.getDocument)();
            document.addEventListener('visibilitychange', onVisibilityChange);
            attachMouseEvents();
        }
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on('sliderFirstMove', ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on('touchEnd', ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on('destroy', ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $4acFp.getDocument)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}




function $063a77c64406fb38$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
            else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $b254fe4b7c9c1178$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $093847604d5cafbc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $b254fe4b7c9c1178$export$461939dd4422153)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $b254fe4b7c9c1178$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $8d4e16c568ab01e7$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                '-webkit-order': newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel('margin-top'), row !== 0 ? spaceBetween && `${spaceBetween}px` : '');
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel('width')]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $d59b6e2443b78190$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}


function $4581dd3fc0dc14e7$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $f4d9a81beb7efc43$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $05fa667223b0de98$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $39eda8f4166c8156$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $3bee8b7b8f78b39b$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $d59b6e2443b78190$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $4581dd3fc0dc14e7$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $f4d9a81beb7efc43$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $05fa667223b0de98$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $39eda8f4166c8156$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $c4cb41250e7e6a0a$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}


function $869bdd50588521f3$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        'backface-visibility': 'hidden',
        '-webkit-backface-visibility': 'hidden'
    });
    return $slideEl;
}


function $7ee679e4e1fc3cdd$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                'webkitTransitionEnd',
                'transitionend'
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}


function $9d892de9fba7bf61$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $869bdd50588521f3$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $7ee679e4e1fc3cdd$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $22dd7d617eacaa4c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
            'transform-origin': `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find('.swiper-cube-shadow').transition(duration);
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}




function $50e091fb9de20d2d$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}





function $e3f7a5551d142941$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) shadowBefore = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (shadowAfter.length === 0) shadowAfter = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $869bdd50588521f3$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        (0, $7ee679e4e1fc3cdd$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}





function $af05481a6c3d5a31$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $869bdd50588521f3$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'left' : 'top');
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'right' : 'bottom');
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}






function $8abffc196ff25a15$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children('.swiper-slide-shadow');
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $869bdd50588521f3$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css('transform-origin', data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $7ee679e4e1fc3cdd$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $403997b391f9cdb3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find('.swiper-slide-shadow');
                if ($shadowEl.length === 0) $shadowEl = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $869bdd50588521f3$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $7ee679e4e1fc3cdd$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




/**
 * Function for disabling Swiper autoscroll when Swiper is not in viewport
 */ const $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a = (swiperInstance)=>{
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.85
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) swiperInstance.autoplay.start();
            else swiperInstance.autoplay.stop();
        });
    }, observerOptions);
    observer.observe(swiperInstance.el);
};


let $bd7b7dcd5b5a8694$var$spotlightSwiperWr = document.querySelectorAll('.spotlight-swiper-wr');
$bd7b7dcd5b5a8694$var$spotlightSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector('.swiper-button-next');
        let prevEl = parentEl.querySelector('.swiper-button-prev');
        let scrollbarEl = parentEl.querySelector('.spotlight-sec__scrollbar');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039),
                (0, $558f0a9ee089358a$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 12,
            slidesPerView: 1.05,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            scrollbar: {
                el: scrollbarEl,
                draggable: true
            },
            breakpoints: {
                375: {
                    spaceBetween: 12,
                    slidesPerView: 1.18
                },
                440: {
                    spaceBetween: 16,
                    slidesPerView: 1.3
                },
                768: {
                    spaceBetween: 16,
                    slidesPerView: 1.6
                },
                840: {
                    spaceBetween: 16,
                    slidesPerView: 2
                },
                1280: {
                    spaceBetween: 20,
                    slidesPerView: 2.5
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $6b5e02d34daafde3$var$ourVacanciesSwiperWr = document.querySelectorAll('.our-vacancies-swiper-wr');
$6b5e02d34daafde3$var$ourVacanciesSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector('.swiper-button-next');
        let prevEl = parentEl.querySelector('.swiper-button-prev');
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039),
                (0, $8abffc196ff25a15$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 0,
            threshold: 10,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            effect: 'creative',
            creativeEffect: {
                limitProgress: 3,
                // progressMultiplier: 1,
                next: {
                    translate: [
                        'calc(100% + 20px)',
                        0,
                        0
                    ],
                    opacity: 1,
                    scale: 1
                },
                prev: {
                    opacity: 0,
                    translate: [
                        0,
                        '40%',
                        0
                    ]
                }
            },
            breakpoints: {
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $f1dab827a7b3c48f$var$processSwiperWr = document.querySelectorAll('.process-swiper-wr');
$f1dab827a7b3c48f$var$processSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.parentElement.querySelector('.swiper-button-next');
        let prevEl = parentEl.parentElement.querySelector('.swiper-button-prev');
        const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
        const isMakersBlockedSwipe = el.classList.contains('makers-type') && window.innerWidth > 1150 && slidesCount <= 2;
        let autoplay = {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        };
        if (isMakersBlockedSwipe) autoplay = false;
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039),
                (0, $8abffc196ff25a15$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 0,
            threshold: 10,
            observer: true,
            observeParents: true,
            allowTouchMove: !isMakersBlockedSwipe,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            autoplay: autoplay,
            effect: 'creative',
            creativeEffect: {
                limitProgress: 3,
                // progressMultiplier: 1,
                next: {
                    translate: [
                        'calc(100% + 20px)',
                        0,
                        0
                    ],
                    opacity: 1,
                    scale: 1
                },
                prev: {
                    opacity: 0,
                    translate: [
                        0,
                        '40%',
                        0
                    ]
                }
            },
            breakpoints: {
            }
        });
        if (!isMakersBlockedSwipe) (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});


/* eslint-disable no-inner-declarations */ 

let $e2759302f3e19822$var$reviewsSwiperWr = document.querySelectorAll('.reviews-swiper-wr');
$e2759302f3e19822$var$reviewsSwiperWr.forEach((el)=>{
    if (el) {
        let itemsSwiperEl = el.querySelector('.reviews-sec__items .swiper');
        let swiperEl = el.querySelector('.reviews-sec__cards .swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector('.swiper-button-next');
        let prevEl = parentEl.querySelector('.swiper-button-prev');
        let scrollbarEl = parentEl.querySelector('.reviews-sec__scrollbar');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        // thumbs
        let itemsSwiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(itemsSwiperEl, {
            modules: [
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039),
                (0, $063a77c64406fb38$export$2e2bcd8739ae039),
                (0, $558f0a9ee089358a$export$2e2bcd8739ae039),
                (0, $d4f01ea054a44f20$export$2e2bcd8739ae039)
            ],
            direction: 'vertical',
            spaceBetween: 0,
            slidesPerView: 4,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            scrollbar: {
                el: scrollbarEl,
                draggable: true
            },
            mousewheel: {
                enabled: true
            }
        });
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039),
                (0, $063a77c64406fb38$export$2e2bcd8739ae039)
            ],
            spaceBetween: 10,
            loop: false,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            thumbs: {
                swiper: itemsSwiper
            }
        });
        function updateThumbsShadow() {
            const container = itemsSwiperEl.parentElement;
            const total = swiper.slides.length;
            if (total < 4 || swiper.activeIndex >= 3) container.classList.add('hide-shadow');
            else container.classList.remove('hide-shadow');
        }
        swiper.on('slideChange slideChangeTransitionEnd', updateThumbsShadow);
        updateThumbsShadow();
    }
});




/**
 * Duplicates slides inside the Swiper container.
 *
 * @param {string} containerClass - CSS class of the Swiper container without a dot (e.g., “gallery-swiper-wr”)
 * @param {number} count - How many times to duplicate each slide.
 *
 * @example
 * duplicateSwiperSlides("gallery-swiper-wr", 2);
 */ function $609851eaba2e9ae8$export$1b1f2485001f41ce(containerClass, count) {
    const containers = document.querySelectorAll(`.${containerClass}`);
    containers.forEach((container)=>{
        const slides = container.querySelectorAll('.swiper-slide');
        const swiperWrapper = container.querySelector('.swiper-wrapper');
        if (!swiperWrapper || slides.length === 0) return;
        for(let i = 0; i < count; i++)slides.forEach((slide)=>{
            const clone = slide.cloneNode(true);
            swiperWrapper.appendChild(clone);
        });
    });
}


let $22a89d2b4320ad41$var$numbersSwiperWr = document.querySelectorAll('.numbers-swiper-wr');
$22a89d2b4320ad41$var$numbersSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector('.swiper-button-next');
        let prevEl = parentEl.querySelector('.swiper-button-prev');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl?.querySelector('.swiper-wrapper');
        (0, $609851eaba2e9ae8$export$1b1f2485001f41ce)('numbers-swiper-wr', 2);
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 24,
            slidesPerView: 'auto',
            loop: true,
            threshold: 10,
            // navigation: {
            //   nextEl: nextEl,
            //   prevEl: prevEl,
            // },
            breakpoints: {
                480: {
                    spaceBetween: 36
                },
                768: {
                    spaceBetween: 64
                },
                1200: {
                    spaceBetween: 110
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            }
        });
    // swiperObserver(swiper);
    }
});


/* eslint-disable no-inner-declarations */ 

let $f76da7af90146faf$var$ourTeamSwiperWr = document.querySelectorAll('.our-team-swiper-wr');
$f76da7af90146faf$var$ourTeamSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector('.swiper-button-next');
        let prevEl = parentEl.querySelector('.swiper-button-prev');
        let scrollbarEl = parentEl.querySelector('.our-team-sec__scrollbar');
        const items = document.querySelectorAll('.our-team-sec__item');
        console.log('SRC');
        if (items.length) {
            items[0].classList.add('active');
            setTimeout(()=>{
                swiper.autoplay.stop();
                swiper.update();
            }, 450);
        }
        items.forEach((item, i)=>{
            item.addEventListener('click', (e)=>changeActiveItem(e, i));
        });
        const changeActiveItem = (e, i)=>{
            const item = items[i];
            console.log(item);
            // if (item.classList.contains('active') && (e.target.classList.contains('our-team-sec__item-button') || e.target.tagName === 'I')) {
            //   item.classList.remove('active');
            //   const hasActive = [...items].some(it => it.classList.contains('active'));
            //   if (!hasActive) swiper.autoplay.start();
            //   return;
            // }
            if (item.classList.contains('active')) return;
            // if(item.classList.contains('active') && !item.classList.contains('swiper-slide-active')) {
            //   item.classList.remove('active');
            // }
            items.forEach((it)=>it.classList.remove('active'));
            // swiper.update(); 
            setTimeout(()=>{
                item.classList.add('active');
                swiper.autoplay.stop();
                swiper.update();
                swiper.slideTo(i, 350);
            }, 500);
        };
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039),
                (0, $558f0a9ee089358a$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 14,
            slidesPerView: 1,
            threshold: 10,
            // slideToClickedSlide: true,
            // freeMode: true,
            /*loop: true,*/ navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            scrollbar: {
                el: scrollbarEl,
                draggable: true
            },
            breakpoints: {
                500: {
                    slidesPerView: 1
                },
                641: {
                    slidesPerView: 1
                },
                769: {
                    spaceBetween: 20,
                    slidesPerView: 1
                }
            },
            autoplay: {
                delay: 800000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            on: {
                slideChange: (swiper)=>{
                    changeActiveItem(items[swiper.activeIndex], swiper.activeIndex);
                }
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $714adf4b99c26688$var$ourProcessSwiperWr = document.querySelectorAll('.our-process-swiper-wr');
$714adf4b99c26688$var$ourProcessSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector('.swiper-button-next');
        let prevEl = parentEl.querySelector('.swiper-button-prev');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 18,
            slidesPerView: 1.1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                580: {
                    slidesPerView: 2,
                    spaceBetween: 18
                },
                920: {
                    spaceBetween: 18,
                    slidesPerView: 3
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 3
                },
                1280: {
                    spaceBetween: 20,
                    slidesPerView: 4
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $b822ee33e1db14e5$var$caseStudiesSwiperWr = document.querySelectorAll('.case-studies-swiper-wr');
$b822ee33e1db14e5$var$caseStudiesSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector('.swiper-button-next');
        let prevEl = parentEl.querySelector('.swiper-button-prev');
        let scrollbarEl = parentEl.querySelector('.case-studies-sec__scrollbar');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039),
                (0, $558f0a9ee089358a$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 14,
            slidesPerView: 1.1,
            threshold: 10,
            scrollbar: {
                el: scrollbarEl,
                draggable: true
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                420: {
                    slidesPerView: 1.5,
                    spaceBetween: 16
                },
                580: {
                    slidesPerView: 2.1,
                    spaceBetween: 18
                },
                768: {
                    spaceBetween: 18,
                    slidesPerView: 2.5
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 3
                },
                1280: {
                    spaceBetween: 20,
                    slidesPerView: 3.333
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $83330c936e60059d$var$similarVacanciesSwiperWr = document.querySelectorAll('.similar-vacancies-swiper-wr');
$83330c936e60059d$var$similarVacanciesSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector('.swiper-button-next');
        let prevEl = parentEl.querySelector('.swiper-button-prev');
        const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
        const isBlockedSwipe = window.innerWidth > 1150 && slidesCount <= 2;
        let autoplay = {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        };
        if (isBlockedSwipe) autoplay = false;
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039),
                (0, $8abffc196ff25a15$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 0,
            threshold: 10,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            observer: true,
            observeParents: true,
            allowTouchMove: !isBlockedSwipe,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            autoplay: autoplay,
            effect: 'creative',
            creativeEffect: {
                limitProgress: 2,
                next: {
                    translate: [
                        'calc(100% + 20px)',
                        0,
                        0
                    ],
                    opacity: 1,
                    scale: 1
                },
                prev: {
                    opacity: 0,
                    translate: [
                        0,
                        '40%',
                        0
                    ]
                }
            }
        });
        if (!isBlockedSwipe) (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});





const $0b515b836d29f568$export$f16e6af5a274aa5b = (breakpoint, swiperClass, swiperSettings, startOnView)=>{
    let swiper;
    breakpoint = window.matchMedia(breakpoint);
    const enableSwiper = function(className, settings) {
        swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(className, settings);
        if (startOnView) (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    };
    const checker = function() {
        if (breakpoint.matches) return enableSwiper(swiperClass, swiperSettings);
        else {
            if (swiper !== undefined) swiper.destroy(true, true);
            return;
        }
    };
    breakpoint.addEventListener("change", checker);
    checker();
};


let $b1705f06cf091733$var$benefitsSwiperWr = document.querySelectorAll('.benefits-swiper-wr');
$b1705f06cf091733$var$benefitsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let nextEl = el.querySelector('.swiper-button-next');
        let prevEl = el.querySelector('.swiper-button-prev');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        (0, $0b515b836d29f568$export$f16e6af5a274aa5b)('(max-width: 768px)', swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1.1,
            spaceBetween: 14,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            breakpoints: {
                400: {
                    slidesPerView: 1.2
                },
                500: {
                    slidesPerView: 1.5
                },
                600: {
                    slidesPerView: 2,
                    spaceBetween: 20
                }
            },
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            }
        });
    }
});




let $42a65d952fe66f21$var$snapshotSwiperWr = document.querySelectorAll('.snapshot-swiper-wr');
$42a65d952fe66f21$var$snapshotSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector('.swiper-button-next');
        let prevEl = parentEl.querySelector('.swiper-button-prev');
        let scrollbarEl = parentEl.querySelector('.snapshot-sec__scrollbar');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039),
                (0, $558f0a9ee089358a$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 14,
            slidesPerView: 1,
            threshold: 10,
            initialSlide: slidesCount > 3 && window.innerWidth >= 641 ? 1 : 0,
            // loop: true,
            scrollbar: {
                el: scrollbarEl,
                draggable: true
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                641: {
                    slidesPerView: 2,
                    spaceBetween: 14
                },
                768: {
                    spaceBetween: 16,
                    slidesPerView: 2
                },
                1024: {
                    spaceBetween: 18,
                    slidesPerView: 2
                },
                1280: {
                    spaceBetween: 20,
                    slidesPerView: 2
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 1024
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




const $cdad6138960fa3e7$var$toggles = document.querySelectorAll('.specializations-sec__toggle');
const $cdad6138960fa3e7$var$contents = document.querySelectorAll('.specializations-sec__content');
const $cdad6138960fa3e7$var$wrap = document.querySelector('.specializations-sec__wrap');
if ($cdad6138960fa3e7$var$toggles.length && $cdad6138960fa3e7$var$contents.length) {
    $cdad6138960fa3e7$var$toggles[0].classList.add('active');
    $cdad6138960fa3e7$var$contents[0].classList.add('active');
    const setWrapHeight = ()=>{
        if (!$cdad6138960fa3e7$var$wrap || !$cdad6138960fa3e7$var$contents.length) return;
        let maxHeight = Math.max(...Array.from($cdad6138960fa3e7$var$contents, (c)=>c.scrollHeight));
        if (maxHeight && isFinite(maxHeight)) $cdad6138960fa3e7$var$wrap.style.minHeight = `${maxHeight}px`;
    };
    setWrapHeight();
    $cdad6138960fa3e7$var$toggles.forEach((toggle, i)=>{
        toggle.addEventListener('click', ()=>{
            if (toggle.classList.contains('active')) return;
            $cdad6138960fa3e7$var$toggles.forEach((t)=>t.classList.remove('active'));
            $cdad6138960fa3e7$var$contents.forEach((c)=>c.classList.remove('active'));
            toggle.classList.add('active');
            $cdad6138960fa3e7$var$contents[i].classList.add('active');
        });
    });
    window.addEventListener('resize', setWrapHeight);
}
let $cdad6138960fa3e7$var$specializationsSwiperWr = document.querySelectorAll('.specializations-swiper-wr');
$cdad6138960fa3e7$var$specializationsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector('.swiper-button-next');
        let prevEl = parentEl.querySelector('.swiper-button-prev');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        let allowTouchMove = window.innerWidth > 768 && slidesCount <= 4;
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 24,
            slidesPerView: 'auto',
            freeMode: true,
            threshold: 10,
            slideToClickedSlide: true,
            allowTouchMove: !allowTouchMove,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                768: {
                    spaceBetween: 38
                },
                1200: {
                    spaceBetween: 70
                }
            },
            autoplay: false
        });
    }
});




let $377260595bedc541$var$similarInsightsSwiperWr = document.querySelectorAll('.similar-insights-swiper-wr');
$377260595bedc541$var$similarInsightsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector('.swiper-button-next');
        let prevEl = parentEl.querySelector('.swiper-button-prev');
        const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
        const isBlockedSwipe = window.innerWidth > 1150 && slidesCount <= 2;
        let autoplay = {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        };
        if (isBlockedSwipe) autoplay = false;
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039),
                (0, $8abffc196ff25a15$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 0,
            threshold: 10,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            observer: true,
            observeParents: true,
            allowTouchMove: !isBlockedSwipe,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            autoplay: autoplay,
            effect: 'creative',
            creativeEffect: {
                limitProgress: 2,
                next: {
                    translate: [
                        'calc(100% + 20px)',
                        0,
                        0
                    ],
                    opacity: 1,
                    scale: 1
                },
                prev: {
                    opacity: 0,
                    translate: [
                        0,
                        '40%',
                        0
                    ]
                }
            }
        });
        if (!isBlockedSwipe) (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});


/*import { OverlayScrollbars } from 'overlayscrollbars';

if (document.querySelector('[data-scroll]')) {
  const scrollElArr = document.querySelectorAll('[data-scroll]');
  scrollElArr.forEach((scrollEl) => {
    const osInstance = OverlayScrollbars(scrollEl, {});
  });
}*/ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $d24730ee5f0ecc22$var$extendStatics = function(d, b) {
    $d24730ee5f0ecc22$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $d24730ee5f0ecc22$var$extendStatics(d, b);
};
function $d24730ee5f0ecc22$export$a8ba968b8961cb8a(d, b) {
    $d24730ee5f0ecc22$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d24730ee5f0ecc22$export$18ce0697a983be9b = function() {
    $d24730ee5f0ecc22$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d24730ee5f0ecc22$export$18ce0697a983be9b.apply(this, arguments);
};
function $d24730ee5f0ecc22$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d24730ee5f0ecc22$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d24730ee5f0ecc22$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d24730ee5f0ecc22$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d24730ee5f0ecc22$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d24730ee5f0ecc22$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $d24730ee5f0ecc22$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $d24730ee5f0ecc22$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $d24730ee5f0ecc22$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d24730ee5f0ecc22$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d24730ee5f0ecc22$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d24730ee5f0ecc22$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d24730ee5f0ecc22$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d24730ee5f0ecc22$export$10c90e4f7922046c(v) {
    return this instanceof $d24730ee5f0ecc22$export$10c90e4f7922046c ? (this.v = v, this) : new $d24730ee5f0ecc22$export$10c90e4f7922046c(v);
}
function $d24730ee5f0ecc22$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d24730ee5f0ecc22$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d24730ee5f0ecc22$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d24730ee5f0ecc22$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $d24730ee5f0ecc22$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d24730ee5f0ecc22$export$19a8beecd37a4c45 === "function" ? $d24730ee5f0ecc22$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d24730ee5f0ecc22$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $d24730ee5f0ecc22$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $d24730ee5f0ecc22$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d24730ee5f0ecc22$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $d24730ee5f0ecc22$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}





var $7e32d0dbe13ec8ca$var$eventListenerOptions;
var $7e32d0dbe13ec8ca$var$eventMap = new WeakMap();
function $7e32d0dbe13ec8ca$var$getOptions() {
    if ($7e32d0dbe13ec8ca$var$eventListenerOptions !== undefined) return $7e32d0dbe13ec8ca$var$eventListenerOptions;
    var supportPassiveEvent = false;
    try {
        var noop = function() {};
        var options = Object.defineProperty({}, 'passive', {
            enumerable: true,
            get: function() {
                supportPassiveEvent = true;
                return true;
            }
        });
        window.addEventListener('testPassive', noop, options);
        window.removeEventListener('testPassive', noop, options);
    } catch (e) {}
    $7e32d0dbe13ec8ca$var$eventListenerOptions = supportPassiveEvent ? {
        passive: false
    } : false;
    return $7e32d0dbe13ec8ca$var$eventListenerOptions;
}
function $7e32d0dbe13ec8ca$export$cfedec40817575fe(scrollbar) {
    var configs = $7e32d0dbe13ec8ca$var$eventMap.get(scrollbar) || [];
    $7e32d0dbe13ec8ca$var$eventMap.set(scrollbar, configs);
    return function addEvent(elem, events, fn) {
        function handler(event) {
            // ignore default prevented events
            if (event.defaultPrevented) return;
            fn(event);
        }
        events.split(/\s+/g).forEach(function(eventName) {
            configs.push({
                elem: elem,
                eventName: eventName,
                handler: handler
            });
            elem.addEventListener(eventName, handler, $7e32d0dbe13ec8ca$var$getOptions());
        });
    };
}
function $7e32d0dbe13ec8ca$export$2bf7a27f443e4893(scrollbar) {
    var configs = $7e32d0dbe13ec8ca$var$eventMap.get(scrollbar);
    if (!configs) return;
    configs.forEach(function(_a) {
        var elem = _a.elem, eventName = _a.eventName, handler = _a.handler;
        elem.removeEventListener(eventName, handler, $7e32d0dbe13ec8ca$var$getOptions());
    });
    $7e32d0dbe13ec8ca$var$eventMap.delete(scrollbar);
}


/**
 * Get pointer/touch data
 */ function $45eefa4d98616065$export$f7b14ec3e1349d05(evt) {
    // if is touch event, return last item in touchList
    // else return original event
    return evt.touches ? evt.touches[evt.touches.length - 1] : evt;
}



function $989197b988ce28b5$export$1690e12b840569b9(evt) {
    var data = (0, $45eefa4d98616065$export$f7b14ec3e1349d05)(evt);
    return {
        x: data.clientX,
        y: data.clientY
    };
}


/**
 * Check if `a` is one of `[...b]`
 */ function $f84eba88c39f2d95$export$532a90c0e5e8e48c(a, b) {
    if (b === void 0) b = [];
    return b.some(function(v) {
        return a === v;
    });
}


var $7e99e1fbb0d7cf76$var$VENDOR_PREFIX = [
    'webkit',
    'moz',
    'ms',
    'o'
];
var $7e99e1fbb0d7cf76$var$RE = new RegExp("^-(?!(?:" + $7e99e1fbb0d7cf76$var$VENDOR_PREFIX.join('|') + ")-)");
function $7e99e1fbb0d7cf76$var$autoPrefix(styles) {
    var res = {};
    Object.keys(styles).forEach(function(prop) {
        if (!$7e99e1fbb0d7cf76$var$RE.test(prop)) {
            res[prop] = styles[prop];
            return;
        }
        var val = styles[prop];
        prop = prop.replace(/^-/, '');
        res[prop] = val;
        $7e99e1fbb0d7cf76$var$VENDOR_PREFIX.forEach(function(prefix) {
            res["-" + prefix + "-" + prop] = val;
        });
    });
    return res;
}
function $7e99e1fbb0d7cf76$export$37a5fde709c1db82(elem, styles) {
    styles = $7e99e1fbb0d7cf76$var$autoPrefix(styles);
    Object.keys(styles).forEach(function(prop) {
        var cssProp = prop.replace(/^-/, '').replace(/-([a-z])/g, function(_, $1) {
            return $1.toUpperCase();
        });
        elem.style[cssProp] = styles[prop];
    });
}




var $5bf738deeb5a11e4$export$254d9747e34ddc90 = /** @class */ function() {
    function Tracker(touch) {
        this.velocityMultiplier = window.devicePixelRatio;
        this.updateTime = Date.now();
        this.delta = {
            x: 0,
            y: 0
        };
        this.velocity = {
            x: 0,
            y: 0
        };
        this.lastPosition = {
            x: 0,
            y: 0
        };
        this.lastPosition = (0, $989197b988ce28b5$export$1690e12b840569b9)(touch);
    }
    Tracker.prototype.update = function(touch) {
        var _a = this, velocity = _a.velocity, updateTime = _a.updateTime, lastPosition = _a.lastPosition;
        var now = Date.now();
        var position = (0, $989197b988ce28b5$export$1690e12b840569b9)(touch);
        var delta = {
            x: -(position.x - lastPosition.x),
            y: -(position.y - lastPosition.y)
        };
        var duration = now - updateTime || 16.7;
        var vx = delta.x / duration * 16.7;
        var vy = delta.y / duration * 16.7;
        velocity.x = vx * this.velocityMultiplier;
        velocity.y = vy * this.velocityMultiplier;
        this.delta = delta;
        this.updateTime = now;
        this.lastPosition = position;
    };
    return Tracker;
}();
var $5bf738deeb5a11e4$export$9da4f16074124683 = /** @class */ function() {
    function TouchRecord() {
        this._touchList = {};
    }
    Object.defineProperty(TouchRecord.prototype, "_primitiveValue", {
        get: function() {
            return {
                x: 0,
                y: 0
            };
        },
        enumerable: true,
        configurable: true
    });
    TouchRecord.prototype.isActive = function() {
        return this._activeTouchID !== undefined;
    };
    TouchRecord.prototype.getDelta = function() {
        var tracker = this._getActiveTracker();
        if (!tracker) return this._primitiveValue;
        return (0, $d24730ee5f0ecc22$export$18ce0697a983be9b)({}, tracker.delta);
    };
    TouchRecord.prototype.getVelocity = function() {
        var tracker = this._getActiveTracker();
        if (!tracker) return this._primitiveValue;
        return (0, $d24730ee5f0ecc22$export$18ce0697a983be9b)({}, tracker.velocity);
    };
    TouchRecord.prototype.getEasingDistance = function(damping) {
        var deAcceleration = 1 - damping;
        var distance = {
            x: 0,
            y: 0
        };
        var vel = this.getVelocity();
        Object.keys(vel).forEach(function(dir) {
            // ignore small velocity
            var v = Math.abs(vel[dir]) <= 10 ? 0 : vel[dir];
            while(v !== 0){
                distance[dir] += v;
                v = v * deAcceleration | 0;
            }
        });
        return distance;
    };
    TouchRecord.prototype.track = function(evt) {
        var _this = this;
        var targetTouches = evt.targetTouches;
        Array.from(targetTouches).forEach(function(touch) {
            _this._add(touch);
        });
        return this._touchList;
    };
    TouchRecord.prototype.update = function(evt) {
        var _this = this;
        var touches = evt.touches, changedTouches = evt.changedTouches;
        Array.from(touches).forEach(function(touch) {
            _this._renew(touch);
        });
        this._setActiveID(changedTouches);
        return this._touchList;
    };
    TouchRecord.prototype.release = function(evt) {
        var _this = this;
        delete this._activeTouchID;
        Array.from(evt.changedTouches).forEach(function(touch) {
            _this._delete(touch);
        });
    };
    TouchRecord.prototype._add = function(touch) {
        if (this._has(touch)) // reset tracker
        this._delete(touch);
        var tracker = new $5bf738deeb5a11e4$export$254d9747e34ddc90(touch);
        this._touchList[touch.identifier] = tracker;
    };
    TouchRecord.prototype._renew = function(touch) {
        if (!this._has(touch)) return;
        var tracker = this._touchList[touch.identifier];
        tracker.update(touch);
    };
    TouchRecord.prototype._delete = function(touch) {
        delete this._touchList[touch.identifier];
    };
    TouchRecord.prototype._has = function(touch) {
        return this._touchList.hasOwnProperty(touch.identifier);
    };
    TouchRecord.prototype._setActiveID = function(touches) {
        this._activeTouchID = touches[touches.length - 1].identifier;
    };
    TouchRecord.prototype._getActiveTracker = function() {
        var _a = this, _touchList = _a._touchList, _activeTouchID = _a._activeTouchID;
        return _touchList[_activeTouchID];
    };
    return TouchRecord;
}();


function $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4(value, lower, upper) {
    return Math.max(lower, Math.min(upper, value));
}


function $e20bc1b3be085f95$export$61fc7d43ac8f84b0(fn, wait, leading) {
    if (wait === void 0) wait = 0;
    var timer;
    var lastCalledAt = -Infinity;
    return function debouncedFn() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (leading) {
            var now = Date.now();
            var elapsed = now - lastCalledAt;
            lastCalledAt = now;
            if (elapsed >= wait) fn.apply(this, args);
        }
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(_this, args);
        }, wait);
    };
}






function $364bffc95fff96d9$export$d02631cccf789723(min, max) {
    if (min === void 0) min = -Infinity;
    if (max === void 0) max = Infinity;
    return function(proto, key) {
        var alias = "_" + key;
        Object.defineProperty(proto, key, {
            get: function() {
                return this[alias];
            },
            set: function(val) {
                Object.defineProperty(this, alias, {
                    value: (0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(val, min, max),
                    enumerable: false,
                    writable: true,
                    configurable: true
                });
            },
            enumerable: true,
            configurable: true
        });
    };
}


function $53a6aa0a6a97d9af$export$4a21f16c33752377(proto, key) {
    var alias = "_" + key;
    Object.defineProperty(proto, key, {
        get: function() {
            return this[alias];
        },
        set: function(val) {
            Object.defineProperty(this, alias, {
                value: !!val,
                enumerable: false,
                writable: true,
                configurable: true
            });
        },
        enumerable: true,
        configurable: true
    });
}




function $90125405ecd89861$export$61fc7d43ac8f84b0() {
    var options = [];
    for(var _i = 0; _i < arguments.length; _i++)options[_i] = arguments[_i];
    return function(_proto, key, descriptor) {
        var fn = descriptor.value;
        return {
            get: function() {
                if (!this.hasOwnProperty(key)) Object.defineProperty(this, key, {
                    value: (0, $e20bc1b3be085f95$export$61fc7d43ac8f84b0).apply(void 0, (0, $d24730ee5f0ecc22$export$6388937ca91ccae8)([
                        fn
                    ], options))
                });
                return this[key];
            }
        };
    };
}




var $f64dcb84f514b3ef$export$c019608e5b5bb4cb = /** @class */ function() {
    function Options(config) {
        var _this = this;
        if (config === void 0) config = {};
        /**
         * Momentum reduction damping factor, a float value between `(0, 1)`.
         * The lower the value is, the more smooth the scrolling will be
         * (also the more paint frames).
         */ this.damping = 0.1;
        /**
         * Minimal size for scrollbar thumbs.
         */ this.thumbMinSize = 20;
        /**
         * Render every frame in integer pixel values
         * set to `true` to improve scrolling performance.
         */ this.renderByPixels = true;
        /**
         * Keep scrollbar tracks visible
         */ this.alwaysShowTracks = false;
        /**
         * Set to `true` to allow outer scrollbars continue scrolling
         * when current scrollbar reaches edge.
         */ this.continuousScrolling = true;
        /**
         * Delegate wheel events and touch events to the given element.
         * By default, the container element is used.
         * This option will be useful for dealing with fixed elements.
         */ this.delegateTo = null;
        /**
         * Options for plugins. Syntax:
         *   plugins[pluginName] = pluginOptions: any
         */ this.plugins = {};
        Object.keys(config).forEach(function(prop) {
            _this[prop] = config[prop];
        });
    }
    Object.defineProperty(Options.prototype, "wheelEventTarget", {
        get: function() {
            return this.delegateTo;
        },
        set: function(el) {
            console.warn('[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead.');
            this.delegateTo = el;
        },
        enumerable: true,
        configurable: true
    });
    (0, $d24730ee5f0ecc22$export$29e00dfd3077644b)([
        (0, $364bffc95fff96d9$export$d02631cccf789723)(0, 1)
    ], Options.prototype, "damping", void 0);
    (0, $d24730ee5f0ecc22$export$29e00dfd3077644b)([
        (0, $364bffc95fff96d9$export$d02631cccf789723)(0, Infinity)
    ], Options.prototype, "thumbMinSize", void 0);
    (0, $d24730ee5f0ecc22$export$29e00dfd3077644b)([
        (0, $53a6aa0a6a97d9af$export$4a21f16c33752377)
    ], Options.prototype, "renderByPixels", void 0);
    (0, $d24730ee5f0ecc22$export$29e00dfd3077644b)([
        (0, $53a6aa0a6a97d9af$export$4a21f16c33752377)
    ], Options.prototype, "alwaysShowTracks", void 0);
    (0, $d24730ee5f0ecc22$export$29e00dfd3077644b)([
        (0, $53a6aa0a6a97d9af$export$4a21f16c33752377)
    ], Options.prototype, "continuousScrolling", void 0);
    return Options;
}();





var $a7fc62ed37f116a4$export$2d4c17c1fb94ad57;
(function(TrackDirection) {
    TrackDirection["X"] = "x";
    TrackDirection["Y"] = "y";
})($a7fc62ed37f116a4$export$2d4c17c1fb94ad57 || ($a7fc62ed37f116a4$export$2d4c17c1fb94ad57 = {}));



var $744489451c8c30eb$export$2d610e681b8dabf8 = /** @class */ function() {
    function ScrollbarThumb(_direction, _minSize) {
        if (_minSize === void 0) _minSize = 0;
        this._direction = _direction;
        this._minSize = _minSize;
        /**
         * Thumb element
         */ this.element = document.createElement('div');
        /**
         * Display size of the thumb
         * will always be greater than `scrollbar.options.thumbMinSize`
         */ this.displaySize = 0;
        /**
         * Actual size of the thumb
         */ this.realSize = 0;
        /**
         * Thumb offset to the top
         */ this.offset = 0;
        this.element.className = "scrollbar-thumb scrollbar-thumb-" + _direction;
    }
    /**
     * Attach to track element
     *
     * @param trackEl Track element
     */ ScrollbarThumb.prototype.attachTo = function(trackEl) {
        trackEl.appendChild(this.element);
    };
    ScrollbarThumb.prototype.update = function(scrollOffset, containerSize, pageSize) {
        // calculate thumb size
        // pageSize > containerSize -> scrollable
        this.realSize = Math.min(containerSize / pageSize, 1) * containerSize;
        this.displaySize = Math.max(this.realSize, this._minSize);
        // calculate thumb offset
        this.offset = scrollOffset / pageSize * (containerSize + (this.realSize - this.displaySize));
        (0, $7e99e1fbb0d7cf76$export$37a5fde709c1db82)(this.element, this._getStyle());
    };
    ScrollbarThumb.prototype._getStyle = function() {
        switch(this._direction){
            case (0, $a7fc62ed37f116a4$export$2d4c17c1fb94ad57).X:
                return {
                    width: this.displaySize + "px",
                    '-transform': "translate3d(" + this.offset + "px, 0, 0)"
                };
            case (0, $a7fc62ed37f116a4$export$2d4c17c1fb94ad57).Y:
                return {
                    height: this.displaySize + "px",
                    '-transform': "translate3d(0, " + this.offset + "px, 0)"
                };
            default:
                return null;
        }
    };
    return ScrollbarThumb;
}();



var $1b1f05a32169df0b$export$9e82a9d3e0d2088 = /** @class */ function() {
    function ScrollbarTrack(direction, thumbMinSize) {
        if (thumbMinSize === void 0) thumbMinSize = 0;
        /**
         * Track element
         */ this.element = document.createElement('div');
        this._isShown = false;
        this.element.className = "scrollbar-track scrollbar-track-" + direction;
        this.thumb = new (0, $744489451c8c30eb$export$2d610e681b8dabf8)(direction, thumbMinSize);
        this.thumb.attachTo(this.element);
    }
    /**
     * Attach to scrollbar container element
     *
     * @param scrollbarContainer Scrollbar container element
     */ ScrollbarTrack.prototype.attachTo = function(scrollbarContainer) {
        scrollbarContainer.appendChild(this.element);
    };
    /**
     * Show track immediately
     */ ScrollbarTrack.prototype.show = function() {
        if (this._isShown) return;
        this._isShown = true;
        this.element.classList.add('show');
    };
    /**
     * Hide track immediately
     */ ScrollbarTrack.prototype.hide = function() {
        if (!this._isShown) return;
        this._isShown = false;
        this.element.classList.remove('show');
    };
    ScrollbarTrack.prototype.update = function(scrollOffset, containerSize, pageSize) {
        (0, $7e99e1fbb0d7cf76$export$37a5fde709c1db82)(this.element, {
            display: pageSize <= containerSize ? 'none' : 'block'
        });
        this.thumb.update(scrollOffset, containerSize, pageSize);
    };
    return ScrollbarTrack;
}();




var $84eb28b40e8dfb1e$export$40a0242a5dec07f5 = /** @class */ function() {
    function TrackController(_scrollbar) {
        this._scrollbar = _scrollbar;
        var thumbMinSize = _scrollbar.options.thumbMinSize;
        this.xAxis = new (0, $1b1f05a32169df0b$export$9e82a9d3e0d2088)((0, $a7fc62ed37f116a4$export$2d4c17c1fb94ad57).X, thumbMinSize);
        this.yAxis = new (0, $1b1f05a32169df0b$export$9e82a9d3e0d2088)((0, $a7fc62ed37f116a4$export$2d4c17c1fb94ad57).Y, thumbMinSize);
        this.xAxis.attachTo(_scrollbar.containerEl);
        this.yAxis.attachTo(_scrollbar.containerEl);
        if (_scrollbar.options.alwaysShowTracks) {
            this.xAxis.show();
            this.yAxis.show();
        }
    }
    /**
     * Updates track appearance
     */ TrackController.prototype.update = function() {
        var _a = this._scrollbar, size = _a.size, offset = _a.offset;
        this.xAxis.update(offset.x, size.container.width, size.content.width);
        this.yAxis.update(offset.y, size.container.height, size.content.height);
    };
    /**
     * Automatically hide tracks when scrollbar is in idle state
     */ TrackController.prototype.autoHideOnIdle = function() {
        if (this._scrollbar.options.alwaysShowTracks) return;
        this.xAxis.hide();
        this.yAxis.hide();
    };
    (0, $d24730ee5f0ecc22$export$29e00dfd3077644b)([
        (0, $90125405ecd89861$export$61fc7d43ac8f84b0)(300)
    ], TrackController.prototype, "autoHideOnIdle", null);
    return TrackController;
}();


function $bcd5423be609cbe9$export$31b21d0167753bb4(scrollbar) {
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl;
    var containerStyles = getComputedStyle(containerEl);
    var paddings = [
        'paddingTop',
        'paddingBottom',
        'paddingLeft',
        'paddingRight'
    ].map(function(prop) {
        return containerStyles[prop] ? parseFloat(containerStyles[prop]) : 0;
    });
    var verticalPadding = paddings[0] + paddings[1];
    var horizontalPadding = paddings[2] + paddings[3];
    return {
        container: {
            // requires `overflow: hidden`
            width: containerEl.clientWidth,
            height: containerEl.clientHeight
        },
        content: {
            // border width and paddings should be included
            width: contentEl.offsetWidth - contentEl.clientWidth + contentEl.scrollWidth + horizontalPadding,
            height: contentEl.offsetHeight - contentEl.clientHeight + contentEl.scrollHeight + verticalPadding
        }
    };
}


function $47d160b8343dd967$export$795910f5f15a9633(scrollbar, elem) {
    var bounding = scrollbar.bounding;
    var targetBounding = elem.getBoundingClientRect();
    // check overlapping
    var top = Math.max(bounding.top, targetBounding.top);
    var left = Math.max(bounding.left, targetBounding.left);
    var right = Math.min(bounding.right, targetBounding.right);
    var bottom = Math.min(bounding.bottom, targetBounding.bottom);
    return top < bottom && left < right;
}


function $cea822e4b8a89504$export$722fbec263ad908a(scrollbar) {
    var newSize = scrollbar.getSize();
    var limit = {
        x: Math.max(newSize.content.width - newSize.container.width, 0),
        y: Math.max(newSize.content.height - newSize.container.height, 0)
    };
    // metrics
    var containerBounding = scrollbar.containerEl.getBoundingClientRect();
    var bounding = {
        top: Math.max(containerBounding.top, 0),
        right: Math.min(containerBounding.right, window.innerWidth),
        bottom: Math.min(containerBounding.bottom, window.innerHeight),
        left: Math.max(containerBounding.left, 0)
    };
    // assign props
    scrollbar.size = newSize;
    scrollbar.limit = limit;
    scrollbar.bounding = bounding;
    // update tracks
    scrollbar.track.update();
    // re-positioning
    scrollbar.setPosition();
}







function $2a1a9e819405b0e8$export$f9b088a47202d605(scrollbar, x, y) {
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit, track = scrollbar.track, contentEl = scrollbar.contentEl;
    if (options.renderByPixels) {
        x = Math.round(x);
        y = Math.round(y);
    }
    x = (0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(x, 0, limit.x);
    y = (0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(y, 0, limit.y);
    // position changed -> show track for 300ms
    if (x !== offset.x) track.xAxis.show();
    if (y !== offset.y) track.yAxis.show();
    if (!options.alwaysShowTracks) track.autoHideOnIdle();
    if (x === offset.x && y === offset.y) return null;
    offset.x = x;
    offset.y = y;
    (0, $7e99e1fbb0d7cf76$export$37a5fde709c1db82)(contentEl, {
        '-transform': "translate3d(" + -x + "px, " + -y + "px, 0)"
    });
    track.update();
    return {
        offset: (0, $d24730ee5f0ecc22$export$18ce0697a983be9b)({}, offset),
        limit: (0, $d24730ee5f0ecc22$export$18ce0697a983be9b)({}, limit)
    };
}



var $e9da79b46c42cf39$var$animationIDStorage = new WeakMap();
function $e9da79b46c42cf39$export$3f99968195accfaf(scrollbar, x, y, duration, _a) {
    if (duration === void 0) duration = 0;
    var _b = _a === void 0 ? {} : _a, _c = _b.easing, easing = _c === void 0 ? $e9da79b46c42cf39$var$defaultEasing : _c, callback = _b.callback;
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit;
    if (options.renderByPixels) {
        // ensure resolved with integer
        x = Math.round(x);
        y = Math.round(y);
    }
    var startX = offset.x;
    var startY = offset.y;
    var disX = (0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(x, 0, limit.x) - startX;
    var disY = (0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(y, 0, limit.y) - startY;
    var start = Date.now();
    function scroll() {
        var elapse = Date.now() - start;
        var progress = duration ? easing(Math.min(elapse / duration, 1)) : 1;
        scrollbar.setPosition(startX + disX * progress, startY + disY * progress);
        if (elapse >= duration) {
            if (typeof callback === 'function') callback.call(scrollbar);
        } else {
            var animationID = requestAnimationFrame(scroll);
            $e9da79b46c42cf39$var$animationIDStorage.set(scrollbar, animationID);
        }
    }
    cancelAnimationFrame($e9da79b46c42cf39$var$animationIDStorage.get(scrollbar));
    scroll();
}
/**
 * easeOutCubic
 */ function $e9da79b46c42cf39$var$defaultEasing(t) {
    return Math.pow(t - 1, 3) + 1;
}



function $ab973bcbd2706f4c$export$53a0910f038337bd(scrollbar, elem, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.alignToTop, alignToTop = _c === void 0 ? true : _c, _d = _b.onlyScrollIfNeeded, onlyScrollIfNeeded = _d === void 0 ? false : _d, _e = _b.offsetTop, offsetTop = _e === void 0 ? 0 : _e, _f = _b.offsetLeft, offsetLeft = _f === void 0 ? 0 : _f, _g = _b.offsetBottom, offsetBottom = _g === void 0 ? 0 : _g;
    var containerEl = scrollbar.containerEl, bounding = scrollbar.bounding, offset = scrollbar.offset, limit = scrollbar.limit;
    if (!elem || !containerEl.contains(elem)) return;
    var targetBounding = elem.getBoundingClientRect();
    if (onlyScrollIfNeeded && scrollbar.isVisible(elem)) return;
    var delta = alignToTop ? targetBounding.top - bounding.top - offsetTop : targetBounding.bottom - bounding.bottom + offsetBottom;
    scrollbar.setMomentum(targetBounding.left - bounding.left - offsetLeft, (0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(delta, -offset.y, limit.y - offset.y));
}





var $35c3ee4c1655e1df$export$db53f857c251fca3 = /** @class */ function() {
    function ScrollbarPlugin(scrollbar, options) {
        var _newTarget = this.constructor;
        this.scrollbar = scrollbar;
        this.name = _newTarget.pluginName;
        this.options = (0, $d24730ee5f0ecc22$export$18ce0697a983be9b)((0, $d24730ee5f0ecc22$export$18ce0697a983be9b)({}, _newTarget.defaultOptions), options);
    }
    ScrollbarPlugin.prototype.onInit = function() {};
    ScrollbarPlugin.prototype.onDestroy = function() {};
    ScrollbarPlugin.prototype.onUpdate = function() {};
    ScrollbarPlugin.prototype.onRender = function(_remainMomentum) {};
    ScrollbarPlugin.prototype.transformDelta = function(delta, _evt) {
        return (0, $d24730ee5f0ecc22$export$18ce0697a983be9b)({}, delta);
    };
    ScrollbarPlugin.pluginName = '';
    ScrollbarPlugin.defaultOptions = {};
    return ScrollbarPlugin;
}();
var $35c3ee4c1655e1df$export$905153d94e0757fa = {
    order: new Set(),
    constructors: {}
};
function $35c3ee4c1655e1df$export$19ec5365ea6ce8cf() {
    var Plugins = [];
    for(var _i = 0; _i < arguments.length; _i++)Plugins[_i] = arguments[_i];
    Plugins.forEach(function(P) {
        var pluginName = P.pluginName;
        if (!pluginName) throw new TypeError("plugin name is required");
        $35c3ee4c1655e1df$export$905153d94e0757fa.order.add(pluginName);
        $35c3ee4c1655e1df$export$905153d94e0757fa.constructors[pluginName] = P;
    });
}
function $35c3ee4c1655e1df$export$d117388934d9aaf6(scrollbar, options) {
    return Array.from($35c3ee4c1655e1df$export$905153d94e0757fa.order).filter(function(pluginName) {
        return options[pluginName] !== false;
    }).map(function(pluginName) {
        var Plugin = $35c3ee4c1655e1df$export$905153d94e0757fa.constructors[pluginName];
        var instance = new Plugin(scrollbar, options[pluginName]);
        // bind plugin options to `scrollbar.options`
        options[pluginName] = instance.options;
        return instance;
    });
}


var $a75ea76ba84e9191$exports = {};
var $57edbe51eb2166ab$exports = {};

$parcel$export($57edbe51eb2166ab$exports, "keyboardHandler", function () { return $57edbe51eb2166ab$export$6ff2ab7955f7f068; });

var $57edbe51eb2166ab$var$KEY_CODE;
(function(KEY_CODE) {
    KEY_CODE[KEY_CODE["TAB"] = 9] = "TAB";
    KEY_CODE[KEY_CODE["SPACE"] = 32] = "SPACE";
    KEY_CODE[KEY_CODE["PAGE_UP"] = 33] = "PAGE_UP";
    KEY_CODE[KEY_CODE["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KEY_CODE[KEY_CODE["END"] = 35] = "END";
    KEY_CODE[KEY_CODE["HOME"] = 36] = "HOME";
    KEY_CODE[KEY_CODE["LEFT"] = 37] = "LEFT";
    KEY_CODE[KEY_CODE["UP"] = 38] = "UP";
    KEY_CODE[KEY_CODE["RIGHT"] = 39] = "RIGHT";
    KEY_CODE[KEY_CODE["DOWN"] = 40] = "DOWN";
})($57edbe51eb2166ab$var$KEY_CODE || ($57edbe51eb2166ab$var$KEY_CODE = {}));
function $57edbe51eb2166ab$export$6ff2ab7955f7f068(scrollbar) {
    var addEvent = (0, $7e32d0dbe13ec8ca$export$cfedec40817575fe)(scrollbar);
    var container = scrollbar.containerEl;
    addEvent(container, 'keydown', function(evt) {
        var activeElement = document.activeElement;
        if (activeElement !== container && !container.contains(activeElement)) return;
        if ($57edbe51eb2166ab$var$isEditable(activeElement)) return;
        var delta = $57edbe51eb2166ab$var$getKeyDelta(scrollbar, evt.keyCode || evt.which);
        if (!delta) return;
        var x = delta[0], y = delta[1];
        scrollbar.addTransformableMomentum(x, y, evt, function(willScroll) {
            if (willScroll) evt.preventDefault();
            else {
                scrollbar.containerEl.blur();
                if (scrollbar.parent) scrollbar.parent.containerEl.focus();
            }
        });
    });
}
function $57edbe51eb2166ab$var$getKeyDelta(scrollbar, keyCode) {
    var size = scrollbar.size, limit = scrollbar.limit, offset = scrollbar.offset;
    switch(keyCode){
        case $57edbe51eb2166ab$var$KEY_CODE.TAB:
            return $57edbe51eb2166ab$var$handleTabKey(scrollbar);
        case $57edbe51eb2166ab$var$KEY_CODE.SPACE:
            return [
                0,
                200
            ];
        case $57edbe51eb2166ab$var$KEY_CODE.PAGE_UP:
            return [
                0,
                -size.container.height + 40
            ];
        case $57edbe51eb2166ab$var$KEY_CODE.PAGE_DOWN:
            return [
                0,
                size.container.height - 40
            ];
        case $57edbe51eb2166ab$var$KEY_CODE.END:
            return [
                0,
                limit.y - offset.y
            ];
        case $57edbe51eb2166ab$var$KEY_CODE.HOME:
            return [
                0,
                -offset.y
            ];
        case $57edbe51eb2166ab$var$KEY_CODE.LEFT:
            return [
                -40,
                0
            ];
        case $57edbe51eb2166ab$var$KEY_CODE.UP:
            return [
                0,
                -40
            ];
        case $57edbe51eb2166ab$var$KEY_CODE.RIGHT:
            return [
                40,
                0
            ];
        case $57edbe51eb2166ab$var$KEY_CODE.DOWN:
            return [
                0,
                40
            ];
        default:
            return null;
    }
}
function $57edbe51eb2166ab$var$handleTabKey(scrollbar) {
    // handle in next frame
    requestAnimationFrame(function() {
        scrollbar.scrollIntoView(document.activeElement, {
            offsetTop: scrollbar.size.container.height / 2,
            offsetLeft: scrollbar.size.container.width / 2,
            onlyScrollIfNeeded: true
        });
    });
}
function $57edbe51eb2166ab$var$isEditable(elem) {
    if (elem.tagName === 'INPUT' || elem.tagName === 'SELECT' || elem.tagName === 'TEXTAREA' || elem.isContentEditable) return !elem.disabled;
    return false;
}


var $929034511db1cb21$exports = {};

$parcel$export($929034511db1cb21$exports, "mouseHandler", function () { return $929034511db1cb21$export$242d43875ab79ce3; });


var $929034511db1cb21$var$Direction;
(function(Direction) {
    Direction[Direction["X"] = 0] = "X";
    Direction[Direction["Y"] = 1] = "Y";
})($929034511db1cb21$var$Direction || ($929034511db1cb21$var$Direction = {}));
function $929034511db1cb21$export$242d43875ab79ce3(scrollbar) {
    var addEvent = (0, $7e32d0dbe13ec8ca$export$cfedec40817575fe)(scrollbar);
    var container = scrollbar.containerEl;
    var _a = scrollbar.track, xAxis = _a.xAxis, yAxis = _a.yAxis;
    function calcMomentum(direction, clickPosition) {
        var size = scrollbar.size, limit = scrollbar.limit, offset = scrollbar.offset;
        if (direction === $929034511db1cb21$var$Direction.X) {
            var totalWidth = size.container.width + (xAxis.thumb.realSize - xAxis.thumb.displaySize);
            return (0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(clickPosition / totalWidth * size.content.width, 0, limit.x) - offset.x;
        }
        if (direction === $929034511db1cb21$var$Direction.Y) {
            var totalHeight = size.container.height + (yAxis.thumb.realSize - yAxis.thumb.displaySize);
            return (0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(clickPosition / totalHeight * size.content.height, 0, limit.y) - offset.y;
        }
        return 0;
    }
    function getTrackDirection(elem) {
        if ((0, $f84eba88c39f2d95$export$532a90c0e5e8e48c)(elem, [
            xAxis.element,
            xAxis.thumb.element
        ])) return $929034511db1cb21$var$Direction.X;
        if ((0, $f84eba88c39f2d95$export$532a90c0e5e8e48c)(elem, [
            yAxis.element,
            yAxis.thumb.element
        ])) return $929034511db1cb21$var$Direction.Y;
        return void 0;
    }
    var isMouseDown;
    var isMouseMoving;
    var startOffsetToThumb;
    var trackDirection;
    var containerRect;
    addEvent(container, 'click', function(evt) {
        if (isMouseMoving || !(0, $f84eba88c39f2d95$export$532a90c0e5e8e48c)(evt.target, [
            xAxis.element,
            yAxis.element
        ])) return;
        var track = evt.target;
        var direction = getTrackDirection(track);
        var rect = track.getBoundingClientRect();
        var clickPos = (0, $989197b988ce28b5$export$1690e12b840569b9)(evt);
        if (direction === $929034511db1cb21$var$Direction.X) {
            var offsetOnTrack = clickPos.x - rect.left - xAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(calcMomentum(direction, offsetOnTrack), 0);
        }
        if (direction === $929034511db1cb21$var$Direction.Y) {
            var offsetOnTrack = clickPos.y - rect.top - yAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(0, calcMomentum(direction, offsetOnTrack));
        }
    });
    addEvent(container, 'mousedown', function(evt) {
        if (!(0, $f84eba88c39f2d95$export$532a90c0e5e8e48c)(evt.target, [
            xAxis.thumb.element,
            yAxis.thumb.element
        ])) return;
        isMouseDown = true;
        var thumb = evt.target;
        var cursorPos = (0, $989197b988ce28b5$export$1690e12b840569b9)(evt);
        var thumbRect = thumb.getBoundingClientRect();
        trackDirection = getTrackDirection(thumb);
        // pointer offset to thumb
        startOffsetToThumb = {
            x: cursorPos.x - thumbRect.left,
            y: cursorPos.y - thumbRect.top
        };
        // container bounding rectangle
        containerRect = container.getBoundingClientRect();
        // prevent selection, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/48
        (0, $7e99e1fbb0d7cf76$export$37a5fde709c1db82)(scrollbar.containerEl, {
            '-user-select': 'none'
        });
    });
    addEvent(window, 'mousemove', function(evt) {
        if (!isMouseDown) return;
        isMouseMoving = true;
        var cursorPos = (0, $989197b988ce28b5$export$1690e12b840569b9)(evt);
        if (trackDirection === $929034511db1cb21$var$Direction.X) {
            // get percentage of pointer position in track
            // then tranform to px
            // don't need easing
            var offsetOnTrack = cursorPos.x - startOffsetToThumb.x - containerRect.left;
            scrollbar.setMomentum(calcMomentum(trackDirection, offsetOnTrack), 0);
        }
        if (trackDirection === $929034511db1cb21$var$Direction.Y) {
            var offsetOnTrack = cursorPos.y - startOffsetToThumb.y - containerRect.top;
            scrollbar.setMomentum(0, calcMomentum(trackDirection, offsetOnTrack));
        }
    });
    addEvent(window, 'mouseup blur', function() {
        isMouseDown = isMouseMoving = false;
        (0, $7e99e1fbb0d7cf76$export$37a5fde709c1db82)(scrollbar.containerEl, {
            '-user-select': ''
        });
    });
}


var $4064fac6477939ad$exports = {};

$parcel$export($4064fac6477939ad$exports, "resizeHandler", function () { return $4064fac6477939ad$export$53d88fe222065052; });


function $4064fac6477939ad$export$53d88fe222065052(scrollbar) {
    var addEvent = (0, $7e32d0dbe13ec8ca$export$cfedec40817575fe)(scrollbar);
    addEvent(window, 'resize', (0, $e20bc1b3be085f95$export$61fc7d43ac8f84b0)(scrollbar.update.bind(scrollbar), 300));
}


var $b86f1767bc7da6b2$exports = {};

$parcel$export($b86f1767bc7da6b2$exports, "selectHandler", function () { return $b86f1767bc7da6b2$export$77907cd5c206b555; });


function $b86f1767bc7da6b2$export$77907cd5c206b555(scrollbar) {
    var addEvent = (0, $7e32d0dbe13ec8ca$export$cfedec40817575fe)(scrollbar);
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl;
    var isSelected = false;
    var isContextMenuOpened = false; // flag to prevent selection when context menu is opened
    var animationID;
    function scroll(_a) {
        var x = _a.x, y = _a.y;
        if (!x && !y) return;
        var offset = scrollbar.offset, limit = scrollbar.limit;
        // DISALLOW delta transformation
        scrollbar.setMomentum((0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(offset.x + x, 0, limit.x) - offset.x, (0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(offset.y + y, 0, limit.y) - offset.y);
        animationID = requestAnimationFrame(function() {
            scroll({
                x: x,
                y: y
            });
        });
    }
    addEvent(window, 'mousemove', function(evt) {
        if (!isSelected) return;
        cancelAnimationFrame(animationID);
        var dir = $b86f1767bc7da6b2$var$calcMomentum(scrollbar, evt);
        scroll(dir);
    });
    // prevent scrolling when context menu is opened
    // NOTE: `contextmenu` event may be fired
    //          1. BEFORE `selectstart`: when user right-clicks on the text content -> prevent future scrolling,
    //          2. AFTER `selectstart`: when user right-clicks on the blank area -> cancel current scrolling,
    //        so we need to both set the flag and cancel current scrolling
    addEvent(contentEl, 'contextmenu', function() {
        // set the flag to prevent future scrolling
        isContextMenuOpened = true;
        // stop current scrolling
        cancelAnimationFrame(animationID);
        isSelected = false;
    });
    // reset context menu flag on mouse down
    // to ensure the scrolling is allowed in the next selection
    addEvent(contentEl, 'mousedown', function() {
        isContextMenuOpened = false;
    });
    addEvent(contentEl, 'selectstart', function() {
        if (isContextMenuOpened) return;
        cancelAnimationFrame(animationID);
        isSelected = true;
    });
    addEvent(window, 'mouseup blur', function() {
        cancelAnimationFrame(animationID);
        isSelected = false;
        isContextMenuOpened = false;
    });
    // patch for touch devices
    addEvent(containerEl, 'scroll', function(evt) {
        evt.preventDefault();
        containerEl.scrollTop = containerEl.scrollLeft = 0;
    });
}
function $b86f1767bc7da6b2$var$calcMomentum(scrollbar, evt) {
    var _a = scrollbar.bounding, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
    var _b = (0, $989197b988ce28b5$export$1690e12b840569b9)(evt), x = _b.x, y = _b.y;
    var res = {
        x: 0,
        y: 0
    };
    var padding = 20;
    if (x === 0 && y === 0) return res;
    if (x > right - padding) res.x = x - right + padding;
    else if (x < left + padding) res.x = x - left - padding;
    if (y > bottom - padding) res.y = y - bottom + padding;
    else if (y < top + padding) res.y = y - top - padding;
    res.x *= 2;
    res.y *= 2;
    return res;
}


var $3d4eb52b49e80e28$exports = {};

$parcel$export($3d4eb52b49e80e28$exports, "touchHandler", function () { return $3d4eb52b49e80e28$export$2916e5349c3e671c; });

var $3d4eb52b49e80e28$var$activeScrollbar;
function $3d4eb52b49e80e28$export$2916e5349c3e671c(scrollbar) {
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var touchRecord = new (0, $5bf738deeb5a11e4$export$9da4f16074124683)();
    var addEvent = (0, $7e32d0dbe13ec8ca$export$cfedec40817575fe)(scrollbar);
    var damping;
    var pointerCount = 0;
    addEvent(target, 'touchstart', function(evt) {
        // start records
        touchRecord.track(evt);
        // stop scrolling
        scrollbar.setMomentum(0, 0);
        // save damping
        if (pointerCount === 0) {
            damping = scrollbar.options.damping;
            scrollbar.options.damping = Math.max(damping, 0.5); // less frames on touchmove
        }
        pointerCount++;
    });
    addEvent(target, 'touchmove', function(evt) {
        if ($3d4eb52b49e80e28$var$activeScrollbar && $3d4eb52b49e80e28$var$activeScrollbar !== scrollbar) return;
        touchRecord.update(evt);
        var _a = touchRecord.getDelta(), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function(willScroll) {
            if (willScroll && evt.cancelable) {
                evt.preventDefault();
                $3d4eb52b49e80e28$var$activeScrollbar = scrollbar;
            }
        });
    });
    addEvent(target, 'touchcancel touchend', function(evt) {
        var delta = touchRecord.getEasingDistance(damping);
        scrollbar.addTransformableMomentum(delta.x, delta.y, evt);
        pointerCount--;
        // restore damping
        if (pointerCount === 0) scrollbar.options.damping = damping;
        touchRecord.release(evt);
        $3d4eb52b49e80e28$var$activeScrollbar = null;
    });
}


var $222593b45e2a5666$exports = {};

$parcel$export($222593b45e2a5666$exports, "wheelHandler", function () { return $222593b45e2a5666$export$14c83f6c8045ea84; });

function $222593b45e2a5666$export$14c83f6c8045ea84(scrollbar) {
    var addEvent = (0, $7e32d0dbe13ec8ca$export$cfedec40817575fe)(scrollbar);
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var eventName = 'onwheel' in window || document.implementation.hasFeature('Events.wheel', '3.0') ? 'wheel' : 'mousewheel';
    addEvent(target, eventName, function(evt) {
        var _a = $222593b45e2a5666$var$normalizeDelta(evt), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function(willScroll) {
            if (willScroll) evt.preventDefault();
        });
    });
}
// Normalizing wheel delta
var $222593b45e2a5666$var$DELTA_SCALE = {
    STANDARD: 1,
    OTHERS: -3
};
var $222593b45e2a5666$var$DELTA_MODE = [
    1.0,
    28.0,
    500.0
];
var $222593b45e2a5666$var$getDeltaMode = function(mode) {
    return $222593b45e2a5666$var$DELTA_MODE[mode] || $222593b45e2a5666$var$DELTA_MODE[0];
};
function $222593b45e2a5666$var$normalizeDelta(evt) {
    if ('deltaX' in evt) {
        var mode = $222593b45e2a5666$var$getDeltaMode(evt.deltaMode);
        return {
            x: evt.deltaX / $222593b45e2a5666$var$DELTA_SCALE.STANDARD * mode,
            y: evt.deltaY / $222593b45e2a5666$var$DELTA_SCALE.STANDARD * mode
        };
    }
    if ('wheelDeltaX' in evt) return {
        x: evt.wheelDeltaX / $222593b45e2a5666$var$DELTA_SCALE.OTHERS,
        y: evt.wheelDeltaY / $222593b45e2a5666$var$DELTA_SCALE.OTHERS
    };
    // ie with touchpad
    return {
        x: 0,
        y: evt.wheelDelta / $222593b45e2a5666$var$DELTA_SCALE.OTHERS
    };
}


$parcel$exportWildcard($a75ea76ba84e9191$exports, $57edbe51eb2166ab$exports);
$parcel$exportWildcard($a75ea76ba84e9191$exports, $929034511db1cb21$exports);
$parcel$exportWildcard($a75ea76ba84e9191$exports, $4064fac6477939ad$exports);
$parcel$exportWildcard($a75ea76ba84e9191$exports, $b86f1767bc7da6b2$exports);
$parcel$exportWildcard($a75ea76ba84e9191$exports, $3d4eb52b49e80e28$exports);
$parcel$exportWildcard($a75ea76ba84e9191$exports, $222593b45e2a5666$exports);


var $0237c2acd2d653a0$export$18a24ca5e48929da = new Map();
var $0237c2acd2d653a0$export$9a4e88b92edfce6b = /** @class */ function() {
    function Scrollbar(containerEl, options) {
        var _this = this;
        /**
         * Current scrolling offsets
         */ this.offset = {
            x: 0,
            y: 0
        };
        /**
         * Max-allowed scrolling offsets
         */ this.limit = {
            x: Infinity,
            y: Infinity
        };
        /**
         * Container bounding rect
         */ this.bounding = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
        // private _observer: ResizeObserver;
        this._plugins = [];
        this._momentum = {
            x: 0,
            y: 0
        };
        this._listeners = new Set();
        this.containerEl = containerEl;
        var contentEl = this.contentEl = document.createElement('div');
        this.options = new (0, $f64dcb84f514b3ef$export$c019608e5b5bb4cb)(options);
        // mark as a scroll element
        containerEl.setAttribute('data-scrollbar', 'true');
        // make container focusable
        containerEl.setAttribute('tabindex', '-1');
        (0, $7e99e1fbb0d7cf76$export$37a5fde709c1db82)(containerEl, {
            overflow: 'hidden',
            outline: 'none'
        });
        // enable touch event capturing in IE, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/39
        if (window.navigator.msPointerEnabled) containerEl.style.msTouchAction = 'none';
        // mount content
        contentEl.className = 'scroll-content';
        Array.from(containerEl.childNodes).forEach(function(node) {
            contentEl.appendChild(node);
        });
        containerEl.appendChild(contentEl);
        // attach track
        this.track = new (0, $84eb28b40e8dfb1e$export$40a0242a5dec07f5)(this);
        // initial measuring
        this.size = this.getSize();
        // init plugins
        this._plugins = (0, $35c3ee4c1655e1df$export$d117388934d9aaf6)(this, this.options.plugins);
        // preserve scroll offset
        var scrollLeft = containerEl.scrollLeft, scrollTop = containerEl.scrollTop;
        containerEl.scrollLeft = containerEl.scrollTop = 0;
        this.setPosition(scrollLeft, scrollTop, {
            withoutCallbacks: true
        });
        // FIXME: update typescript
        var ResizeObserver = window.ResizeObserver;
        // observe
        if (typeof ResizeObserver === 'function') {
            this._observer = new ResizeObserver(function() {
                _this.update();
            });
            this._observer.observe(contentEl);
        }
        $0237c2acd2d653a0$export$18a24ca5e48929da.set(containerEl, this);
        // wait for DOM ready
        requestAnimationFrame(function() {
            _this._init();
        });
    }
    Object.defineProperty(Scrollbar.prototype, "parent", {
        /**
         * Parent scrollbar
         */ get: function() {
            var elem = this.containerEl.parentElement;
            while(elem){
                var parentScrollbar = $0237c2acd2d653a0$export$18a24ca5e48929da.get(elem);
                if (parentScrollbar) return parentScrollbar;
                elem = elem.parentElement;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollTop", {
        /**
         * Gets or sets `scrollbar.offset.y`
         */ get: function() {
            return this.offset.y;
        },
        set: function(y) {
            this.setPosition(this.scrollLeft, y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollLeft", {
        /**
         * Gets or sets `scrollbar.offset.x`
         */ get: function() {
            return this.offset.x;
        },
        set: function(x) {
            this.setPosition(x, this.scrollTop);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the size of the scrollbar container element
     * and the content wrapper element
     */ Scrollbar.prototype.getSize = function() {
        return (0, $bcd5423be609cbe9$export$31b21d0167753bb4)(this);
    };
    /**
     * Forces scrollbar to update geometry infomation.
     *
     * By default, scrollbars are automatically updated with `100ms` debounce (or `MutationObserver` fires).
     * You can call this method to force an update when you modified contents
     */ Scrollbar.prototype.update = function() {
        (0, $cea822e4b8a89504$export$722fbec263ad908a)(this);
        this._plugins.forEach(function(plugin) {
            plugin.onUpdate();
        });
    };
    /**
     * Checks if an element is visible in the current view area
     */ Scrollbar.prototype.isVisible = function(elem) {
        return (0, $47d160b8343dd967$export$795910f5f15a9633)(this, elem);
    };
    /**
     * Sets the scrollbar to the given offset without easing
     */ Scrollbar.prototype.setPosition = function(x, y, options) {
        var _this = this;
        if (x === void 0) x = this.offset.x;
        if (y === void 0) y = this.offset.y;
        if (options === void 0) options = {};
        var status = (0, $2a1a9e819405b0e8$export$f9b088a47202d605)(this, x, y);
        if (!status || options.withoutCallbacks) return;
        this._listeners.forEach(function(fn) {
            fn.call(_this, status);
        });
    };
    /**
     * Scrolls to given position with easing function
     */ Scrollbar.prototype.scrollTo = function(x, y, duration, options) {
        if (x === void 0) x = this.offset.x;
        if (y === void 0) y = this.offset.y;
        if (duration === void 0) duration = 0;
        if (options === void 0) options = {};
        (0, $e9da79b46c42cf39$export$3f99968195accfaf)(this, x, y, duration, options);
    };
    /**
     * Scrolls the target element into visible area of scrollbar,
     * likes the DOM method `element.scrollIntoView().
     */ Scrollbar.prototype.scrollIntoView = function(elem, options) {
        if (options === void 0) options = {};
        (0, $ab973bcbd2706f4c$export$53a0910f038337bd)(this, elem, options);
    };
    /**
     * Adds scrolling listener
     */ Scrollbar.prototype.addListener = function(fn) {
        if (typeof fn !== 'function') throw new TypeError('[smooth-scrollbar] scrolling listener should be a function');
        this._listeners.add(fn);
    };
    /**
     * Removes listener previously registered with `scrollbar.addListener()`
     */ Scrollbar.prototype.removeListener = function(fn) {
        this._listeners.delete(fn);
    };
    /**
     * Adds momentum and applys delta transformers.
     */ Scrollbar.prototype.addTransformableMomentum = function(x, y, fromEvent, callback) {
        this._updateDebounced();
        var finalDelta = this._plugins.reduce(function(delta, plugin) {
            return plugin.transformDelta(delta, fromEvent) || delta;
        }, {
            x: x,
            y: y
        });
        var willScroll = !this._shouldPropagateMomentum(finalDelta.x, finalDelta.y);
        if (willScroll) this.addMomentum(finalDelta.x, finalDelta.y);
        if (callback) callback.call(this, willScroll);
    };
    /**
     * Increases scrollbar's momentum
     */ Scrollbar.prototype.addMomentum = function(x, y) {
        this.setMomentum(this._momentum.x + x, this._momentum.y + y);
    };
    /**
     * Sets scrollbar's momentum to given value
     */ Scrollbar.prototype.setMomentum = function(x, y) {
        if (this.limit.x === 0) x = 0;
        if (this.limit.y === 0) y = 0;
        if (this.options.renderByPixels) {
            x = Math.round(x);
            y = Math.round(y);
        }
        this._momentum.x = x;
        this._momentum.y = y;
    };
    /**
     * Update options for specific plugin
     *
     * @param pluginName Name of the plugin
     * @param [options] An object includes the properties that you want to update
     */ Scrollbar.prototype.updatePluginOptions = function(pluginName, options) {
        this._plugins.forEach(function(plugin) {
            if (plugin.name === pluginName) Object.assign(plugin.options, options);
        });
    };
    Scrollbar.prototype.destroy = function() {
        var _a = this, containerEl = _a.containerEl, contentEl = _a.contentEl;
        (0, $7e32d0dbe13ec8ca$export$2bf7a27f443e4893)(this);
        this._listeners.clear();
        this.setMomentum(0, 0);
        cancelAnimationFrame(this._renderID);
        if (this._observer) this._observer.disconnect();
        $0237c2acd2d653a0$export$18a24ca5e48929da.delete(this.containerEl);
        // restore contents
        var childNodes = Array.from(contentEl.childNodes);
        while(containerEl.firstChild)containerEl.removeChild(containerEl.firstChild);
        childNodes.forEach(function(el) {
            containerEl.appendChild(el);
        });
        // reset scroll position
        (0, $7e99e1fbb0d7cf76$export$37a5fde709c1db82)(containerEl, {
            overflow: ''
        });
        containerEl.scrollTop = this.scrollTop;
        containerEl.scrollLeft = this.scrollLeft;
        // invoke plugin.onDestroy
        this._plugins.forEach(function(plugin) {
            plugin.onDestroy();
        });
        this._plugins.length = 0;
    };
    Scrollbar.prototype._init = function() {
        var _this = this;
        this.update();
        // init evet handlers
        Object.keys($a75ea76ba84e9191$exports).forEach(function(prop) {
            $a75ea76ba84e9191$exports[prop](_this);
        });
        // invoke `plugin.onInit`
        this._plugins.forEach(function(plugin) {
            plugin.onInit();
        });
        this._render();
    };
    Scrollbar.prototype._updateDebounced = function() {
        this.update();
    };
    // check whether to propagate monmentum to parent scrollbar
    // the following situations are considered as `true`:
    //         1. continuous scrolling is enabled (automatically disabled when overscroll is enabled)
    //         2. scrollbar reaches one side and is not about to scroll on the other direction
    Scrollbar.prototype._shouldPropagateMomentum = function(deltaX, deltaY) {
        if (deltaX === void 0) deltaX = 0;
        if (deltaY === void 0) deltaY = 0;
        var _a = this, options = _a.options, offset = _a.offset, limit = _a.limit;
        if (!options.continuousScrolling) return false;
        // force an update when scrollbar is "unscrollable", see #106
        if (limit.x === 0 && limit.y === 0) this._updateDebounced();
        var destX = (0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(deltaX + offset.x, 0, limit.x);
        var destY = (0, $94627d9ae24ebbbe$export$7d15b64cf5a3a4c4)(deltaY + offset.y, 0, limit.y);
        var res = true;
        // offsets are not about to change
        // `&=` operator is not allowed for boolean types
        res = res && destX === offset.x;
        res = res && destY === offset.y;
        // current offsets are on the edge
        res = res && (offset.x === limit.x || offset.x === 0 || offset.y === limit.y || offset.y === 0);
        return res;
    };
    Scrollbar.prototype._render = function() {
        var _momentum = this._momentum;
        if (_momentum.x || _momentum.y) {
            var nextX = this._nextTick('x');
            var nextY = this._nextTick('y');
            _momentum.x = nextX.momentum;
            _momentum.y = nextY.momentum;
            this.setPosition(nextX.position, nextY.position);
        }
        var remain = (0, $d24730ee5f0ecc22$export$18ce0697a983be9b)({}, this._momentum);
        this._plugins.forEach(function(plugin) {
            plugin.onRender(remain);
        });
        this._renderID = requestAnimationFrame(this._render.bind(this));
    };
    Scrollbar.prototype._nextTick = function(direction) {
        var _a = this, options = _a.options, offset = _a.offset, _momentum = _a._momentum;
        var current = offset[direction];
        var remain = _momentum[direction];
        if (Math.abs(remain) <= 0.1) return {
            momentum: 0,
            position: current + remain
        };
        var nextMomentum = remain * (1 - options.damping);
        if (options.renderByPixels) nextMomentum |= 0;
        return {
            momentum: nextMomentum,
            position: current + remain - nextMomentum
        };
    };
    (0, $d24730ee5f0ecc22$export$29e00dfd3077644b)([
        (0, $90125405ecd89861$export$61fc7d43ac8f84b0)(100, true)
    ], Scrollbar.prototype, "_updateDebounced", null);
    return Scrollbar;
}();



var $2cc45d62e0cf32da$var$TRACK_BG = 'rgba(222, 222, 222, .75)';
var $2cc45d62e0cf32da$var$THUMB_BG = 'rgba(0, 0, 0, .5)';
// sets content's display type to `flow-root` to suppress margin collapsing
var $2cc45d62e0cf32da$var$SCROLLBAR_STYLE = "\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  display: flow-root;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: " + $2cc45d62e0cf32da$var$TRACK_BG + ";\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: " + $2cc45d62e0cf32da$var$THUMB_BG + ";\n  border-radius: 4px;\n}\n";
var $2cc45d62e0cf32da$var$STYLE_ID = 'smooth-scrollbar-style';
var $2cc45d62e0cf32da$var$isStyleAttached = false;
function $2cc45d62e0cf32da$export$ff76c51b0f744e0a() {
    if ($2cc45d62e0cf32da$var$isStyleAttached || typeof window === 'undefined') return;
    var styleEl = document.createElement('style');
    styleEl.id = $2cc45d62e0cf32da$var$STYLE_ID;
    styleEl.textContent = $2cc45d62e0cf32da$var$SCROLLBAR_STYLE;
    if (document.head) document.head.appendChild(styleEl);
    $2cc45d62e0cf32da$var$isStyleAttached = true;
}
function $2cc45d62e0cf32da$export$11939e4e3dfbbb72() {
    if (!$2cc45d62e0cf32da$var$isStyleAttached || typeof window === 'undefined') return;
    var styleEl = document.getElementById($2cc45d62e0cf32da$var$STYLE_ID);
    if (!styleEl || !styleEl.parentNode) return;
    styleEl.parentNode.removeChild(styleEl);
    $2cc45d62e0cf32da$var$isStyleAttached = false;
}


/**
 * cast `I.Scrollbar` to `Scrollbar` to avoid error
 *
 * `I.Scrollbar` is not assignable to `Scrollbar`:
 *     "privateProp" is missing in `I.Scrollbar`
 *
 * @see https://github.com/Microsoft/TypeScript/issues/2672
 */ var $9dc7e4d744fa4d38$var$SmoothScrollbar = /** @class */ function(_super) {
    (0, $d24730ee5f0ecc22$export$a8ba968b8961cb8a)(SmoothScrollbar, _super);
    function SmoothScrollbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Initializes a scrollbar on the given element.
     *
     * @param elem The DOM element that you want to initialize scrollbar to
     * @param [options] Initial options
     */ SmoothScrollbar.init = function(elem, options) {
        if (!elem || elem.nodeType !== 1) throw new TypeError("expect element to be DOM Element, but got " + elem);
        // attach stylesheet
        (0, $2cc45d62e0cf32da$export$ff76c51b0f744e0a)();
        if ((0, $0237c2acd2d653a0$export$18a24ca5e48929da).has(elem)) return (0, $0237c2acd2d653a0$export$18a24ca5e48929da).get(elem);
        return new (0, $0237c2acd2d653a0$export$9a4e88b92edfce6b)(elem, options);
    };
    /**
     * Automatically init scrollbar on all elements base on the selector `[data-scrollbar]`
     *
     * @param options Initial options
     */ SmoothScrollbar.initAll = function(options) {
        return Array.from(document.querySelectorAll('[data-scrollbar]'), function(elem) {
            return SmoothScrollbar.init(elem, options);
        });
    };
    /**
     * Check if there is a scrollbar on given element
     *
     * @param elem The DOM element that you want to check
     */ SmoothScrollbar.has = function(elem) {
        return (0, $0237c2acd2d653a0$export$18a24ca5e48929da).has(elem);
    };
    /**
     * Gets scrollbar on the given element.
     * If no scrollbar instance exsits, returns `undefined`
     *
     * @param elem The DOM element that you want to check.
     */ SmoothScrollbar.get = function(elem) {
        return (0, $0237c2acd2d653a0$export$18a24ca5e48929da).get(elem);
    };
    /**
     * Returns an array that contains all scrollbar instances
     */ SmoothScrollbar.getAll = function() {
        return Array.from((0, $0237c2acd2d653a0$export$18a24ca5e48929da).values());
    };
    /**
     * Removes scrollbar on the given element
     */ SmoothScrollbar.destroy = function(elem) {
        var scrollbar = (0, $0237c2acd2d653a0$export$18a24ca5e48929da).get(elem);
        if (scrollbar) scrollbar.destroy();
    };
    /**
     * Removes all scrollbar instances from current document
     */ SmoothScrollbar.destroyAll = function() {
        (0, $0237c2acd2d653a0$export$18a24ca5e48929da).forEach(function(scrollbar) {
            scrollbar.destroy();
        });
    };
    /**
     * Attaches plugins to scrollbars
     *
     * @param ...Plugins Scrollbar plugin classes
     */ SmoothScrollbar.use = function() {
        var Plugins = [];
        for(var _i = 0; _i < arguments.length; _i++)Plugins[_i] = arguments[_i];
        return (0, $35c3ee4c1655e1df$export$19ec5365ea6ce8cf).apply(void 0, Plugins);
    };
    /**
     * Attaches default style sheets to current document.
     * You don't need to call this method manually unless
     * you removed the default styles via `Scrollbar.detachStyle()`
     */ SmoothScrollbar.attachStyle = function() {
        return (0, $2cc45d62e0cf32da$export$ff76c51b0f744e0a)();
    };
    /**
     * Removes default styles from current document.
     * Use this method when you want to use your own css for scrollbars.
     */ SmoothScrollbar.detachStyle = function() {
        return (0, $2cc45d62e0cf32da$export$11939e4e3dfbbb72)();
    };
    SmoothScrollbar.version = "8.8.4";
    SmoothScrollbar.ScrollbarPlugin = (0, $35c3ee4c1655e1df$export$db53f857c251fca3);
    return SmoothScrollbar;
}((0, $0237c2acd2d653a0$export$9a4e88b92edfce6b));
var $9dc7e4d744fa4d38$export$2e2bcd8739ae039 = $9dc7e4d744fa4d38$var$SmoothScrollbar;


window.scrollInitFunc = function scrollInitFunc1() {
    if (document.querySelector('[data-scroll]')) {
        const scrollElArr = document.querySelectorAll('[data-scroll]');
        scrollElArr.forEach((el)=>{
            if (!el.classList.contains('is-scroll-init')) {
                el.classList.add('is-scroll-init');
                const startScrollWidth = parseInt(el.getAttribute('data-start-scroll'), 10);
                if (!startScrollWidth || window.innerWidth <= startScrollWidth) {
                    const scrollbar = (0, $9dc7e4d744fa4d38$export$2e2bcd8739ae039).init(el, {
                        alwaysShowTracks: true,
                        damping: 0.1,
                        renderByPixels: true
                    });
                    scrollbar.addListener(({ offset: offset })=>{
                        if (offset.x !== 0) scrollbar.setPosition(0, offset.y);
                    });
                }
            }
        });
    }
};
scrollInitFunc();


var $05e3867a14f28447$var$t = function() {
    return $05e3867a14f28447$var$t = Object.assign || function(t) {
        for(var i, n = 1, s = arguments.length; n < s; n++)for(var a in i = arguments[n])Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
        return t;
    }, $05e3867a14f28447$var$t.apply(this, arguments);
}, $05e3867a14f28447$export$1567cc001e3d0c1d = function() {
    function i(i, n, s) {
        var a = this;
        this.endVal = n, this.options = s, this.version = "2.8.0", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200,
            scrollSpyOnce: !1
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(t) {
            a.startTime || (a.startTime = t);
            var i = t - a.startTime;
            a.remaining = a.duration - i, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(i, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(i, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (i / a.duration);
            var n = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
            a.frameVal = n ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), i < a.duration ? a.rAF = requestAnimationFrame(a.count) : null !== a.finalEndVal ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
        }, this.formatNumber = function(t) {
            var i, n, s, e, o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(a.options.decimalPlaces);
            var r = (i += "").split(".");
            if (n = r[0], s = r.length > 1 ? a.options.decimal + r[1] : "", a.options.useGrouping) {
                e = "";
                for(var l = 3, h = 0, u = 0, p = n.length; u < p; ++u)a.options.useIndianSeparators && 4 === u && (l = 2, h = 1), 0 !== u && h % l == 0 && (e = a.options.separator + e), h++, e = n[p - u - 1] + e;
                n = e;
            }
            return a.options.numerals && a.options.numerals.length && (n = n.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            })), o + a.options.prefix + n + s + a.options.suffix;
        }, this.easeOutExpo = function(t, i, n, s) {
            return n * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
        }, this.options = $05e3867a14f28447$var$t($05e3867a14f28447$var$t({}, this.defaults), s), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(n), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el = "string" == typeof i ? document.getElementById(i) : i, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.enableScrollSpy && (this.error ? console.error(this.error, i) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
            return a.handleScroll(a);
        }), window.onscroll = function() {
            window.onScrollFns.forEach(function(t) {
                return t();
            });
        }, this.handleScroll(this)));
    }
    return i.prototype.handleScroll = function(t) {
        if (t && window && !t.once) {
            var i = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), s = n.top + window.pageYOffset, a = n.top + n.height + window.pageYOffset;
            a < i && a > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
                return t.start();
            }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > a || s > i) && !t.paused && t.reset();
        }
    }, i.prototype.determineDirectionAndSmartEasing = function() {
        var t = this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > t;
        var i = t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var n = this.countDown ? 1 : -1;
            this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = t, this.finalEndVal = null;
        null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, i.prototype.start = function(t) {
        this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, i.prototype.pauseResume = function() {
        this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, i.prototype.reset = function() {
        cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, i.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, i.prototype.printValue = function(t) {
        var i;
        if (this.el) {
            var n = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, n);
            else if ("INPUT" === this.el.tagName) this.el.value = n;
            else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = n : this.el.innerHTML = n;
        }
    }, i.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, i.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, i.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, i;
}();


let $4f5e25340686dc37$var$countUpId = 1;
let $4f5e25340686dc37$var$contCountUpId = 1;
/**
 * Init CountUp (default behaviour, supports ajax)
 */ window.initCountUp = function initCountUp1(container = document) {
    const counts = Array.from(container.querySelectorAll('.count-up:not(.is-count-init)'));
    if (!counts.length) return;
    const defaultOptions = {
        separator: '.',
        enableScrollSpy: true,
        scrollSpyRunOnce: true
    };
    counts.forEach((count)=>{
        count.classList.add('is-count-init');
        const value = parseFloat(count.textContent.replace(',', '.'));
        if (isNaN(value)) return;
        const id = `count-up-${$4f5e25340686dc37$var$countUpId++}`;
        count.id = id;
        const optionsFromDataAttr = {
            ...count.dataset
        };
        for(const key in optionsFromDataAttr)if (optionsFromDataAttr[key] === '') optionsFromDataAttr[key] = true;
        const decimalPlaces = count.textContent.split('.')[1]?.length || 0;
        count._countUpInstance = new (0, $05e3867a14f28447$export$1567cc001e3d0c1d)(id, value, Object.assign({}, defaultOptions, optionsFromDataAttr, {
            decimalPlaces: decimalPlaces
        }));
    });
};
/**
 * Force restart animation
 */ window.restartCountUp = function restartCountUp(container = document) {
    const counts = Array.from(container.querySelectorAll('.count-up.is-count-init'));
    if (!counts.length) return;
    counts.forEach((count)=>{
        const instance = count._countUpInstance;
        if (!instance) return;
        instance.reset();
        instance.start();
    });
};
/**
 * Container-based observer
 * запускает ВСЕ count-up внутри контейнера
 */ window.initContainerCountUp = function initContainerCountUp({ container: container, root: root = null, rootMargin: rootMargin = '0px', threshold: threshold = 0.3, runOnce: runOnce = true }) {
    const containerEl = typeof container === 'string' ? document.querySelector(container) : container;
    if (!containerEl) return;
    if (containerEl._contCountUpObserverInit) return;
    containerEl._contCountUpObserverInit = true;
    const runCountUp = ()=>{
        const items = Array.from(containerEl.querySelectorAll('.cont-count-up:not(.is-cont-count-init)'));
        if (!items.length) return;
        items.forEach((item)=>{
            item.classList.add('is-cont-count-init');
            const value = parseFloat(item.textContent.replace(',', '.'));
            if (isNaN(value)) return;
            const id = `cont-count-up-${$4f5e25340686dc37$var$contCountUpId++}`;
            item.id = id;
            const optionsFromDataAttr = {
                ...item.dataset
            };
            for(const key in optionsFromDataAttr)if (optionsFromDataAttr[key] === '') optionsFromDataAttr[key] = true;
            const decimalPlaces = item.textContent.split('.')[1]?.length || 0;
            item._contCountUpInstance = new (0, $05e3867a14f28447$export$1567cc001e3d0c1d)(id, value, Object.assign({}, optionsFromDataAttr, {
                decimalPlaces: decimalPlaces
            }));
            item._contCountUpInstance.start();
        });
    };
    const rect = containerEl.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (isVisible) {
        runCountUp();
        return;
    }
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            runCountUp();
            if (runOnce) observer.unobserve(containerEl);
        });
    }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold
    });
    observer.observe(containerEl);
};
initCountUp();


(0, (/*@__PURE__*/$parcel$interopDefault($2b1a091b652cef0d$exports))).init({
    offset: 50,
    delay: 10,
    duration: 600,
    easing: 'ease-in-out',
    once: true,
    startEvent: 'DOMContentLoaded'
});
const $0c5444ba1638078b$var$isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if ($0c5444ba1638078b$var$isSafari) document.body.classList.add('is-safari');


//# sourceMappingURL=scripts.0db5f766.js.map
